import { c as Ma, e as Ia, a as La, b as Fa, g as Pa } from "./libs/config-countries-df62edb9.js";
import { m as _e, p as Oa, u as Se, e as Ht, g as je, s as Rt, h as Ea, o as _a, i as Na, j as $e, l as Je, n as za, _ as Ba, S as Va, q as Be, v as Ha, w as qt, t as Ra, x as Ve, y as Wt, z as jt, A as qa, B as Wa } from "./vendor-dcffe3e4.js";
import { inject as xe, defineComponent as _, openBlock as l, createElementBlock as g, normalizeClass as I, renderSlot as N, createStaticVNode as bt, normalizeStyle as le, createBlock as P, mergeModels as Fe, useModel as vt, watch as K, useSlots as yt, computed as T, resolveComponent as pe, mergeProps as he, createSlots as Oe, withCtx as A, createVNode as L, renderList as J, normalizeProps as kt, guardReactiveProps as wt, ref as D, toRef as ce, onMounted as ne, resolveDynamicComponent as de, unref as u, Fragment as Y, withKeys as fe, withModifiers as ie, createCommentVNode as E, createElementVNode as c, toDisplayString as H, createTextVNode as X, reactive as Yt, nextTick as ja, onBeforeUnmount as Ce, Teleport as Ge, TransitionGroup as Kt, onBeforeMount as Ut, Transition as xt, pushScopeId as De, popScopeId as Ae, provide as we, onUnmounted as Ee, defineAsyncComponent as ue, withDirectives as Jt, vShow as Gt, isRef as Ya, mergeDefaults as St } from "vue";
import { F as Ka, g as Lt, t as Ua, a as Ja, c as Ga } from "./vendor/formkit-7479af46.js";
import { useI18n as Qa } from "vue-i18n";
import { u as Qt, w as $t, a as Ie, b as Xa, o as gt, c as Za, d as eo, e as to, f as ao, g as oo, h as no, i as so, T as io, j as Xt, k as lo, l as ro } from "./vendor/vueuse-c06f1965.js";
import { _ as ee } from "./vendor/emoji-mart-vue-fast-aef1105d.js";
import { Image as Pe } from "@unpic/vue";
import { getDaysInMonth as Ct, endOfWeek as uo, isAfter as He, isSameDay as me, isBefore as Dt, isSameMonth as tt, isSameYear as at, differenceInCalendarMonths as Ft, addMonths as Pt, addYears as Ye, format as Me, parse as ot, isValid as Ot } from "date-fns";
import { C as oe, r as Qe } from "./vendor/chartjs-7f52c419.js";
import { h as co } from "./vendor/html2canvas-8aceeec1.js";
import { I as mo, M as po, u as go, g as Et, S as nt, L as st, H as fo, m as ho, T as it, C as lt, a as rt, b as dt, V as bo, E as _t } from "./vendor/tiptap-ff94818f.js";
import { g as vo, a as yo, b as ko, A as wo, i as xo } from "./vendor/libphonenumberjs-dba064a0.js";
const So = "Activity", $o = "April", Co = "August", Do = "Copy", Ao = "Custom", To = "December", Mo = "February", Io = "Flags", Lo = "Foods", Fo = "January", Po = "July", Oo = "June", Eo = "March", _o = "May", No = "Nature", zo = "November", Bo = "Objects", Vo = "October", Ho = "People", Ro = "Phone", qo = "Places", Wo = "Preview", jo = "Save", Yo = "Search", Ko = "September", Uo = "Show", Jo = "Smileys", Go = "Symbols", Qo = "Apply", Xo = "Cancel", Zo = "Clear", en = "Elements", tn = "Move", an = "Tomorrow", on = "Yesterday", nn = {
  Activity: So,
  "Add file": "Add file",
  "An error occurred, but we have not been able to identify it. Try reloading the page or if the error persists, contact us": "An error occurred, but we have not been able to identify it. Try reloading the page or if the error persists, contact us",
  "An error ocurred, but we have not been able to identify it. Try reloading the page or if the error persist contact us": "An error ocurred, but we have not been able to identify it. Try reloading the page or if the error persist contact us",
  April: $o,
  August: Co,
  "Copied!": "Copied!",
  Copy: Do,
  Custom: Ao,
  Date: "Date",
  "Date Abbreviation Short Day": "d",
  "Date Abbreviation Short Month": "m",
  "Date Abbreviation Short Year": "y",
  December: To,
  "Download QR": "Download QR",
  "Drag and drop <span class='text-primary-300'>your files</span> here": "Drag and drop <span class='text-primary-300'>your files</span> here",
  February: Mo,
  "First page": "First page",
  Flags: Io,
  Foods: Lo,
  "Frequently Used": "Frequently Used",
  "Go to page": "Go to page",
  "Heading {n}": "Heading {n}",
  "Image URL": "Image URL",
  "Image preview": "Image preview",
  January: Fo,
  July: Po,
  June: Oo,
  "Last page": "Last page",
  March: Eo,
  "Max file size": "Max file size",
  May: _o,
  Nature: No,
  "Next page": "Next page",
  "No Emoji Found": "No Emoji Found",
  "No available data": "No available data",
  "No data": "No data",
  "No matching results with: {searchTerm}": "No matching results with: {searchTerm}",
  November: zo,
  Objects: Bo,
  October: Vo,
  "Or <span class='text-primary-300 underline cursor-pointer'>browse</span> files in your computer": "Or <span class='text-primary-300 underline cursor-pointer'>browse</span> files in your computer",
  People: Ho,
  Phone: Ro,
  Places: qo,
  Preview: Wo,
  "Previous page": "Previous page",
  Save: jo,
  Search: Yo,
  "Search country name or code": "Search country name or code",
  "Search results": "Search results",
  "Select all": "Select all",
  "Select country phone code": "Select country phone code",
  September: Ko,
  Show: Uo,
  "Showing {0}-{1} of {2}": "Showing {0}-{1} of {2}",
  Smileys: Jo,
  "Success! All went right": "Success! All went right",
  Symbols: Go,
  "The phone number you entered is invalid": "The phone number you entered is invalid",
  "The specified date is not valid": "The specified date is not valid",
  "The specified date is outside the allowed range": "The specified date is outside the allowed range",
  "There is no available data matching your current request. Try refreshing or maybe there's nothing to show": "There is no available data matching your current request. Try refreshing or maybe there's nothing to show",
  "There is no available data matching your current request. Try refreshing the page": "There is no available data matching your current request. Try refreshing the page",
  "This might be of your interest": "This might be of your interest",
  "Weekday Abbreviation Short Friday": "F",
  "Weekday Abbreviation Short Monday": "M",
  "Weekday Abbreviation Short Saturday": "S",
  "Weekday Abbreviation Short Sunday": "S",
  "Weekday Abbreviation Short Thursday": "T",
  "Weekday Abbreviation Short Tuesday": "T",
  "Weekday Abbreviation Short Wednesday": "W",
  "Woops! Something went wrong...": "Woops! Something went wrong...",
  "You should bear this in mind": "You should bear this in mind",
  "Your current operation has been successfully completed": "Your current operation has been successfully completed",
  "{current}/{limit} characters": "{current}/{limit} characters",
  "An error happened and we have not been able to show more results, please use try again button or reload this page": "An error happened and we have not been able to show more results, please use try again button or reload this page",
  Apply: Qo,
  Cancel: Xo,
  Clear: Zo,
  "Did you know?": "Did you know?",
  "Drag and drop <span class='text-primary-300'>your file</span> here": "Drag and drop <span class='text-primary-300'>your file</span> here",
  "Drag and drop <span class='text-primary-300'>your image</span> here": "Drag and drop <span class='text-primary-300'>your image</span> here",
  "Drop rows here to move them to a row not shown on this page": "Drop rows here to move them to a row not shown on this page",
  Elements: en,
  "Just Now": "Just Now",
  "Last Month": "Last Month",
  "Last Week": "Last Week",
  "Last Year": "Last Year",
  "Last available row is {n}": "Last available row is {n}",
  "Load more": "Load more",
  Move: tn,
  "Next Month": "Next Month",
  "Next Week": "Next Week",
  "Next Year": "Next Year",
  "Oops!": "Oops!",
  "Or <span class='text-primary-300 underline cursor-pointer'>browse</span> files in your device": "Or <span class='text-primary-300 underline cursor-pointer'>browse</span> files in your device",
  "Or <span class='text-primary-300 underline cursor-pointer'>browse</span> images in your device": "Or <span class='text-primary-300 underline cursor-pointer'>browse</span> images in your device",
  "Something went wrong!": "Something went wrong!",
  "Success!": "Success!",
  "Time Ago Day": "Days| Day | Days",
  "Time Ago Future": "In {0}",
  "Time Ago Hour": "Hours | Hour | Hours",
  "Time Ago Minute": "Minutes | Minute | Minutes",
  "Time Ago Month": "Months | Month | Months",
  "Time Ago Past": "{0} Ago",
  "Time Ago Second": "Seconds | Second | Seconds",
  "Time Ago Week": "Weeks | Week | Weeks",
  "Time Ago Year": "Years| Year | Years",
  Tomorrow: an,
  "Try again": "Try again",
  "Warning!": "Warning!",
  Yesterday: on,
  "You cannot use zero or negative values": "You cannot use zero or negative values",
  "You have seen <strong>{seen}</strong> of <strong>{total}</strong> {kindOfElement}": "You have seen <strong>{seen}</strong> of <strong>{total}</strong> {kindOfElement}",
  "Max: {totalItems}": "Max: {totalItems}",
  "Move element from row {originalPosition} to:": "Move element from row {originalPosition} to:",
  "Edit columns": "Edit columns",
  "Error uploading the image - File may be too large": "Error uploading the image - File may be too large"
}, sn = "Actividad", ln = "Abril", rn = "Agosto", dn = "Copiar", un = "Personalizado", cn = "Diciembre", mn = "Febrero", pn = "Banderas", gn = "Comidas", fn = "Enero", hn = "Julio", bn = "Junio", vn = "Marzo", yn = "Mayo", kn = "Naturaleza", wn = "Noviembre", xn = "Objetos", Sn = "Octubre", $n = "Personas", Cn = "Teléfono", Dn = "Lugares", An = "Previsualización", Tn = "Guardar", Mn = "Buscar", In = "Septiembre", Ln = "Mostrar", Fn = "Caritas sonrientes", Pn = "Símbolos", On = "Aplicar", En = "Cancelar", _n = "Borrar", Nn = "Elementos", zn = "Mover", Bn = "Mañana", Vn = "Ayer", Hn = {
  Activity: sn,
  "Add file": "Agregar archivo",
  "An error occurred, but we have not been able to identify it. Try reloading the page or if the error persists, contact us": "Se produjo un error, pero no hemos podido identificarlo. Intenta recargar la página o, si el error persiste, contáctanos",
  "An error ocurred, but we have not been able to identify it. Try reloading the page or if the error persist contact us": "Se ha producido un error, pero no hemos podido identificarlo. Intenta recargar la página o, si el error persiste, contáctanos",
  April: ln,
  August: rn,
  "Copied!": "¡Copiado!",
  Copy: dn,
  Custom: un,
  Date: "Fecha",
  "Date Abbreviation Short Day": "d",
  "Date Abbreviation Short Month": "m",
  "Date Abbreviation Short Year": "a",
  December: cn,
  "Download QR": "Descargar QR",
  "Drag and drop <span class='text-primary-300'>your files</span> here": "Arrastra y suelta <span class='text-primary-300'>tus archivos</span> aquí",
  February: mn,
  "First page": "Primera página",
  Flags: pn,
  Foods: gn,
  "Frequently Used": "Usado con frecuencia",
  "Go to page": "Ir a la página",
  "Heading {n}": "Encabezado {n}",
  "Image URL": "URL de la imagen",
  "Image preview": "Vista previa de la imagen",
  January: fn,
  July: hn,
  June: bn,
  "Last page": "Última página",
  March: vn,
  "Max file size": "Tamaño máximo del archivo",
  May: yn,
  Nature: kn,
  "Next page": "Siguiente página",
  "No Emoji Found": "No se encontraron emojis",
  "No available data": "Sin datos disponibles",
  "No data": "Sin datos",
  "No matching results with: {searchTerm}": "No hay resultados que coincidan con: {searchTerm}",
  November: wn,
  Objects: xn,
  October: Sn,
  "Or <span class='text-primary-300 underline cursor-pointer'>browse</span> files in your computer": "O <span class='text-primary-300 underline cursor-pointer'>explora</span> archivos en tu ordenador",
  People: $n,
  Phone: Cn,
  Places: Dn,
  Preview: An,
  "Previous page": "Página anterior",
  Save: Tn,
  Search: Mn,
  "Search country name or code": "Buscar nombre de país o código",
  "Search results": "Resultados de la búsqueda",
  "Select all": "Seleccionar todos",
  "Select country phone code": "Selecciona el código telefónico del país",
  September: In,
  Show: Ln,
  "Showing {0}-{1} of {2}": "Mostrando {0}-{1} de {2}",
  Smileys: Fn,
  "Success! All went right": "¡Bien! Todo ha ido correcto",
  Symbols: Pn,
  "The phone number you entered is invalid": "El número de teléfono que ingresaste no es válido",
  "The specified date is not valid": "La fecha especificada no es válida",
  "The specified date is outside the allowed range": "La fecha especificada está fuera del rango permitido",
  "There is no available data matching your current request. Try refreshing or maybe there's nothing to show": "No hay datos disponibles que coincidan con tu solicitud actual. Intenta refrescar la página o quizá no haya nada que mostrar",
  "There is no available data matching your current request. Try refreshing the page": "No hay información que coincida con tu petición actual. Prueba a refrescar la página",
  "This might be of your interest": "Esto podría interesarte",
  "Weekday Abbreviation Short Friday": "V",
  "Weekday Abbreviation Short Monday": "L",
  "Weekday Abbreviation Short Saturday": "S",
  "Weekday Abbreviation Short Sunday": "D",
  "Weekday Abbreviation Short Thursday": "J",
  "Weekday Abbreviation Short Tuesday": "M",
  "Weekday Abbreviation Short Wednesday": "X",
  "Woops! Something went wrong...": "¡Vaya! Algo salió mal...",
  "You should bear this in mind": "Deberías tener esto en cuenta",
  "Your current operation has been successfully completed": "Tu operación actual se ha completado satisfactoriamente",
  "{current}/{limit} characters": "{current}/{limit} caracteres",
  "An error happened and we have not been able to show more results, please use try again button or reload this page": "Ha ocurrido un error y no hemos podido mostrar más resultados, por favor usa el botón de Probar otra vez o recarga la página",
  Apply: On,
  Cancel: En,
  Clear: _n,
  "Did you know?": "¿Sabías que?",
  "Drag and drop <span class='text-primary-300'>your file</span> here": "Arrastra y suelta <span class='text-primary-300'>tu archivo</span> aquí",
  "Drag and drop <span class='text-primary-300'>your image</span> here": "Arrastra y suelta <span class='text-primary-300'>tu imagen</span> aquí",
  "Drop rows here to move them to a row not shown on this page": "Suelta las filas aquí para moverlas a una fila que no se muestra en esta página",
  Elements: Nn,
  "Just Now": "Ahora",
  "Last Month": "El mes pasado",
  "Last Week": "La semana pasada",
  "Last Year": "El año pasado",
  "Last available row is {n}": "La última fila disponible es {n}",
  "Load more": "Cargar más",
  Move: zn,
  "Next Month": "El próximo mes",
  "Next Week": "La próxima semana",
  "Next Year": "El próximo año",
  "Oops!": "¡Vaya!",
  "Or <span class='text-primary-300 underline cursor-pointer'>browse</span> files in your device": "O <span class='text-primary-300 underline cursor-pointer'>explora</span> archivos en tu dispositivo",
  "Or <span class='text-primary-300 underline cursor-pointer'>browse</span> images in your device": "O <span class='text-primary-300 underline cursor-pointer'>explora</span> imágenes en tu dispositivo",
  "Something went wrong!": "¡Algo salió mal!",
  "Success!": "¡Listo!",
  "Time Ago Day": "días | día | días",
  "Time Ago Future": "En {0}",
  "Time Ago Hour": "horas | hora | horas",
  "Time Ago Minute": "minutos | minuto | minutos",
  "Time Ago Month": "meses | mes | meses",
  "Time Ago Past": "Hace {0}",
  "Time Ago Second": "segundos | segundo | segundos",
  "Time Ago Week": "semanas | semana | semanas",
  "Time Ago Year": "años | año | años",
  Tomorrow: Bn,
  "Try again": "Probar otra vez",
  "Warning!": "¡Atención!",
  Yesterday: Vn,
  "You cannot use zero or negative values": "No puedes usar valores negativos o cero",
  "You have seen <strong>{seen}</strong> of <strong>{total}</strong> {kindOfElement}": "Has visto <strong>{seen}</strong> de <strong>{total}</strong> {kindOfElement}",
  "Max: {totalItems}": "Máx: {totalItems}",
  "Move element from row {originalPosition} to:": "Mover el elemento de la fila {originalPosition} a:",
  "Edit columns": "Editar columnas",
  "Error uploading the image - File may be too large": "Error al cargar la imagen - El archivo puede ser demasiado grande"
}, Rn = "Ekintza", qn = "Aplikatu", Wn = "Apiril", jn = "Abuztu", Yn = "Utzi", Kn = "Ezabatu", Un = "Kopiatu", Jn = "Pertsonalizatua", Gn = "Abendu", Qn = "Elementuak", Xn = "Otsail", Zn = "Banderak", es = "Elikagaiak", ts = "Urtarrila", as = "Uztaila", os = "Ekaina", ns = "Martxoa", ss = "Maiatza", is = "Mugitu", ls = "Natura", rs = "Azaroa", ds = "Objektuak", us = "Urria", cs = "Jendea", ms = "Telefonoa", ps = "Lekuak", gs = "Aurrebista", fs = "Gorde", hs = "Bilatu", bs = "Iraila", vs = "Erakutsi", ys = "Igarteko irudiak", ks = "Sinboloak", ws = "Bihar", xs = "Atzo", Ss = {
  Activity: Rn,
  "Add file": "Gehitu fitxategia",
  "An error happened and we have not been able to show more results, please use try again button or reload this page": "Akats bat gertatu da eta ezin izan dugu emaitza gehiago erakutsi. Mesedez, erabili berriro botoia edo kargatu orri hau",
  "An error occurred, but we have not been able to identify it. Try reloading the page or if the error persists, contact us": "Errorea gertatu da, baina ez dugu identifikatu. Saiatu orriari berriz kargatzen edo errorea jarraitzen badu, gurekin harremanetan jarri",
  "An error ocurred, but we have not been able to identify it. Try reloading the page or if the error persist contact us": "Errorea gertatu da, baina ez dugu identifikatu ahal izan. Saiatu orriari berriro kargatzen edo errorea iraun egiten badu, gurekin harremanetan jarri",
  Apply: qn,
  April: Wn,
  August: jn,
  Cancel: Yn,
  Clear: Kn,
  "Copied!": "Kopiatuta!",
  Copy: Un,
  Custom: Jn,
  Date: "Data",
  "Date Abbreviation Short Day": "e",
  "Date Abbreviation Short Month": "h",
  "Date Abbreviation Short Year": "u",
  December: Gn,
  "Did you know?": "Bazenekien?",
  "Download QR": "Deskargatu QR",
  "Drag and drop <span class='text-primary-300'>your file</span> here": "Arrastatu eta botatu <span class='text-primary-300'>zure fitxategia</span> hemen",
  "Drag and drop <span class='text-primary-300'>your files</span> here": "Arrastatu eta botatu <span class='text-primary-300'>zure fitxategiak</span> hemen",
  "Drag and drop <span class='text-primary-300'>your image</span> here": "Arrastatu eta botatu <span class='text-primary-300'>zure irudia</span> hemen",
  "Drop rows here to move them to a row not shown on this page": "Bota hemen errenkadak orri honetan erakusten ez den errenkadara mugitzeko",
  "Edit columns": "Editatu zutabeak",
  Elements: Qn,
  February: Xn,
  "First page": "Lehen orrialdea",
  Flags: Zn,
  Foods: es,
  "Frequently Used": "Ohiko erabilpena",
  "Go to page": "Go to page",
  "Heading {n}": "Hasieran {n}",
  "Image URL": "Irudiaren URLa",
  "Image preview": "Irudiaren aurrebista",
  January: ts,
  July: as,
  June: os,
  "Just Now": "Orain",
  "Last Month": "Irailean",
  "Last Week": "Aste pasa",
  "Last Year": "Iaz",
  "Last available row is {n}": "Eskuragarri dagoen azken errenkada {n} da",
  "Last page": "Azken orrialdea",
  "Load more": "Kargatu gehiago",
  March: ns,
  "Max file size": "Fitxategiaren gehienezko tamaina",
  "Max: {totalItems}": "Máx: {totalItems}",
  May: ss,
  Move: is,
  "Move element from row {originalPosition} to:": "Mugitu {originalPosition} errenkadako elementua honetara:",
  Nature: ls,
  "Next Month": "Hurrengo hilabetean",
  "Next Week": "Hurrengo astean",
  "Next Year": "Hurrengo urtean",
  "Next page": "Hurrengo orrialdea",
  "No Emoji Found": "Ez da Emoji aurkitu",
  "No available data": "Datu eskuragarririk gabe",
  "No data": "Daturik gabe",
  "No matching results with: {searchTerm}": "Ez datoz bat emaitza hauek: {searchTerm}",
  November: rs,
  Objects: ds,
  October: us,
  "Oops!": "Hara!",
  "Or <span class='text-primary-300 underline cursor-pointer'>browse</span> files in your computer": "Edo <span class='text-primary-300 underline cursor-pointer'>nabigatu</span> zure ordenagailuan",
  "Or <span class='text-primary-300 underline cursor-pointer'>browse</span> files in your device": "Edo <span class='text-primary-300 underline cursor-pointer'>nabigatu</span> fitxategiak zure gailuan",
  "Or <span class='text-primary-300 underline cursor-pointer'>browse</span> images in your device": "Edo <span class='text-primary-300 underline cursor-pointer'>nabigatu</span> irudiak zure gailuan",
  People: cs,
  Phone: ms,
  Places: ps,
  Preview: gs,
  "Previous page": "Previous page",
  Save: fs,
  Search: hs,
  "Search country name or code": "Herrialdearen izena edo kodea bilatu",
  "Search results": "Bilaketaren emaitzak",
  "Select all": "Hautatu guztiak",
  "Select country phone code": "Aukeratu herrialdearen telefono-kodea",
  September: bs,
  Show: vs,
  "Showing {0}-{1} of {2}": "Showing {0}-{1} of {2}",
  Smileys: ys,
  "Something went wrong!": "Zerbait gaizki joan da!",
  "Success!": "Prest!",
  "Success! All went right": "Arrakasta! Guztia zuzen joan da",
  Symbols: ks,
  "The phone number you entered is invalid": "Sartu duzun telefono zenbakia baliogabea da",
  "The specified date is not valid": "Zehaztutako data ez da baliozkoa",
  "The specified date is outside the allowed range": "Zehaztutako data baimendutako tartetik kanpo dago",
  "There is no available data matching your current request. Try refreshing or maybe there's nothing to show": "Ez dago zure eskaerarekin bat datorren daturik. Saiatu freskatzen edo agian ez dago ezer erakusteko",
  "There is no available data matching your current request. Try refreshing the page": "Ez dago zure egungo eskaerarekin bat datorren informaziorik. Orria freskatzeko proba",
  "This might be of your interest": "Zure interesean izan daiteke hau",
  "Time Ago Day": "egunak | egun | egunak",
  "Time Ago Future": "{0} barru",
  "Time Ago Hour": "orduak | ordu | orduak",
  "Time Ago Minute": "minutuak | minutu | minutuak",
  "Time Ago Month": "{0} hilabete",
  "Time Ago Past": "Duela {0}",
  "Time Ago Second": "segundoak | segundo | segundoak",
  "Time Ago Week": "asteak | aste | asteak",
  "Time Ago Year": "urteak | urte | urteak",
  Tomorrow: ws,
  "Try again": "Saiatu berriro",
  "Warning!": "Adi!",
  "Weekday Abbreviation Short Friday": "Or",
  "Weekday Abbreviation Short Monday": "Al",
  "Weekday Abbreviation Short Saturday": "L",
  "Weekday Abbreviation Short Sunday": "I",
  "Weekday Abbreviation Short Thursday": "Og",
  "Weekday Abbreviation Short Tuesday": "Ar",
  "Weekday Abbreviation Short Wednesday": "Az",
  "Woops! Something went wrong...": "Ai zerbitzua! Zerbait gaizki joan da...",
  Yesterday: xs,
  "You cannot use zero or negative values": "Ezin dituzu zero edo balio negatiboak erabili",
  "You have seen <strong>{seen}</strong> of <strong>{total}</strong> {kindOfElement}": "<strong>{total}</strong> {kindOfElement} -etik <strong>{seen}</strong> ikusi dituzu",
  "You should bear this in mind": "Gogoratu beharko zenioke hau",
  "Your current operation has been successfully completed": "Zure uneko eragiketa arrakastatsuan amaitu da",
  "{current}/{limit} characters": "{current}/{limit} karaktereak",
  "Error uploading the image - File may be too large": "Errorea irudia kargatzean - Fitxategia handiegia izan daiteke"
}, $s = "Activitat", Cs = "Aplicar", Ds = "Abril", As = "Agost", Ts = "Cancelar", Ms = "Esborrar", Is = "Copia", Ls = "Personalitzat", Fs = "Desembre", Ps = "Elements", Os = "Febrer", Es = "Banderes", _s = "Aliments", Ns = "Gener", zs = "Juliol", Bs = "Juny", Vs = "Març", Hs = "Maig", Rs = "Moure", qs = "Naturalesa", Ws = "Novembre", js = "Objectes", Ys = "Octubre", Ks = "Gent", Us = "Telèfon", Js = "Llocs", Gs = "Previsualització", Qs = "Desa", Xs = "Cerca", Zs = "Setembre", ei = "Mostra", ti = "Emoticones", ai = "Símbols", oi = "Demà", ni = "Ahir", si = {
  Activity: $s,
  "Add file": "Afegeix un fitxer",
  "An error happened and we have not been able to show more results, please use try again button or reload this page": "S'ha produït un error i no s'han pogut mostrar més resultats. Utilitzeu el botó Torna-ho a provar o torneu a carregar aquesta pàgina",
  "An error occurred, but we have not been able to identify it. Try reloading the page or if the error persists, contact us": "S'ha produït un error, però no hem pogut identificar-lo. Prova de tornar a carregar la pàgina o si l'error persisteix, contacta-nos",
  "An error ocurred, but we have not been able to identify it. Try reloading the page or if the error persist contact us": "S'ha produït un error, però no hem pogut identificar-lo. Prova de tornar a carregar la pàgina o si l'error persisteix, contacta-nos",
  Apply: Cs,
  April: Ds,
  August: As,
  Cancel: Ts,
  Clear: Ms,
  "Copied!": "¡Copiat!",
  Copy: Is,
  Custom: Ls,
  Date: "Data",
  "Date Abbreviation Short Day": "d",
  "Date Abbreviation Short Month": "m",
  "Date Abbreviation Short Year": "a",
  December: Fs,
  "Did you know?": "¿Sàvies què?",
  "Download QR": "Descarregar QR",
  "Drag and drop <span class='text-primary-300'>your file</span> here": "Arrossegueu i solta <span class='text-primary-300'>el teu fitxer</span> aquí",
  "Drag and drop <span class='text-primary-300'>your files</span> here": "Arrossegueu i solta <span class='text-primary-300'>els vostres fitxers</span> aquí",
  "Drag and drop <span class='text-primary-300'>your image</span> here": "Arrossegueu i solta <span class='text-primary-300'>la teva imatge</span> aquí",
  "Drop rows here to move them to a row not shown on this page": "Deixa les files aquí per moure-les a una fila que no es mostra en aquesta pàgina",
  "Edit columns": "Edita les columnes",
  Elements: Ps,
  February: Os,
  "First page": "Primera pàgina",
  Flags: Es,
  Foods: _s,
  "Frequently Used": "Utilitzat amb freqüència",
  "Go to page": "Ves a la pàgina",
  "Heading {n}": "Encapçalament {n}",
  "Image URL": "URL de la imatge",
  "Image preview": "Previsualització de imatge",
  January: Ns,
  July: zs,
  June: Bs,
  "Just Now": "Ara",
  "Last Month": "El mes passat",
  "Last Week": "La setmana passada",
  "Last Year": "L'any passat",
  "Last available row is {n}": "L'última fila disponible és {n}",
  "Last page": "Última pàgina",
  "Load more": "Carregar més",
  March: Vs,
  "Max file size": "Mida màxima del fitxer",
  "Max: {totalItems}": "Màx: {totalItems}",
  May: Hs,
  Move: Rs,
  "Move element from row {originalPosition} to:": "Mou l'element de la fila {originalPosition} a:",
  Nature: qs,
  "Next Month": "El pròxim mes",
  "Next Week": "La propera setmana",
  "Next Year": "L'any que ve",
  "Next page": "Pàgina següent",
  "No Emoji Found": "No s'ha trobat cap emoji",
  "No available data": "No hi ha dades disponibles",
  "No data": "Sense dades",
  "No matching results with: {searchTerm}": "No hi ha resultats coincidents amb: {searchTerm}",
  November: Ws,
  Objects: js,
  October: Ys,
  "Oops!": "Vaja!",
  "Or <span class='text-primary-300 underline cursor-pointer'>browse</span> files in your computer": "O <span class='text-primary-300 underline cursor-pointer'>navega per</span> fitxers al teu ordinador",
  "Or <span class='text-primary-300 underline cursor-pointer'>browse</span> files in your device": "O <span class='text-primary-300 underline cursor-pointer'>navega per</span> fitxers al teu dispositiu",
  "Or <span class='text-primary-300 underline cursor-pointer'>browse</span> images in your device": "O <span class='text-primary-300 underline cursor-pointer'>navega per</span> imatges al teu dispositiu",
  People: Ks,
  Phone: Us,
  Places: Js,
  Preview: Gs,
  "Previous page": "Pàgina anterior",
  Save: Qs,
  Search: Xs,
  "Search country name or code": "Cerca el nom del país o el codi",
  "Search results": "Cerca resultats",
  "Select all": "Selecciona-ho tot",
  "Select country phone code": "Seleccioneu el codi del telèfon del país",
  September: Zs,
  Show: ei,
  "Showing {0}-{1} of {2}": "S'està mostrant {0}-{1} de {2}",
  Smileys: ti,
  "Something went wrong!": "Alguna cosa ha anat malament!",
  "Success!": "Fet!",
  "Success! All went right": "Ben! Tot ha anat correctament",
  Symbols: ai,
  "The phone number you entered is invalid": "El número de telèfon que heu introduït no és vàlid",
  "The specified date is not valid": "La data especificada no és vàlida",
  "The specified date is outside the allowed range": "La data especificada està fora de l'interval permès",
  "There is no available data matching your current request. Try refreshing or maybe there's nothing to show": "No hi ha dades disponibles que coincideixin amb la teua sol·licitud actual. Prova d'actualitzar o potser no hi ha res a mostrar",
  "There is no available data matching your current request. Try refreshing the page": "No hi ha dades disponibles que coincideixin amb la vostra sol·licitud actual. Proveu d'actualitzar la pàgina",
  "This might be of your interest": "Això pot ser del vostre interès",
  "Time Ago Day": "dies | dia | dies",
  "Time Ago Future": "En {0}",
  "Time Ago Hour": "hores | hora | hores",
  "Time Ago Minute": "minuts | minut | minuts",
  "Time Ago Month": "{0} mesos",
  "Time Ago Past": "Fa {0}",
  "Time Ago Second": "segons | segon | segons",
  "Time Ago Week": "setmanes | setmana | setmanes",
  "Time Ago Year": "anys | any | anys",
  Tomorrow: oi,
  "Try again": "Torna a provar",
  "Warning!": "Atenció!",
  "Weekday Abbreviation Short Friday": "Dv",
  "Weekday Abbreviation Short Monday": "Dl",
  "Weekday Abbreviation Short Saturday": "Ds",
  "Weekday Abbreviation Short Sunday": "Dd",
  "Weekday Abbreviation Short Thursday": "Dj",
  "Weekday Abbreviation Short Tuesday": "Dt",
  "Weekday Abbreviation Short Wednesday": "Dc",
  "Woops! Something went wrong...": "Vaja! Alguna cosa ha anat malament...",
  Yesterday: ni,
  "You cannot use zero or negative values": "No pots utilitzar valors zero o negatius",
  "You have seen <strong>{seen}</strong> of <strong>{total}</strong> {kindOfElement}": "Has vist <strong>{seen}</strong> de <strong>{total}</strong> {kindOfElement}",
  "You should bear this in mind": "Has de tenir això en compte",
  "Your current operation has been successfully completed": "L'operació actual s'ha completat correctament",
  "{current}/{limit} characters": "{current}/{limit} caràcters",
  "Error uploading the image - File may be too large": "Error en carregar la imatge - L'arxiu pot ser massa gran"
}, ii = "Actividade", li = "Aplicar", ri = "Abril", di = "Agosto", ui = "Cancelar", ci = "Borrar", mi = "Copiar", pi = "Personalizado", gi = "Decembro", fi = "Elementos", hi = "Febreiro", bi = "Bandeiras", vi = "Alimentos", yi = "Xaneiro", ki = "Xullo", wi = "Xuño", xi = "Marzo", Si = "Maio", $i = "Mover", Ci = "Natureza", Di = "Novembro", Ai = "Objetos", Ti = "Outubro", Mi = "Persoas", Ii = "Teléfono", Li = "Lugares", Fi = "Previsualización", Pi = "Gardar", Oi = "Buscar", Ei = "Setembro", _i = "Amosar", Ni = "Emoticonos", zi = "Símbolos", Bi = "Mañá", Vi = "Onte", Hi = {
  Activity: ii,
  "Add file": "Engadir ficheiro",
  "An error happened and we have not been able to show more results, please use try again button or reload this page": "Ocorreu un erro e non puidemos amosar máis resultados, por favor usa o botón de Probar outra vez ou recarga a páxina",
  "An error occurred, but we have not been able to identify it. Try reloading the page or if the error persists, contact us": "Produciuse un erro, pero non fomos capaces de identificalo. Proba recargar a páxina ou, se o erro persiste, contacta connosco",
  "An error ocurred, but we have not been able to identify it. Try reloading the page or if the error persist contact us": "Produciuse un erro, pero non puidemos identificalo. Proba recargar a páxina ou, se o erro persiste, contacta connosco",
  Apply: li,
  April: ri,
  August: di,
  Cancel: ui,
  Clear: ci,
  "Copied!": "¡Copiado!",
  Copy: mi,
  Custom: pi,
  Date: "Data",
  "Date Abbreviation Short Day": "d",
  "Date Abbreviation Short Month": "m",
  "Date Abbreviation Short Year": "a",
  December: gi,
  "Did you know?": "¿Sabías que?",
  "Download QR": "Descargar QR",
  "Drag and drop <span class='text-primary-300'>your file</span> here": "Arrastra e solta <span class='text-primary-300'>o teu ficheiro</span> aquí",
  "Drag and drop <span class='text-primary-300'>your files</span> here": "Arrastra e solta <span class='text-primary-300'>os teus ficheiros</span> aquí",
  "Drag and drop <span class='text-primary-300'>your image</span> here": "Arrastra e solta <span class='text-primary-300'>a túa imaxe</span> aquí",
  "Drop rows here to move them to a row not shown on this page": "Solta as filas aquí para movelas a unha fila que non se amosa nesta páxina",
  "Edit columns": "Editar columnas",
  Elements: fi,
  February: hi,
  "First page": "First page",
  Flags: bi,
  Foods: vi,
  "Frequently Used": "Usado con frecuencia",
  "Go to page": "Ir á páxina",
  "Heading {n}": "Encabezado {n}",
  "Image URL": "URL da imaxe",
  "Image preview": "Vista previa da imaxe",
  January: yi,
  July: ki,
  June: wi,
  "Just Now": "Agora",
  "Last Month": "O mes pasado",
  "Last Week": "A semana pasada",
  "Last Year": "O ano pasado",
  "Last available row is {n}": "A última fila dispoñible é {n}",
  "Last page": "Última páxina",
  "Load more": "Cargar máis",
  March: xi,
  "Max file size": "Tamaño máximo do ficheiro",
  "Max: {totalItems}": "Máx: {totalItems}",
  May: Si,
  Move: $i,
  "Move element from row {originalPosition} to:": "Mover o elemento da fila {originalPosition} a:",
  Nature: Ci,
  "Next Month": "O vindeiro mes",
  "Next Week": "A vindeira semana",
  "Next Year": "O vindeiro ano",
  "Next page": "Seguinte páxina",
  "No Emoji Found": "Non se atoparon emojis",
  "No available data": "Sen datos dispoñibles",
  "No data": "Sen datos",
  "No matching results with: {searchTerm}": "Non hai resultados que coincidan con: {searchTerm}",
  November: Di,
  Objects: Ai,
  October: Ti,
  "Oops!": "Vaia!",
  "Or <span class='text-primary-300 underline cursor-pointer'>browse</span> files in your computer": "Ou <span class='text-primary-300 underline cursor-pointer'>navega</span> polos ficheiros no teu ordenador",
  "Or <span class='text-primary-300 underline cursor-pointer'>browse</span> files in your device": "Ou <span class='text-primary-300 underline cursor-pointer'>navega</span> polos ficheiros no teu dispositivo",
  "Or <span class='text-primary-300 underline cursor-pointer'>browse</span> images in your device": "Ou <span class='text-primary-300 underline cursor-pointer'>navega</span> polas imaxes no teu dispositivo",
  People: Mi,
  Phone: Ii,
  Places: Li,
  Preview: Fi,
  "Previous page": "Páxina anterior",
  Save: Pi,
  Search: Oi,
  "Search country name or code": "Buscar nome do país ou código",
  "Search results": "Resultados da búsqueda",
  "Select all": "Seleccionar todos",
  "Select country phone code": "Selecciona o código telefónico do país",
  September: Ei,
  Show: _i,
  "Showing {0}-{1} of {2}": "Amosando {0}-{1} de {2}",
  Smileys: Ni,
  "Something went wrong!": "¡Algo saíu mal!",
  "Success!": "¡Listo!",
  "Success! All went right": "Ben! Todo foi correcto",
  Symbols: zi,
  "The phone number you entered is invalid": "O número de teléfono que introduciches non é válido",
  "The specified date is not valid": "A data especificada non é válida",
  "The specified date is outside the allowed range": "A data especificada está fóra do rango permitido",
  "There is no available data matching your current request. Try refreshing or maybe there's nothing to show": "Non hai datos dispoñibles que coincidan coa súa solicitude actual. Tente actualizar ou quizais non haxa nada que amosar",
  "There is no available data matching your current request. Try refreshing the page": "Non hai información que coincida coa túa petición actual. Proba a refrescar a páxina",
  "This might be of your interest": "Isto podería interesarte",
  "Time Ago Day": "días | día | días",
  "Time Ago Future": "En {0}",
  "Time Ago Hour": "horas | hora | horas",
  "Time Ago Minute": "minutos | minuto | minutos",
  "Time Ago Month": "meses| mes | meses",
  "Time Ago Past": "Fai {0}",
  "Time Ago Second": "segundos | segundo | segundos",
  "Time Ago Week": "semanas | semana | semanas",
  "Time Ago Year": "anos | ano | anos",
  Tomorrow: Bi,
  "Try again": "Proba outra vez",
  "Warning!": "¡Atención!",
  "Weekday Abbreviation Short Friday": "V",
  "Weekday Abbreviation Short Monday": "L",
  "Weekday Abbreviation Short Saturday": "S",
  "Weekday Abbreviation Short Sunday": "D",
  "Weekday Abbreviation Short Thursday": "X",
  "Weekday Abbreviation Short Tuesday": "M",
  "Weekday Abbreviation Short Wednesday": "M",
  "Woops! Something went wrong...": "Vaia! Algo saíu mal...",
  Yesterday: Vi,
  "You cannot use zero or negative values": "Non podes usar valores negativos ou cero",
  "You have seen <strong>{seen}</strong> of <strong>{total}</strong> {kindOfElement}": "Viches <strong>{seen}strong> de <strong>{total}strong> {kindOfElement}",
  "You should bear this in mind": "Deberías ter isto en conta",
  "Your current operation has been successfully completed": "A túa operación actual completouse con éxito",
  "{current}/{limit} characters": "{current}/{limit} caracteres",
  "Error uploading the image - File may be too large": "Erro ao cargar a imaxe - O arquivo pode ser demasiado grande"
}, Em = {
  "ca-ES": _e(si, Ma),
  "en-US": _e(nn, Ia),
  "es-ES": _e(Hn, La),
  "eu-ES": _e(Ss, Fa),
  "gl-ES": _e(Hi, Pa)
}, Zt = Symbol("cb-locale-config"), ea = Symbol("cb-use-route"), ta = Symbol("cb-auth-config"), aa = Symbol("cb-api-urls-config");
function te() {
  return xe(Zt, (() => Oa.env.NODE_ENV === "development" ? Qa() : {
    t: (n) => n
  })());
}
const Ri = ["data-testid"], Te = /* @__PURE__ */ _({
  __name: "CbCard",
  props: {
    id: {
      type: String,
      default: ""
    },
    extraRounded: {
      type: Boolean
    }
  },
  setup(e) {
    return (n, t) => (l(), g("article", {
      "data-testid": e.id ? `CbCard_${e.id}` : "CbCard",
      class: I([
        "bg-white dark:bg-base-1000 shadow",
        e.extraRounded ? "rounded-2xl" : "rounded-sm"
      ])
    }, [
      N(n.$slots, "default")
    ], 10, Ri));
  }
});
const qi = {}, Wi = /* @__PURE__ */ bt('<svg id="euqMzaUGWij1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="-23 0 680 680" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" data-v-622fa6d0><g transform="translate(65.591316 88.531777)" data-v-622fa6d0><g id="euqMzaUGWij3" transform="translate(-.000026 0.000026)" data-v-622fa6d0><path d="M229.62,0.65v50.51c-62.42,9.55-112,39.55-146,93.35-24,37.86-34.11,79.62-30,124.25c9.07,97.54,82.39,169,171.35,181.32c55.63,7.72,106.1-5.65,150.53-40s69.16-80.4,76.8-135.91h48.18C493.69,384.25,399.7,498.95,257.87,502.84c-147.77,4-262.85-116.71-257.7-259.12C5.72,90.1,130.78,5.79,229.62,0.65Z" fill="#002449" data-v-622fa6d0></path><path d="M502.69,231.17h-48.59c-5.49-47.6-24.4-88.73-58.12-122.54s-74.78-52.48-122.23-57.74v-50.64c.85-.13,1.7-.21,2.55-.25c62.53,0,125.06.02,187.58.06c18.51,0,33.8,11.64,38.36,29.05.36,1.38.56,2.8.57,4.22v194.82c.02.74-.05,1.51-.12,3.02Z" fill="#0080ff" data-v-622fa6d0></path></g><path id="euqMzaUGWij6" d="M250.29,358.55c27.92-.9,52.05-10.52,72.63-29.36c5-4.61,10.18-9.26,17.32-10.73c14.3-3.16,28.46,5.88,31.61,20.18c1.86,8.43-.5,17.24-6.32,23.61-9.9,10.87-21.69,19.4-34.3,26.77-21.43,12.54-45.53,19.82-70.32,21.23-83.44,5.23-155.26-55.09-166.66-136.12-11.64-82.72,41-159.75,122.43-178.29c48.77-11.11,93.35-.36,133,30.27c4.81,3.78,9.42,7.8,13.81,12.05c11.39,10.85,12.08,27.12,1.79,38.14-10.11,10.83-26.23,11.21-37.77.71-16.13-14.68-34.05-25.77-55.72-30.45-57.63-12.45-116.2,26.89-126.33,85.16-10.05,57.82,25.37,111.16,82.51,123.87c7.28,1.66,14.87,2,22.32,2.96Z" fill="#002449" data-v-622fa6d0></path></g></svg>', 1);
function ji(e, n) {
  return l(), g("div", null, [
    N(e.$slots, "default", {}, () => [
      Wi
    ], !0)
  ]);
}
const Yi = /* @__PURE__ */ ee(qi, [["render", ji], ["__scopeId", "data-v-622fa6d0"]]), Ki = /* @__PURE__ */ _({
  __name: "CbLoader",
  props: {
    ringSize: {
      type: Number,
      default: 20
    },
    variant: {
      type: String,
      default: "spinner",
      validator: (e) => ["spinner", "logo"].includes(e)
    }
  },
  setup(e) {
    const n = e;
    function t() {
      return Math.floor(n.ringSize / 10);
    }
    return (a, o) => n.variant === "spinner" ? (l(), g("div", {
      key: 0,
      class: "cb-loader",
      "data-testid": "CbLoader",
      style: le({
        "--loader-ring-size": `${e.ringSize}px`,
        "--loader-ring-border-width": `${t()}px`
      })
    }, null, 4)) : (l(), P(Yi, {
      key: 1,
      "data-testid": "CbLogoLoader",
      class: "cb-loader-logo"
    }));
  }
});
const qe = /* @__PURE__ */ ee(Ki, [["__scopeId", "data-v-4113f467"]]), ye = /* @__PURE__ */ _({
  __name: "CbCheckbox",
  props: /* @__PURE__ */ Fe({
    id: {
      type: String,
      required: !0
    },
    label: {
      type: String,
      default: ""
    },
    help: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean
    },
    loading: {
      type: Boolean
    }
  }, {
    modelValue: {
      type: Boolean,
      default: void 0
    },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Fe(["change"], ["update:modelValue"]),
  setup(e, { emit: n }) {
    const t = vt(e, "modelValue"), a = n, o = e;
    K(t, (r) => {
      a("change", r);
    });
    const s = yt(), i = T(() => o.loading || o.disabled), d = T(() => o.loading ? Object.fromEntries(Object.entries(s).filter(([r]) => r !== "decorator")) : s);
    return (r, p) => {
      const h = pe("FormKit");
      return l(), P(h, he({ id: e.id }, r.$attrs, {
        modelValue: t.value,
        "onUpdate:modelValue": p[0] || (p[0] = (b) => t.value = b),
        type: "checkbox",
        label: e.label,
        help: e.help,
        disabled: i.value,
        classes: {
          inner: "flex items-center"
        }
      }), Oe({ _: 2 }, [
        e.loading ? {
          name: "decorator",
          fn: A(() => [
            L(qe, { class: "text-primary-500 mr-2" })
          ]),
          key: "0"
        } : void 0,
        J(d.value, (b, y) => ({
          name: y,
          fn: A((w) => [
            N(r.$slots, y, kt(wt(w)))
          ])
        }))
      ]), 1040, ["id", "modelValue", "label", "help", "disabled"]);
    };
  }
}), Ui = /* @__PURE__ */ _({
  __name: "CbVirtualList",
  props: {
    id: {
      type: String,
      default: Se()
    },
    defaultSelected: {
      type: Array,
      default: () => []
    },
    disabledItems: {
      type: [Array, void 0],
      default: void 0
    },
    items: {
      type: Array,
      required: !0
    },
    itemHeight: {
      type: [Function, Number],
      required: !0
    },
    wrapperClasses: {
      type: String,
      default: void 0
    },
    containerClasses: {
      type: String,
      default: void 0
    },
    rowClasses: {
      type: [String, Array, Function],
      default: void 0
    },
    listTag: {
      type: String,
      default: "div"
    },
    wrapperTag: {
      type: String,
      default: "ul"
    },
    rowTag: {
      type: String,
      default: "li"
    },
    multiple: {
      type: Boolean
    }
  },
  emits: [
    "selected"
  ],
  setup(e, { emit: n }) {
    const t = n, a = e, o = D(a.defaultSelected);
    K(() => a.defaultSelected, () => {
      a.multiple && (o.value = a.defaultSelected);
    });
    function s(S) {
      return `virtual-list-checkbox-${a.id}-${S}`;
    }
    function i(S) {
      return o.value.findIndex((R) => R === S.value) !== -1;
    }
    function d(S) {
      return document.getElementById(s(S));
    }
    const {
      list: r,
      containerProps: p,
      wrapperProps: h,
      scrollTo: b
    } = Qt(
      ce(a, "items"),
      {
        itemHeight: a.itemHeight,
        overscan: 12
      }
    );
    K(() => a.items.length, () => {
      b && b(0);
    });
    function y(S) {
      b(S);
      const R = document.querySelector(`[data-focusindex="${S}"]`);
      R && R.focus();
    }
    const w = D(0);
    function v(S, R) {
      R.key === "Tab" && (w.value = S + 1), w.value || (w.value = S);
    }
    function f() {
      w.value > 0 && (w.value -= 1, y(w.value));
    }
    function m() {
      w.value < a.items.length && (w.value += 1, y(w.value));
    }
    function k(S) {
      var R;
      (R = a.disabledItems) != null && R.includes(S.value) || t("selected", S);
    }
    const x = D(!1);
    function $(S, R) {
      var U;
      if ((U = a.disabledItems) != null && U.includes(S.value))
        return;
      const B = d(R);
      B != null && B.checked ? o.value.push(S.value) : o.value = o.value.filter((M) => M !== S.value), B == null || B.click(), x.value || (x.value = !0, t("selected", o.value)), setTimeout(() => {
        x.value = !1;
      }, 200);
    }
    function F() {
      a.items.forEach((S, R) => {
        if (i(S)) {
          const B = d(R);
          B == null || B.click();
        }
      });
    }
    return ne(() => {
      if (!Array.isArray(a.defaultSelected))
        throw Error(`Prop: defaultSelected for CbVirtualList with ID ${a.id} needs to be an array, currently the props is ${typeof a.defaultSelected}`);
      a.multiple && F();
    }), (S, R) => (l(), P(de(e.listTag), he(u(p), {
      class: e.containerClasses,
      "data-testid": "cbvirtual-list"
    }), {
      default: A(() => [
        (l(), P(de(e.wrapperTag), he(u(h), {
          class: e.wrapperClasses,
          "data-testid": "cbvirtual-list-wrapper"
        }), {
          default: A(() => [
            (l(!0), g(Y, null, J(u(r), ({ data: B, index: U }) => (l(), P(de(e.rowTag), {
              key: U,
              class: I(typeof e.rowClasses == "function" ? e.rowClasses(B) : e.rowClasses),
              "data-testid": "cbvirtual-list-row",
              "data-focusindex": U,
              tabindex: "0",
              onKeydown: [
                R[0] || (R[0] = fe(ie((M) => m(), ["prevent"]), ["down"])),
                R[1] || (R[1] = fe(ie((M) => f(), ["prevent"]), ["up"])),
                fe((M) => v(U, M), ["tab"]),
                fe((M) => e.multiple ? $(B, U) : k(B), ["enter"])
              ],
              onFocus: (M) => v(U, M),
              onClick: (M) => e.multiple ? $(B, U) : k(B)
            }, {
              default: A(() => {
                var M;
                return [
                  N(S.$slots, "prefix", { item: B }),
                  e.multiple ? (l(), P(ye, {
                    key: 0,
                    id: s(U),
                    "model-value": i(B),
                    label: B.label,
                    type: "checkbox",
                    disabled: (M = e.disabledItems) == null ? void 0 : M.includes(B.value),
                    classes: {
                      outer: "w-full pointer-events-none",
                      wrapper: "w-full",
                      input: ""
                    }
                  }, null, 8, ["id", "model-value", "label", "disabled"])) : N(S.$slots, "default", {
                    key: 1,
                    item: B
                  }),
                  N(S.$slots, "suffix", { item: B })
                ];
              }),
              _: 2
            }, 1064, ["class", "data-focusindex", "onKeydown", "onFocus", "onClick"]))), 128))
          ]),
          _: 3
        }, 16, ["class"]))
      ]),
      _: 3
    }, 16, ["class"]));
  }
});
var ft = /* @__PURE__ */ ((e) => (e.Danger = "danger", e.Success = "success", e.Primary = "primary", e.Secondary = "secondary", e.Base = "base", e.Info = "info", e.Accent = "accent", e))(ft || {}), Ji = /* @__PURE__ */ ((e) => (e.SecondaryToPrimary = "from-secondary-to-primary", e.BaseToAccent = "from-base-to-accent", e.BaseToSuccess = "from-base-to-success", e.BaseToDanger = "from-base-to-danger", e.BaseToWarning = "from-base-to-warning", e))(Ji || {});
const At = /* @__PURE__ */ _({
  __name: "CbBadge",
  props: {
    mode: {
      type: String,
      default: ft.Base
    },
    gradient: {
      type: String,
      default: void 0
    },
    hasClose: {
      type: Boolean
    }
  },
  emits: [
    "close"
  ],
  setup(e) {
    const n = e, t = T(() => n.gradient ? `bg-linear-110 from-50% to-50% ${{
      "from-secondary-to-primary": "from-secondary-100 to-primary-200",
      "from-base-to-accent": "from-base-200 to-accent-3",
      "from-base-to-danger": "from-base-200 to-danger-200",
      "from-base-to-success": "from-base-200 to-success-200",
      "from-base-to-warning": "from-base-200 to-warning-500"
    }[n.gradient]} dark:text-black` : ""), a = {
      base: "bg-base-200 text-base-900",
      danger: "bg-danger-100 text-danger-900",
      success: "bg-success-200 text-success-900",
      primary: "bg-primary-500 text-white",
      secondary: "bg-secondary-300 text-white",
      info: "bg-primary-200 text-primary-900",
      accent: "bg-accent-1 text-white"
    };
    return (o, s) => (l(), g("div", {
      class: I([
        "rounded-sm font-bold text-xs py-1 inline-block text-center select-none",
        e.hasClose ? "pr-2 pl-4" : "px-4",
        e.gradient ? t.value : a[e.mode || u(ft).Base]
      ])
    }, [
      N(o.$slots, "default"),
      e.hasClose ? (l(), g("span", {
        key: 0,
        "data-testid": "badgeCloseIcon",
        class: "ml-2 mr-1 cursor-pointer bi bi-x-circle-fill",
        onClick: s[0] || (s[0] = (i) => o.$emit("close")),
        onKeypress: () => {
        }
      }, null, 32)) : E("", !0)
    ], 2));
  }
});
var oa = /* @__PURE__ */ ((e) => (e.Small = "sm", e.Medium = "md", e.Large = "lg", e))(oa || {}), na = /* @__PURE__ */ ((e) => (e.Primary = "primary", e.Secondary = "secondary", e.Success = "success", e.Danger = "danger", e))(na || {}), sa = /* @__PURE__ */ ((e) => (e.Filled = "filled", e.Outline = "outline", e.Transparent = "transparent", e))(sa || {});
const Gi = { class: "cb-loader-container" }, Qi = /* @__PURE__ */ _({
  __name: "CbButton",
  props: {
    tag: {
      type: String,
      default: "button"
    },
    mode: {
      type: String,
      default: sa.Filled,
      validator: (e) => ["filled", "outline", "transparent"].includes(e)
    },
    square: {
      type: Boolean
    },
    size: {
      type: String,
      default: oa.Medium,
      validator: (e) => ["lg", "md", "sm"].includes(e)
    },
    color: {
      type: String,
      default: na.Primary,
      validator: (e) => [
        "primary",
        "secondary",
        "success",
        "danger"
      ].includes(e)
    },
    disabled: {
      type: Boolean
    },
    loading: {
      type: Boolean
    }
  },
  emits: [
    "click"
  ],
  setup(e, { emit: n }) {
    const t = n, a = (o) => {
      t("click", o);
    };
    return (o, s) => (l(), P(de(e.tag), {
      type: "button",
      class: I([
        "cb-button bg-primary-500 relative outline-0 focus:outline-hidden focus:ring focus:ring-primary-300",
        e.mode,
        { square: e.square },
        e.size,
        e.color
      ]),
      disabled: e.disabled,
      onClick: a
    }, {
      default: A(() => [
        c("div", Gi, [
          e.loading ? (l(), P(qe, {
            key: 0,
            class: "block"
          })) : E("", !0)
        ]),
        c("span", {
          class: I([
            "block",
            { "opacity-0": e.loading }
          ])
        }, [
          N(o.$slots, "default", {}, void 0, !0)
        ], 2)
      ]),
      _: 3
    }, 8, ["class", "disabled"]));
  }
});
const re = /* @__PURE__ */ ee(Qi, [["__scopeId", "data-v-486347e4"]]), Xi = {}, Zi = { class: "mb-6 border-base-300 w-full" };
function el(e, n) {
  return l(), g("hr", Zi);
}
const tl = /* @__PURE__ */ ee(Xi, [["render", el]]), al = /* @__PURE__ */ c("span", { class: "bi bi-search z-10 absolute left-7" }, null, -1), ol = {
  key: 1,
  class: "text-center p-8 block w-full text-xl font-bold font-body"
}, nl = { class: "w-11/12 whitespace-nowrap overflow-hidden text-ellipsis mr-2" }, sl = {
  key: 2,
  class: "p-3"
}, il = { class: "flex justify-end pt-0 gap-x-3" }, ll = /* @__PURE__ */ _({
  __name: "CbSelectMenu",
  props: {
    menuId: {
      type: String,
      required: !0
    },
    defaultSelected: {
      type: [String, Number, Array, void 0],
      default: void 0
    },
    disabledItems: {
      type: [Array, void 0],
      default: void 0
    },
    items: {
      type: Array,
      required: !0
    },
    searchPlaceholder: {
      type: String,
      default: ""
    },
    searchable: {
      type: Boolean
    },
    showDefaultMenuSuffix: {
      type: Boolean
    },
    virtualListElementHeight: {
      type: Number,
      default: 40
    },
    menuWidth: {
      type: String,
      default: "22rem"
    },
    menuHeight: {
      type: String,
      default: ""
    },
    menuMaxHeight: {
      type: String,
      default: ""
    },
    multiple: {
      type: Boolean
    },
    showSelectionActions: {
      type: Boolean
    }
  },
  emits: [
    "selected",
    "apply"
  ],
  setup(e, { emit: n }) {
    const { t } = te(), a = n, o = e, s = D(""), i = D(o.items);
    $t(
      s,
      () => {
        s.value ? i.value = o.items.filter((f) => {
          const m = je(f.label).toLocaleLowerCase(), k = je(f.value.toString()).toLocaleLowerCase(), x = je(s.value).toLocaleLowerCase(), $ = m.includes(je(x)), F = k.includes(x);
          return $ || F;
        }) : i.value = o.items;
      },
      { debounce: 500, maxWait: 1e3 }
    );
    const d = T(() => {
      const m = o.searchable ? i.value.length : o.items.length;
      return o.showSelectionActions ? Math.min(m, 5) : m;
    }), r = T(() => {
      const m = `${3.5 * d.value}rem`;
      return {
        height: o.menuHeight || m,
        width: o.menuWidth,
        // Or props default
        "min-height": Ht(o.virtualListElementHeight),
        // Don't allow less menu height than one item height
        ...o.menuMaxHeight && { "max-height": o.menuMaxHeight }
        // Don't add max-height if not set
      };
    }), p = D(o.defaultSelected);
    function h(f) {
      p.value = f, a("selected", f);
    }
    const b = D(o.defaultSelected);
    function y(f) {
      b.value = f, !o.showSelectionActions && a("selected", b.value);
    }
    function w(f) {
      var m;
      return !o.multiple && p.value ? f.value.toString() === p.value.toString() : o.multiple && ((m = b.value) != null && m.length) ? b.value.findIndex((k) => k === f.value) !== -1 : !1;
    }
    function v(f) {
      var m, k;
      return (m = o.disabledItems) != null && m.length ? ((k = o.disabledItems) == null ? void 0 : k.findIndex((x) => x === f.value)) !== -1 : !1;
    }
    return ne(() => {
      const f = document.getElementById(o.menuId);
      f == null || f.focus();
    }), (f, m) => (l(), P(Te, null, {
      default: A(() => {
        var k;
        return [
          e.searchable ? (l(), P(u(Ka), {
            key: 0,
            id: e.menuId,
            modelValue: s.value,
            "onUpdate:modelValue": m[0] || (m[0] = (x) => s.value = x),
            "data-testid": `cbSelectMenu-${e.menuId}`,
            type: "search",
            placeholder: e.searchPlaceholder,
            "input-class": "m-4 pl-9!",
            role: "presentation",
            tabindex: "-1",
            autocomplete: "off"
          }, {
            prefix: A(() => [
              al
            ]),
            _: 1
          }, 8, ["id", "modelValue", "data-testid", "placeholder"])) : E("", !0),
          s.value && !i.value.length ? (l(), g("span", ol, H(u(t)("No matching results with: {searchTerm}", { searchTerm: s.value })), 1)) : E("", !0),
          L(Ui, {
            multiple: e.multiple,
            "default-selected": e.multiple ? b.value : [p.value],
            items: i.value,
            "disabled-items": e.disabledItems,
            "item-height": e.virtualListElementHeight,
            "row-classes": (x) => [
              "p-4 block flex items-center",
              { "bg-primary-100 font-bold": w(x) },
              v(x) ? "bg-base-200 user-select-none text-base-300 cursor-default" : "hover:text-black hover:bg-secondary-50 active:bg-primary-300 active:text-white focus:bg-primary-100 focus:text-black cursor-pointer"
            ],
            style: le(r.value),
            onSelected: m[1] || (m[1] = (x) => e.multiple ? y(x) : h(x.value))
          }, {
            prefix: A(({ item: x }) => [
              N(f.$slots, "prefix", { item: x })
            ]),
            default: A(({ item: x }) => [
              c("span", nl, H(x.label), 1)
            ]),
            suffix: A(({ item: x }) => [
              N(f.$slots, "suffix", { item: x }, () => [
                e.showDefaultMenuSuffix ? (l(), P(At, {
                  key: 0,
                  class: "ml-auto whitespace-nowrap"
                }, {
                  default: A(() => [
                    X(H(x.value), 1)
                  ]),
                  _: 2
                }, 1024)) : E("", !0)
              ])
            ]),
            _: 3
          }, 8, ["multiple", "default-selected", "items", "disabled-items", "item-height", "row-classes", "style"]),
          e.showSelectionActions ? (l(), g("div", sl, [
            L(tl, { class: "my-3!" }),
            c("div", il, [
              ((k = b.value) == null ? void 0 : k.length) > 0 ? (l(), P(re, {
                key: 0,
                mode: "outline",
                onClick: m[2] || (m[2] = () => {
                  b.value = [];
                })
              }, {
                default: A(() => [
                  X(H(u(t)("Clear")), 1)
                ]),
                _: 1
              })) : E("", !0),
              L(re, {
                "data-testid": "applyButton",
                disabled: !b.value || b.value.length === 0,
                onClick: m[3] || (m[3] = () => {
                  a("selected", b.value);
                })
              }, {
                default: A(() => [
                  X(H(u(t)("Apply")), 1)
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ])) : E("", !0)
        ];
      }),
      _: 3
    }));
  }
}), rl = /* @__PURE__ */ c("span", { class: "bi bi-chevron-down" }, null, -1), dl = [
  rl
], _m = /* @__PURE__ */ _({
  __name: "CbAccordion",
  props: {
    startExpanded: {
      type: Boolean
    },
    baseHeight: {
      type: Number,
      required: !1,
      default: 0
    },
    tag: {
      type: String,
      required: !1,
      default: "div"
    },
    customHeaderClasses: {
      type: String,
      default: void 0
    },
    customBodyClasses: {
      type: String,
      default: void 0
    },
    forceAlwaysExpanded: {
      type: Boolean
    },
    forceRecalculateHeight: {
      type: Boolean
    },
    hideChevron: {
      type: Boolean
    },
    grouped: {
      type: Boolean
    }
  },
  emits: [
    "expand",
    "expanded",
    "collapse",
    "collapsed",
    "recalculated-height"
  ],
  setup(e, { emit: n }) {
    const t = e, a = n, o = { padding: 0, border: 0, margin: 0 }, s = { willChange: "height" }, i = D(t.forceAlwaysExpanded || t.startExpanded), d = ce(t, "baseHeight"), r = T(() => {
      const x = {
        overflow: "hidden",
        height: `${d.value}px`
      };
      return {
        visible: x,
        collapsed: {
          ...o,
          ...d.value === 0 ? { display: "none" } : x
        }
      };
    }), p = D(), h = D(i.value ? o : r.value.collapsed), b = D(i.value ? "expanded" : "collapsed"), y = D("200ms");
    function w(x = 0) {
      if (x === 0)
        return 0;
      const $ = x / 36;
      return Math.round((4 + 15 * $ ** 0.25 + $ / 5) * 10);
    }
    function v(x = 0, $ = 0) {
      return y.value = `${w(x - $)}ms`, {
        height: `${x}px`
      };
    }
    function f(x) {
      var S, R;
      const { target: $, propertyName: F } = x;
      if ($ === p.value && F === "height")
        if (i.value) {
          const B = parseFloat($.style.height);
          ((S = p.value) == null ? void 0 : S.scrollHeight) === B && (h.value = o, b.value = "expanded", a("expanded"));
        } else
          ((R = p.value) == null ? void 0 : R.style.height) === `${d.value}px` && (h.value = r.value.collapsed, b.value = "collapsed", a("collapsed"));
    }
    function m() {
      t.forceAlwaysExpanded || requestAnimationFrame(() => {
        var x;
        i.value ? (h.value = {
          ...o,
          ...s,
          ...r.value.visible
        }, requestAnimationFrame(() => {
          var $;
          h.value = {
            ...h.value,
            ...v(($ = p.value) == null ? void 0 : $.scrollHeight, d.value)
          }, b.value = "expanding", a("expand");
        })) : (h.value = {
          ...h.value,
          ...s,
          ...v((x = p.value) == null ? void 0 : x.scrollHeight, d.value)
        }, requestAnimationFrame(() => {
          h.value = {
            ...h.value,
            ...r.value.visible
          }, b.value = "collapsing", a("collapse");
        }));
      });
    }
    K(i, m), K(() => t.forceRecalculateHeight, () => {
      t.forceRecalculateHeight && (m(), a("recalculated-height"));
    }), K(d, (x) => {
      i.value || (h.value = {
        ...h.value,
        transitionDuration: "0s",
        height: `${x}px`
      });
    });
    const k = T(() => !t.hideChevron && !t.forceAlwaysExpanded ? !0 : !(t.forceAlwaysExpanded && t.hideChevron || t.forceAlwaysExpanded || t.hideChevron));
    return (x, $) => (l(), g("div", null, [
      c("div", {
        "data-testid": "accordionWrapper",
        class: I([
          "transition-all duration-200",
          { "cursor-pointer": !e.forceAlwaysExpanded },
          e.customHeaderClasses || "flex justify-between px-4 py-2 font-bold bg-white dark:bg-base-1000 border-y border-x border-base-300 font-body min-h-[3.5rem] items-center",
          { "rounded-t": !e.grouped }
        ]),
        onClick: $[0] || ($[0] = (F) => i.value = !i.value),
        onKeypress: () => {
        }
      }, [
        N(x.$slots, "title", { isExpanded: i.value }),
        k.value ? (l(), g("span", {
          key: 0,
          "data-testid": "accordionChevron",
          class: I([
            "font-bold transition-transform duration-200 rounded-sm h-7 w-7 flex items-center justify-center order-last",
            { "rotate-180 text-white bg-primary-300": i.value }
          ])
        }, dl, 2)) : E("", !0)
      ], 34),
      (l(), P(de(e.tag), {
        ref: (F) => p.value = F,
        "data-elem-tag": e.tag,
        "data-collapse": b.value,
        class: I([
          "transition-height duration-300"
        ]),
        style: le(h.value),
        onTransitionend: f
      }, {
        default: A(() => [
          c("div", {
            class: I(e.customBodyClasses || "p-4 bg-white dark:bg-base-700 border border-t-0 border-base-300")
          }, [
            N(x.$slots, "default", { status: b.value })
          ], 2)
        ]),
        _: 3
      }, 40, ["data-elem-tag", "data-collapse", "style"]))
    ]));
  }
});
var ia = /* @__PURE__ */ ((e) => (e.Danger = "danger", e.Success = "success", e.Warning = "warning", e.Info = "info", e))(ia || {});
const ul = ["id"], cl = ["data-testid"], ml = { class: "flex flex-col" }, pl = { class: "mr-2 font-bold" }, gl = { class: "text-base-700 dark:text-base-500 pr-2" }, fl = {
  key: 0,
  class: "space-x-2 pt-3"
}, hl = /* @__PURE__ */ _({
  __name: "CbAlertItem",
  props: {
    status: {
      type: String,
      required: !0
    },
    maxWidth: {
      type: String,
      default: "32rem"
    },
    minWidth: {
      type: String,
      default: "32rem"
    },
    ctaItems: {
      type: Array,
      default: void 0
    },
    location: {
      type: String,
      default: "upper-right"
    },
    dismissible: {
      type: Boolean
    },
    closeAfter: {
      type: [Number, String],
      default: void 0
    },
    ulid: {
      type: String,
      required: !0
    },
    repeatedByLocation: {
      type: Number,
      default: 0
    }
  },
  emits: [
    "close"
  ],
  setup(e, { emit: n }) {
    const { t } = te(), a = D(), { isSmaller: o } = Rt(), s = e, i = n, d = {
      danger: t("Something went wrong!"),
      success: t("Success!"),
      warning: t("Warning!"),
      info: t("Did you know?")
    }, r = {
      danger: t("An error ocurred, but we have not been able to identify it. Try reloading the page or if the error persist contact us"),
      success: t("Your current operation has been successfully completed"),
      warning: "",
      info: ""
    }, p = {
      danger: {
        title: d.danger,
        message: r.danger,
        icon: "bi-x-circle-fill",
        color: "bg-danger-700 dark:bg-danger-700 text-white border-danger-700"
      },
      success: {
        title: d.success,
        message: r.success,
        icon: "bi-check-circle-fill",
        color: "bg-success-300 dark:bg-success-700 text-success-500 dark:text-white border-success-300"
      },
      warning: {
        title: d.warning,
        message: r.warning,
        icon: "bi-exclamation-triangle-fill",
        color: "bg-warning-300 dark:bg-warning-900 text-warning-900 dark:text-white border-warning-500 dark:border-warning-700"
      },
      info: {
        title: d.info,
        message: r.info,
        icon: "bi-info-circle-fill",
        color: "bg-primary-300 dark:bg-primary-700 text-white border-primary-500"
      }
    };
    function h(S) {
      return `${S}px`;
    }
    function b() {
      i("close", s.ulid);
    }
    ne(() => {
      if (s.closeAfter) {
        const S = typeof s.closeAfter == "string" ? parseInt(s.closeAfter, 10) : s.closeAfter;
        setTimeout(b, S);
      }
    });
    function y() {
      let S = "0px";
      return s.repeatedByLocation > 1 && (S = h(26 * (s.repeatedByLocation - 1))), s.location.includes("bottom") && (S = `-${S}`), S;
    }
    const w = y(), {
      height: v,
      width: f,
      update: m
    } = Ie(a), k = Yt({
      "upper-right": {
        top: "-2000px",
        right: 0
      },
      "upper-left": {
        top: "-2000px",
        left: 0
      },
      "bottom-right": {
        top: "2000px",
        right: 0
      },
      "bottom-left": {
        top: "2000px",
        left: 0
      }
    });
    async function x() {
      const S = o("--breakpoint-md").value ? 0 : 22;
      await ja(), m(), k["upper-right"].left = h(document.body.clientWidth - f.value - S), k["upper-left"].left = h(0 + S), k["bottom-right"].left = h(document.body.clientWidth - f.value - S), k["bottom-left"].left = h(0 + S), k["upper-right"].top = h(0 + S), k["upper-left"].top = h(0 + S), k["bottom-right"].top = h(document.body.clientHeight - v.value - S), k["bottom-left"].top = h(document.body.clientHeight - v.value - S);
    }
    K(() => [s.location, s.status], () => {
      x();
    }), Xa(a, () => {
      x();
    });
    const $ = T(() => ({
      left: k[s.location].left,
      top: k[s.location].top
    }));
    function F() {
      return o("--breakpoint-md").value ? {
        width: "100%",
        marginTop: w
      } : {
        maxWidth: s.maxWidth,
        minWidth: s.minWidth,
        marginTop: w
      };
    }
    return (S, R) => {
      var B;
      return l(), g("div", {
        id: `alert_${e.status}_${e.ulid}`,
        ref_key: "alertElement",
        ref: a,
        role: "alert",
        class: "inline-flex fixed transition-all duration-500 bg-white dark:bg-base-1000 shadow rounded-sm pr-5 pl-3 p-4 z-55",
        style: le({
          ...$.value,
          ...F()
        })
      }, [
        c("span", {
          class: I([
            "w-2 h-auto rounded-full mr-2",
            p[e.status].color
          ])
        }, null, 2),
        u(o)("--breakpoint-md").value ? E("", !0) : (l(), g("span", {
          key: 0,
          class: I([
            e.status === u(ia).Danger ? "h-9 w-16 max-w-16" : "h-8 w-8 ",
            "rounded-full flex items-center justify-center mr-5 self-center",
            p[e.status].color
          ])
        }, [
          c("i", {
            class: I(`bi ${p[e.status].icon}`)
          }, null, 2)
        ], 2)),
        e.dismissible ? (l(), g("i", {
          key: 1,
          class: "ml-auto bi bi-x cursor-pointer absolute right-2 text-black dark:text-white top-1/2 -translate-y-2/4",
          "data-testid": `alert_${e.ulid}_close`,
          onClick: b,
          onKeypress: fe(b, ["esc"])
        }, null, 40, cl)) : E("", !0),
        c("div", null, [
          c("div", ml, [
            c("h3", pl, H(p[e.status].title), 1),
            c("p", gl, [
              N(S.$slots, "message", {}, () => [
                X(H(p[e.status].message), 1)
              ])
            ]),
            (B = e.ctaItems) != null && B.length ? (l(), g("div", fl, [
              (l(!0), g(Y, null, J(e.ctaItems, (U) => (l(), g(Y, {
                key: U.title
              }, [
                U ? (l(), P(re, {
                  key: 0,
                  mode: U.mode,
                  color: U.color,
                  size: "sm",
                  onClick: () => U.action()
                }, {
                  default: A(() => [
                    X(H(U.title), 1)
                  ]),
                  _: 2
                }, 1032, ["mode", "color", "onClick"])) : E("", !0)
              ], 64))), 128))
            ])) : E("", !0)
          ])
        ])
      ], 12, ul);
    };
  }
}), Ne = D([]);
function la() {
  function e(a) {
    Ne.value.push({
      ...a,
      ulid: Se()
    });
  }
  function n(a) {
    Ne.value = Ne.value.filter((o) => o.ulid !== a);
  }
  function t() {
    Ne.value = [];
  }
  return {
    addAlert: e,
    removeAlert: n,
    resetAlerts: t,
    alertList: Ne
  };
}
const bl = { class: "fixed top-0 right-0 z-51 pointer-events-none" }, Nm = /* @__PURE__ */ _({
  __name: "CbAlertField",
  setup(e) {
    const { alertList: n, removeAlert: t, resetAlerts: a } = la(), o = {
      "upper-left": 0,
      "upper-right": 0,
      "bottom-left": 0,
      "bottom-right": 0
    }, s = Yt({ ...o });
    function i() {
      var r;
      const d = (r = n.value[n.value.length - 1]) == null ? void 0 : r.location;
      n.value.length ? n.value.some((h) => h.location === d) && (s[d] = n.value.filter((h) => h.location === d).length || 0) : Object.assign(s, o);
    }
    return K(n, () => {
      i();
    }, { deep: !0 }), Ce(a), (d, r) => (l(), P(Ge, { to: "body" }, [
      c("div", bl, [
        L(Kt, {
          name: "fade",
          tag: "ul",
          class: "relative space-y-2 list-none pointer-events-auto"
        }, {
          default: A(() => [
            (l(!0), g(Y, null, J(u(n), (p) => (l(), P(hl, {
              key: p.ulid,
              status: p.status,
              location: p.location,
              "close-after": p.closeAfter,
              dismissible: p.dismissible,
              ulid: p.ulid,
              "cta-items": p.ctaItems,
              "repeated-by-location": s[p.location],
              onClose: u(t)
            }, Oe({ _: 2 }, [
              p.message ? {
                name: "message",
                fn: A(() => [
                  X(H(p.message), 1)
                ]),
                key: "0"
              } : void 0
            ]), 1032, ["status", "location", "close-after", "dismissible", "ulid", "cta-items", "repeated-by-location", "onClose"]))), 128))
          ]),
          _: 1
        })
      ])
    ]));
  }
}), vl = ["data-testid"], yl = { class: "flex flex-col mt-[.2rem] mr-3" }, kl = { class: "font-bold" }, wl = { class: "text-secondary-500" }, zm = /* @__PURE__ */ _({
  __name: "CbAlertInline",
  props: {
    status: {
      type: String,
      required: !0
    },
    dismissible: {
      type: Boolean
    }
  },
  setup(e) {
    const n = {
      danger: {
        base: "bg-danger-50",
        contrast: "border-danger-300 text-danger-300",
        icon: "bi-x-circle-fill"
      },
      success: {
        base: "bg-success-50",
        contrast: "border-success-500 text-success-500",
        icon: "bi-check-circle-fill"
      },
      warning: {
        base: "bg-warning-50",
        contrast: "border-warning-700 text-warning-700",
        icon: "bi-exclamation-triangle-fill"
      },
      info: {
        base: "bg-secondary-50",
        contrast: "border-primary-500 text-primary-500",
        icon: "bi-info-circle-fill"
      }
    };
    function t() {
    }
    return (a, o) => (l(), g("div", {
      class: I([
        "px-5 pt-4 pb-5 relative rounded-sm border flex",
        n[e.status].base,
        n[e.status].contrast
      ])
    }, [
      c("i", {
        "data-testid": `alertIcon_${e.status}`,
        class: I([
          "bi mr-3 text-xl",
          n[e.status].contrast,
          n[e.status].icon
        ])
      }, null, 10, vl),
      c("div", yl, [
        c("h3", kl, [
          N(a.$slots, "title")
        ]),
        c("p", wl, [
          N(a.$slots, "description")
        ])
      ]),
      e.dismissible ? (l(), g("i", {
        key: 0,
        "data-testid": "alertButtonDismiss",
        class: "absolute top-1 right-2 bi bi-x text-black text-xl cursor-pointer",
        onClick: t,
        onKeydown: fe(t, ["enter"])
      }, null, 32)) : E("", !0)
    ], 2));
  }
});
var ra = /* @__PURE__ */ ((e) => (e.Primary100 = "bg-primary-100", e.Secondary100 = "bg-secondary-100", e.Success200 = "bg-success-200", e.Danger100 = "bg-danger-100", e.User2 = "bg-user-2", e.User3 = "bg-user-3", e.User6 = "bg-user-6", e.AccentSpecial100 = "bg-accent-special-100", e.AccentSpecial300 = "bg-accent-special-300", e))(ra || {});
const xl = /* @__PURE__ */ _({
  __name: "CbSkeletonText",
  props: {
    tag: {
      type: String,
      default: "span"
    },
    lines: {
      type: Number,
      default: 1
    },
    delay: {
      type: Number,
      default: 1e3
    },
    width: {
      type: String,
      default: void 0
    },
    isLoading: {
      type: Boolean
    }
  },
  setup(e) {
    const n = e, t = D(!1);
    let a;
    return ne(() => {
      a = setTimeout(() => {
        t.value = !0;
      }, n.delay);
    }), Ut(() => {
      clearInterval(a);
    }), (o, s) => e.isLoading ? (l(), P(de(e.tag), he({ key: 0 }, o.$attrs, {
      class: [
        "block",
        { invisible: !t.value }
      ],
      "data-testid": "cb-skeleton-block"
    }), {
      default: A(() => [
        (l(!0), g(Y, null, J(e.lines, (i) => (l(), g("span", {
          key: i,
          class: "skeleton bg-linear-90 from-base-100 via-base-300 to-base-100 dark:from-base-500 dark:via-base-800 dark:to-base-500 rounded-md",
          style: le({
            width: e.width || `${u(Ea)(5, 10) * 10}%`
          })
        }, null, 4))), 128))
      ]),
      _: 1
    }, 16, ["class"])) : N(o.$slots, "default", { key: 1 }, void 0, !0);
  }
});
const Nt = /* @__PURE__ */ ee(xl, [["__scopeId", "data-v-0b0bd25d"]]), Sl = /* @__PURE__ */ _({
  __name: "CbSkeletonAvatar",
  props: {
    size: {
      type: String,
      default: "big"
    }
  },
  setup(e) {
    const n = e, t = {
      small: "w-8 h-8 text-sm",
      big: "w-16 h-16 text-2xl"
    }, a = T(() => t[n.size]);
    return (o, s) => (l(), g("div", {
      class: I([
        "flex overflow-hidden rounded-full skeleton",
        a.value
      ]),
      "data-testid": "avatarSkeletonText"
    }, null, 2));
  }
});
const $l = /* @__PURE__ */ ee(Sl, [["__scopeId", "data-v-347bb4ad"]]), Cl = /* @__PURE__ */ _({
  __name: "CbSkeletonBlock",
  props: {
    width: {
      type: String,
      default: "0rem"
    },
    height: {
      type: String,
      default: "0rem"
    },
    rounded: {
      type: Boolean
    },
    isLoading: {
      type: Boolean
    }
  },
  setup(e) {
    const n = e, t = ["rem", "em", "%", "px"], a = T(() => {
      const o = t.some((i) => n.width.includes(i)), s = t.some((i) => n.height.includes(i));
      return o && s;
    });
    return (o, s) => a.value && e.isLoading ? (l(), g("div", {
      key: 0,
      class: I([
        "flex overflow-hidden skeleton bg-linear-90 from-base-100 via-base-300 to-base-100 dark:from-base-500 dark:via-base-800 dark:to-base-500 rounded-md",
        { rounded: e.rounded }
      ]),
      style: le({
        width: e.width,
        height: e.height
      })
    }, null, 6)) : N(o.$slots, "default", { key: 1 }, void 0, !0);
  }
});
const zt = /* @__PURE__ */ ee(Cl, [["__scopeId", "data-v-729a10f7"]]), Dl = ["data-uniqueid"], We = /* @__PURE__ */ _({
  __name: "CbDropdown",
  props: {
    modelValue: {
      type: Boolean,
      default: void 0
    },
    margin: {
      type: Number,
      default: 12
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    openPosition: {
      type: String,
      default: "left",
      validator: (e) => ["left", "right"].includes(e)
    },
    openDirection: {
      type: String,
      default: "bottom",
      validator: (e) => ["top", "bottom"].includes(e)
    },
    zIndexMenu: {
      type: [Number, String],
      default: "50"
    },
    closeOnScroll: {
      type: Boolean,
      default: !1
    },
    closeOnOutside: {
      type: Boolean,
      default: !0
    },
    forceOpen: {
      type: Boolean
    },
    preventCloseOnTriggerClick: {
      type: Boolean
    }
  },
  emits: [
    "update:modelValue",
    "open",
    "close"
  ],
  setup(e, { emit: n }) {
    const t = e, a = n, o = typeof t.modelValue > "u" ? D(!1) : T({
      get() {
        return t.modelValue;
      },
      set(C) {
        a("update:modelValue", C);
      }
    }), s = D(null), i = D(null), d = D(null), r = D(Se()), p = D(t.openDirection === "bottom"), h = t.openPosition === "right", b = D(!1), {
      height: y,
      width: w,
      bottom: v,
      right: f,
      left: m,
      top: k,
      update: x
    } = Ie(i), {
      top: $,
      bottom: F,
      left: S,
      right: R,
      update: B
    } = Ie(d), {
      top: U,
      bottom: M,
      width: q
    } = Ie(document.body), G = T(() => p.value ? u(F) : u($) - u(y)), V = T(() => b.value ? u(q) / 2 - u(w) / 2 : h ? u(R) - u(w) : u(S));
    K([v, M], () => {
      if (t.openDirection === "bottom") {
        p.value = !0;
        const C = F.value + y.value > (window.innerHeight || document.documentElement.clientHeight);
        v.value > 0 && C && (p.value = !1);
      }
    }), K([k, U], () => {
      t.openDirection !== "bottom" && (p.value = !1, $.value - y.value < 0 && (p.value = !0));
    });
    function W() {
      const C = window.innerWidth || document.documentElement.clientWidth, O = S.value + w.value > C, z = R.value - w.value < 0, se = f.value >= C;
      return f.value - w.value < 0 && O || se && z;
    }
    K([b, f, q], ([C], [O]) => {
      O || (b.value = W());
    });
    const j = D(!1), Q = D(!1);
    function ae() {
      o.value = !0, B(), x(), b.value = W(), a("open");
    }
    function ge() {
      o.value = !1, b.value = !1, a("close");
    }
    function be() {
      o.value && t.preventCloseOnTriggerClick || (o.value && !Q.value && (j.value = !0, ge(), setTimeout(() => {
        j.value = !1;
      }, 500)), !o.value && !j.value && (Q.value = !0, ae(), setTimeout(() => {
        Q.value = !1;
      }, 500)));
    }
    return K(() => t.forceOpen, () => {
      var C;
      t.forceOpen && !o.value && ((C = d.value) == null || C.click());
    }), gt(i, (C) => {
      s.value && !s.value.contains(C.target) && t.closeOnOutside && ge();
    }), ne(() => {
      if (t.closeOnScroll && s.value) {
        const C = _a(s.value);
        C && Za(C, "scroll", ge);
      }
    }), (C, O) => (l(), g("div", {
      ref_key: "wrapper",
      ref: s,
      class: I([
        "relative block",
        { "pointer-events-none": e.disabled }
      ])
    }, [
      c("div", {
        ref_key: "trigger",
        ref: d,
        "data-testid": "openButton",
        "data-uniqueid": r.value,
        onClick: ie(be, ["stop"]),
        onKeypress: () => {
        }
      }, [
        N(C.$slots, "button", {
          isOpen: u(o),
          openMenu: ae,
          closeMenu: ge
        })
      ], 40, Dl),
      (l(), P(Ge, { to: "body" }, [
        L(xt, {
          name: p.value ? "slidemenu-bottom" : "slidemenu-top"
        }, {
          default: A(() => [
            u(o) ? (l(), g("div", {
              key: 0,
              ref_key: "menu",
              ref: i,
              "data-testid": "menu",
              class: "fixed cb-dropdown__menu",
              style: le({
                left: `${V.value}px`,
                top: `${G.value}px`,
                zIndex: Number(e.zIndexMenu)
              })
            }, [
              N(C.$slots, "menu", { closeMenu: ge })
            ], 4)) : E("", !0)
          ]),
          _: 3
        }, 8, ["name"])
      ]))
    ], 2));
  }
}), Al = {
  key: 1,
  class: "m-auto",
  "test-id": "avatarText"
}, Bm = /* @__PURE__ */ _({
  __name: "CbAvatar",
  props: {
    image: {
      type: String,
      default: void 0
    },
    firstName: {
      type: String,
      default: ""
    },
    lastName: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "small",
      validator: (e) => ["small", "big"].includes(e)
    },
    loading: {
      type: Boolean
    },
    openPosition: {
      type: String,
      default: "left",
      validator: (e) => ["left", "right"].includes(e)
    },
    openDirection: {
      type: String,
      default: "bottom",
      validator: (e) => ["top", "bottom"].includes(e)
    },
    colorClass: {
      type: String,
      default: void 0
    }
  },
  setup(e) {
    const n = e, t = {
      small: "w-8 h-8 text-sm",
      big: "w-16 h-16 text-2xl"
    };
    function a(r) {
      return ((r == null ? void 0 : r.charAt(0)) || "").toUpperCase();
    }
    const o = T(() => `${a(n.firstName)}${a(n.lastName)}`), s = Object.values(ra), i = T(() => t[n.size]), d = T(() => n.colorClass || s[Na(0, s.length)]);
    return (r, p) => e.loading ? (l(), P(u($l), {
      key: 0,
      size: e.size
    }, null, 8, ["size"])) : (l(), P(We, {
      key: 1,
      "open-position": e.openPosition,
      "open-direction": e.openDirection,
      "close-on-scroll": "",
      "close-on-outside": ""
    }, {
      button: A(() => [
        c("div", {
          class: I([
            "flex overflow-hidden rounded-full cursor-pointer",
            i.value,
            o.value ? d.value : "bg-white border border-base-200"
          ]),
          "data-testid": "avatarButton"
        }, [
          e.image ? (l(), g("div", {
            key: 0,
            class: I([
              "rounded-full bg-white m-auto flex",
              i.value
            ])
          }, [
            L(u(Pe), {
              src: e.image,
              alt: "Team Logo",
              class: "w-12 p-1 m-auto"
            }, null, 8, ["src"])
          ], 2)) : E("", !0),
          o.value && !e.image ? (l(), g("span", Al, H(o.value), 1)) : E("", !0),
          !o.value && !e.image ? (l(), g("i", {
            key: 2,
            class: I([
              "bi bi-person w-full flex items-center justify-center",
              e.size === "small" ? "text-xl" : "text-[2.1rem]"
            ])
          }, null, 2)) : E("", !0)
        ], 2)
      ]),
      menu: A(({ closeMenu: h }) => [
        L(Te, null, {
          default: A(() => [
            N(r.$slots, "menu", { closeMenu: h })
          ]),
          _: 2
        }, 1024)
      ]),
      _: 3
    }, 8, ["open-position", "open-direction"]));
  }
});
const Tl = {}, Ml = {
  class: "cb-button-group inline-flex rounded-md shadow-sm",
  role: "group"
};
function Il(e, n) {
  return l(), g("div", Ml, [
    N(e.$slots, "default")
  ]);
}
const Vm = /* @__PURE__ */ ee(Tl, [["render", Il]]), Ll = ["disabled"], ut = /* @__PURE__ */ _({
  __name: "CalendarDay",
  props: {
    isActive: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    },
    outsideOfCurrentMonth: {
      type: Boolean
    },
    isInSelectedRange: {
      type: Boolean
    }
  },
  emits: [
    "date-selected"
  ],
  setup(e) {
    const n = e, t = T(() => (n.outsideOfCurrentMonth || n.disabled) && !n.isActive && !n.isInSelectedRange);
    return (a, o) => (l(), g("button", {
      type: "button",
      class: I([
        "p-5 w-7 h-7 rounded-sm m-0! my-1! flex justify-center! items-center! hover:bg-primary-100",
        { "text-white bg-primary-500": e.isActive },
        { "bg-base-100 hover:bg-base-300 rounded-none!": e.isInSelectedRange },
        { "select-none cursor-default! text-base-500! flex justify-center! items-center! my-1! hover:bg-base-200!": t.value }
      ]),
      disabled: e.disabled,
      onClick: o[0] || (o[0] = (s) => a.$emit("date-selected"))
    }, [
      N(a.$slots, "default")
    ], 10, Ll));
  }
});
function Fl(e) {
  const n = e.getMonth(), t = e.getFullYear(), a = new Date(t, n, 0).getDay();
  if (!a)
    return [];
  const o = new Date(e.getTime());
  o.setDate(0);
  const s = Ct(o);
  return [...Array(s).keys()].map((d, r) => {
    const p = r + 1;
    return new Date(t, n - 1, p);
  }).slice(-a);
}
function Pl(e) {
  const n = e.getMonth(), t = e.getFullYear(), a = uo(new Date(t, n + 1, 0), { weekStartsOn: 1 }), o = new Date(a).getDate(), s = Ct(e);
  return !o || o === s ? [] : [...Array(o).keys()].map((d, r) => {
    const p = r + 1;
    return new Date(t, n + 1, p);
  });
}
function Ol(e) {
  const n = Ct(e), t = e.getMonth(), a = e.getFullYear();
  return [...Array(n).keys()].map((s, i) => {
    const d = i + 1;
    return new Date(a, t, d);
  });
}
function El(e) {
  return Array.from(Array(12).keys()).map((t) => new Date(e.getFullYear(), t, e.getDate()));
}
function _l(e) {
  const n = e.getFullYear(), t = n - n % 10 - 1;
  return Array.from(Array(12).keys()).map((o) => new Date(t + o, e.getMonth(), e.getDate()));
}
function Le(e, { minDate: n, maxDate: t }) {
  if (!n && !t)
    return !0;
  let a = !0;
  return n && (a = a && (He(e, n) || me(e, n))), t && (a = a && (Dt(e, t) || me(e, t))), a;
}
function Nl(e, n) {
  return Dt(e, n) ? e : n;
}
function zl(e, n) {
  return He(e, n) ? e : n;
}
function ct(e, n, t) {
  if (!n || !t || me(e, n) || me(e, t))
    return !1;
  const a = He(n, t) ? n : t, o = He(n, t) ? t : n;
  return Le(e, { minDate: o, maxDate: a });
}
var da = /* @__PURE__ */ ((e) => (e.Monday = "Weekday Abbreviation Short Monday", e.Tuesday = "Weekday Abbreviation Short Tuesday", e.Wednesday = "Weekday Abbreviation Short Wednesday", e.Thursday = "Weekday Abbreviation Short Thursday", e.Friday = "Weekday Abbreviation Short Friday", e.Saturday = "Weekday Abbreviation Short Saturday", e.Sunday = "Weekday Abbreviation Short Sunday", e))(da || {}), Tt = /* @__PURE__ */ ((e) => (e.January = "January", e.February = "February", e.March = "March", e.April = "April", e.May = "May", e.June = "June", e.July = "July", e.August = "August", e.September = "September", e.October = "October", e.November = "November", e.December = "December", e))(Tt || {}), Bl = /* @__PURE__ */ ((e) => (e.Date = "date", e.Month = "month", e.Year = "year", e))(Bl || {});
const ua = Symbol("start-date"), ca = Symbol("out-date"), Vl = { class: "grid grid-cols-7 justify-items-center calendar-content" }, Hl = /* @__PURE__ */ _({
  __name: "CalendarMonth",
  props: {
    currentSelectedDate: {
      type: Date,
      required: !0
    },
    selectedDate: {
      type: Date,
      default: void 0
    },
    minDate: {
      type: Date,
      default: null
    },
    maxDate: {
      type: Date,
      default: null
    }
  },
  emits: [
    "previous-month-date-selected",
    "current-month-date-selected",
    "next-month-date-selected"
  ],
  setup(e) {
    const n = e, t = xe(ua), a = xe(ca), o = T(() => {
      if (!(!t || !a) && !(!t.value && !a.value)) {
        if (!n.selectedDate)
          return t.value ? t.value : a.value ? a.value : void 0;
        if (t.value && a.value)
          return me(n.selectedDate, t.value) ? a.value : t.value;
      }
    }), s = T(() => Fl(n.currentSelectedDate)), i = T(() => Ol(n.currentSelectedDate)), d = T(() => Pl(n.currentSelectedDate));
    function r(y) {
      if (!n.selectedDate || !o.value)
        return !1;
      const w = Nl(n.selectedDate, o.value);
      return me(y, w);
    }
    function p(y) {
      if (!n.selectedDate || !o.value)
        return !1;
      const w = zl(n.selectedDate, o.value);
      return me(y, w);
    }
    function h(y) {
      const w = p(y), v = r(y);
      return !w && !v || w && v || !n.selectedDate || !o.value ? "" : w ? "rounded-l-none!" : v ? "rounded-r-none!" : "";
    }
    function b(y) {
      return o.value && me(y, o.value) || n.selectedDate && me(y, n.selectedDate);
    }
    return (y, w) => (l(), g("div", Vl, [
      (l(!0), g(Y, null, J(s.value, (v) => (l(), P(ut, {
        key: `${v.getDate()}-${v.getMonth() + 1}-${v.getFullYear()}`,
        "is-active": b(v),
        class: I([h(v)]),
        "is-in-selected-range": u(ct)(v, o.value, e.selectedDate),
        "data-testid": `CalendarDay_prevMonth_day_${v}`,
        "outside-of-current-month": "",
        disabled: !u(Le)(v, { minDate: e.minDate, maxDate: e.maxDate }),
        onDateSelected: (f) => y.$emit("previous-month-date-selected", v.getDate())
      }, {
        default: A(() => [
          X(H(`${v.getDate()}`), 1)
        ]),
        _: 2
      }, 1032, ["is-active", "class", "is-in-selected-range", "data-testid", "disabled", "onDateSelected"]))), 128)),
      (l(!0), g(Y, null, J(i.value, (v) => (l(), P(ut, {
        key: `${v.getDate()}-${v.getMonth() + 1}-${v.getFullYear()}`,
        "data-testid": `CalendarDay_currentMonth_day_${v.getDate()}`,
        "is-active": b(v),
        class: I([h(v)]),
        "is-in-selected-range": u(ct)(v, o.value, e.selectedDate),
        disabled: !u(Le)(v, { minDate: e.minDate, maxDate: e.maxDate }),
        onDateSelected: (f) => y.$emit("current-month-date-selected", v)
      }, {
        default: A(() => [
          X(H(`${v.getDate()}`), 1)
        ]),
        _: 2
      }, 1032, ["data-testid", "is-active", "class", "is-in-selected-range", "disabled", "onDateSelected"]))), 128)),
      (l(!0), g(Y, null, J(d.value, (v) => (l(), P(ut, {
        key: `${v.getDate()}-${v.getMonth() + 1}-${v.getFullYear()}`,
        "data-testid": `CalendarDay_nextMonth_day_${v}`,
        "is-active": b(v),
        class: I([h(v)]),
        "is-in-selected-range": u(ct)(v, o.value, e.selectedDate),
        "outside-of-current-month": "",
        disabled: !u(Le)(v, { minDate: e.minDate, maxDate: e.maxDate }),
        onDateSelected: (f) => y.$emit("next-month-date-selected", v.getDate())
      }, {
        default: A(() => [
          X(H(`${v.getDate()}`), 1)
        ]),
        _: 2
      }, 1032, ["data-testid", "is-active", "class", "is-in-selected-range", "disabled", "onDateSelected"]))), 128))
    ]));
  }
}), ma = (e) => (De("data-v-a9dacef7"), e = e(), Ae(), e), Rl = { class: "flex justify-between mb-2" }, ql = ["disabled"], Wl = /* @__PURE__ */ ma(() => /* @__PURE__ */ c("span", { class: "bi bi-chevron-left" }, null, -1)), jl = [
  Wl
], Yl = { class: "font-bold text-base-1000 dark:text-base-100" }, Kl = ["disabled"], Ul = /* @__PURE__ */ ma(() => /* @__PURE__ */ c("span", { class: "bi bi-chevron-right" }, null, -1)), Jl = [
  Ul
], Gl = { class: "grid grid-cols-4 gap-2 justify-items-center month-content" }, Ql = /* @__PURE__ */ _({
  __name: "CalendarMonthList",
  props: {
    currentSelectedDate: {
      type: Date,
      required: !0
    },
    selectedDate: {
      type: Date,
      required: !0
    },
    canGoToPreviousMonth: {
      type: Boolean
    },
    canGoToNextMonth: {
      type: Boolean
    },
    minDate: {
      type: Date,
      default: null
    },
    maxDate: {
      type: Date,
      default: null
    }
  },
  emits: [
    "set-previous-year",
    "set-next-year",
    "change-mode",
    "update-calendar-view"
  ],
  setup(e) {
    const { t: n } = te(), t = e, a = T(() => El(t.currentSelectedDate)), o = Object.values(Tt), s = T(() => t.currentSelectedDate.getFullYear());
    return (i, d) => (l(), g("div", null, [
      c("div", Rl, [
        c("button", {
          class: "change-chevron",
          type: "button",
          "data-testid": "previousMonth",
          disabled: !e.canGoToPreviousMonth,
          onClick: d[0] || (d[0] = (r) => i.$emit("set-previous-year"))
        }, jl, 8, ql),
        L(re, {
          size: "md",
          color: "secondary",
          mode: "transparent",
          onClick: d[1] || (d[1] = (r) => i.$emit("change-mode", "year"))
        }, {
          default: A(() => [
            c("span", Yl, H(`${s.value}`), 1)
          ]),
          _: 1
        }),
        c("button", {
          class: "change-chevron",
          type: "button",
          "data-testid": "nextMonth",
          disabled: !e.canGoToNextMonth,
          onClick: d[2] || (d[2] = (r) => i.$emit("set-next-year"))
        }, Jl, 8, Kl)
      ]),
      c("div", Gl, [
        (l(!0), g(Y, null, J(a.value, (r) => (l(), P(re, {
          key: `${r.getDate()}-${r.getMonth() + 1}-${r.getFullYear()}`,
          mode: u(tt)(r, e.selectedDate) ? "filled" : "transparent",
          color: u(tt)(r, e.selectedDate) ? "primary" : "secondary",
          disabled: !u(Le)(r, { minDate: e.minDate, maxDate: e.maxDate }),
          class: I([
            { active: u(tt)(r, e.selectedDate) }
          ]),
          onClick: (p) => i.$emit("update-calendar-view", { selected: r, type: "date" })
        }, {
          default: A(() => [
            X(H(`${u(n)(u(o)[r.getMonth()]).substring(0, 3)}`), 1)
          ]),
          _: 2
        }, 1032, ["mode", "color", "disabled", "class", "onClick"]))), 128))
      ])
    ]));
  }
});
const Xl = /* @__PURE__ */ ee(Ql, [["__scopeId", "data-v-a9dacef7"]]), Zl = { class: "flex justify-between mb-2" }, er = ["disabled"], tr = /* @__PURE__ */ c("span", { class: "bi bi-chevron-left" }, null, -1), ar = [
  tr
], or = { class: "font-bold text-base-1000 dark:text-base-100" }, nr = ["disabled"], sr = /* @__PURE__ */ c("span", { class: "bi bi-chevron-right" }, null, -1), ir = [
  sr
], lr = { class: "grid grid-cols-7 justify-items-center mb-3" }, rr = { class: "font-bold" }, dr = /* @__PURE__ */ _({
  __name: "CalendarWeekDay",
  props: {
    currentSelectedDate: {
      type: Date,
      required: !0
    },
    canGoToPreviousMonth: {
      type: Boolean
    },
    canGoToNextMonth: {
      type: Boolean
    },
    minDate: {
      type: Date,
      default: null
    },
    maxDate: {
      type: Date,
      default: null
    }
  },
  emits: [
    "set-previous-month",
    "set-next-month",
    "change-mode",
    "update-calendar-view"
  ],
  setup(e) {
    const n = e, { t } = te(), a = Object.values(Tt), o = Object.values(da), s = T(() => n.currentSelectedDate.getMonth()), i = T(() => n.currentSelectedDate.getFullYear());
    return (d, r) => (l(), g(Y, null, [
      c("div", Zl, [
        c("button", {
          class: "change-chevron ml-3",
          type: "button",
          "data-testid": "previousMonth",
          disabled: !e.canGoToPreviousMonth,
          onClick: r[0] || (r[0] = (p) => d.$emit("set-previous-month"))
        }, ar, 8, er),
        L(re, {
          size: "md",
          color: "secondary",
          mode: "transparent",
          onClick: r[1] || (r[1] = (p) => d.$emit("change-mode", "month"))
        }, {
          default: A(() => [
            c("span", or, H(`${u(t)(u(a)[s.value])} ${i.value}`), 1)
          ]),
          _: 1
        }),
        c("button", {
          class: "change-chevron mr-3",
          type: "button",
          "data-testid": "nextMonth",
          disabled: !e.canGoToNextMonth,
          onClick: r[2] || (r[2] = (p) => d.$emit("set-next-month"))
        }, ir, 8, nr)
      ]),
      c("div", lr, [
        (l(!0), g(Y, null, J(u(o), (p) => (l(), g("div", { key: p }, [
          c("span", rr, H(u(t)(p)), 1)
        ]))), 128))
      ])
    ], 64));
  }
}), pa = (e) => (De("data-v-1e1e33a0"), e = e(), Ae(), e), ur = { class: "flex justify-between mb-2" }, cr = ["disabled"], mr = /* @__PURE__ */ pa(() => /* @__PURE__ */ c("span", { class: "bi bi-chevron-left" }, null, -1)), pr = [
  mr
], gr = { class: "font-bold my-2" }, fr = ["disabled"], hr = /* @__PURE__ */ pa(() => /* @__PURE__ */ c("span", { class: "bi bi-chevron-right" }, null, -1)), br = [
  hr
], vr = { class: "grid grid-cols-4 gap-2 justify-items-center text-ellipsis year-content" }, yr = /* @__PURE__ */ _({
  __name: "CalendarYearList",
  props: {
    currentSelectedDate: {
      type: Date,
      required: !0
    },
    selectedDate: {
      type: Date,
      required: !0
    },
    canGoToPreviousMonth: {
      type: Boolean
    },
    canGoToNextMonth: {
      type: Boolean
    },
    minDate: {
      type: Date,
      default: null
    },
    maxDate: {
      type: Date,
      default: null
    }
  },
  emits: [
    "set-previous-decade",
    "set-next-decade",
    "change-mode",
    "update-calendar-view"
  ],
  setup(e) {
    const n = e, t = T(() => _l(n.currentSelectedDate)), a = T(() => n.currentSelectedDate.getFullYear() - n.currentSelectedDate.getFullYear() % 10), o = T(() => a.value + 10);
    return (s, i) => (l(), g("div", null, [
      c("div", ur, [
        c("button", {
          class: "change-chevron",
          type: "button",
          "data-testid": "previousMonth",
          disabled: !e.canGoToPreviousMonth,
          onClick: i[0] || (i[0] = (d) => s.$emit("set-previous-decade"))
        }, pr, 8, cr),
        c("span", gr, H(`${a.value} - ${o.value}`), 1),
        c("button", {
          class: "change-chevron",
          type: "button",
          "data-testid": "nextMonth",
          disabled: !e.canGoToNextMonth,
          onClick: i[1] || (i[1] = (d) => s.$emit("set-next-decade"))
        }, br, 8, fr)
      ]),
      c("div", vr, [
        (l(!0), g(Y, null, J(t.value, (d) => (l(), P(re, {
          key: `${d.getDate()}-${d.getMonth() + 1}-${d.getFullYear()}`,
          mode: u(at)(d, e.selectedDate) ? "filled" : "transparent",
          color: u(at)(d, e.selectedDate) ? "primary" : "secondary",
          class: I([
            { active: u(at)(d, e.selectedDate) }
          ]),
          disabled: !u(Le)(d, { minDate: e.minDate, maxDate: e.maxDate }),
          onClick: (r) => s.$emit("update-calendar-view", { selected: d, type: "month" })
        }, {
          default: A(() => [
            X(H(`${d.getFullYear()}`), 1)
          ]),
          _: 2
        }, 1032, ["mode", "color", "class", "disabled", "onClick"]))), 128))
      ])
    ]));
  }
});
const kr = /* @__PURE__ */ ee(yr, [["__scopeId", "data-v-1e1e33a0"]]), wr = {
  "data-testid": "cb__calendar",
  class: "px-5 py-3 max-w-sm"
}, xr = { key: 0 }, Sr = /* @__PURE__ */ _({
  __name: "CbCalendar",
  props: {
    initialValue: {
      type: Date,
      default: null
    },
    minDate: {
      type: Date,
      default: null
    },
    maxDate: {
      type: Date,
      default: null
    }
  },
  emits: [
    "selected"
  ],
  setup(e, { emit: n }) {
    const t = e, a = n, o = D(t.initialValue ? new Date(t.initialValue) : /* @__PURE__ */ new Date());
    o.value.setHours(0, 0, 0, 0), t.minDate && !t.initialValue && t.minDate > o.value && (o.value = t.minDate);
    const s = D(t.initialValue || null), i = D("date");
    function d() {
      o.value = Pt(o.value, -1);
    }
    function r() {
      o.value = Pt(o.value, 1);
    }
    function p() {
      o.value = Ye(o.value, -1);
    }
    function h() {
      o.value = Ye(o.value, 1);
    }
    function b() {
      o.value = Ye(o.value, -10);
    }
    function y() {
      o.value = Ye(o.value, 10);
    }
    function w($, F) {
      o.value = $, i.value = F;
    }
    function v($) {
      s.value = $, a("selected", $);
    }
    function f($) {
      r();
      const F = o.value.setDate($);
      v(new Date(F));
    }
    function m($) {
      d();
      const F = o.value.setDate($);
      v(new Date(F));
    }
    const k = T(() => t.minDate ? Ft(o.value, t.minDate) > 0 : !0), x = T(() => t.maxDate ? Ft(o.value, t.maxDate) < 0 : !0);
    return K(() => t.initialValue, ($) => {
      s.value = $ || null, o.value = !s.value && t.minDate ? t.minDate : new Date($);
    }), ($, F) => (l(), g("div", wr, [
      L(Kt, {
        name: "dissolve",
        tag: "div"
      }, {
        default: A(() => [
          i.value === "date" ? (l(), g("div", xr, [
            L(dr, {
              "current-selected-date": o.value,
              "max-date": e.maxDate,
              "min-date": e.minDate,
              "can-go-to-next-month": x.value,
              "can-go-to-previous-month": k.value,
              onSetPreviousMonth: d,
              onChangeMode: F[0] || (F[0] = (S) => i.value = S),
              onSetNextMonth: r
            }, null, 8, ["current-selected-date", "max-date", "min-date", "can-go-to-next-month", "can-go-to-previous-month"]),
            L(Hl, {
              "current-selected-date": o.value,
              "selected-date": s.value,
              "max-date": e.maxDate,
              "min-date": e.minDate,
              onPreviousMonthDateSelected: F[1] || (F[1] = (S) => m(S)),
              onCurrentMonthDateSelected: F[2] || (F[2] = (S) => v(S)),
              onNextMonthDateSelected: F[3] || (F[3] = (S) => f(S))
            }, null, 8, ["current-selected-date", "selected-date", "max-date", "min-date"])
          ])) : E("", !0),
          i.value === "month" ? (l(), P(Xl, {
            key: 1,
            "selected-date": s.value,
            "selection-mode": i.value,
            "can-go-to-next-month": x.value,
            "can-go-to-previous-month": k.value,
            "min-date": e.minDate,
            "max-date": e.maxDate,
            "current-selected-date": o.value,
            onSetPreviousYear: p,
            onSetNextYear: h,
            onChangeMode: F[4] || (F[4] = (S) => i.value = S),
            onUpdateCalendarView: F[5] || (F[5] = ({ selected: S, type: R }) => w(S, R))
          }, null, 8, ["selected-date", "selection-mode", "can-go-to-next-month", "can-go-to-previous-month", "min-date", "max-date", "current-selected-date"])) : E("", !0),
          i.value === "year" ? (l(), P(kr, {
            key: 2,
            "selected-date": s.value,
            "selection-mode": i.value,
            "can-go-to-next-month": x.value,
            "can-go-to-previous-month": k.value,
            "min-date": e.minDate,
            "max-date": e.maxDate,
            "current-selected-date": o.value,
            onSetPreviousDecade: b,
            onSetNextYear: y,
            onUpdateCalendarView: F[6] || (F[6] = ({ selected: S, type: R }) => w(S, R))
          }, null, 8, ["selected-date", "selection-mode", "can-go-to-next-month", "can-go-to-previous-month", "min-date", "max-date", "current-selected-date"])) : E("", !0)
        ]),
        _: 1
      })
    ]));
  }
});
const $r = /* @__PURE__ */ ee(Sr, [["__scopeId", "data-v-2dffcd8d"]]), ht = /* @__PURE__ */ _({
  __name: "CbCalendarDropdown",
  props: {
    initialValue: {
      type: Date,
      default: null
    },
    minDate: {
      type: Date,
      default: null
    },
    maxDate: {
      type: Date,
      default: null
    },
    openPosition: {
      type: String,
      default: "left",
      validator: (e) => ["left", "right"].includes(e)
    },
    openDirection: {
      type: String,
      default: "bottom",
      validator: (e) => ["top", "bottom"].includes(e)
    },
    preventCloseOnTriggerClick: {
      type: Boolean
    }
  },
  emits: [
    "selected"
  ],
  setup(e, { emit: n }) {
    const t = e, a = n;
    return (o, s) => (l(), P(We, {
      "open-position": e.openPosition,
      "open-direction": e.openDirection,
      "close-on-scroll": "",
      "close-on-outside": "",
      "prevent-close-on-trigger-click": e.preventCloseOnTriggerClick
    }, {
      button: A(() => [
        N(o.$slots, "default")
      ]),
      menu: A(() => [
        L(Te, null, {
          default: A(() => [
            L($r, {
              "max-date": t.maxDate,
              "min-date": t.minDate,
              "initial-value": t.initialValue,
              onSelected: s[0] || (s[0] = (i) => a("selected", i))
            }, null, 8, ["max-date", "min-date", "initial-value"])
          ]),
          _: 1
        })
      ]),
      _: 3
    }, 8, ["open-position", "open-direction", "prevent-close-on-trigger-click"]));
  }
}), Cr = { class: "flex" }, Dr = ["data-testid"], ze = "yyyy-MM-dd", Ar = /* @__PURE__ */ _({
  __name: "CbCalendarRange",
  props: {
    id: {
      type: String,
      required: !0
    },
    label: {
      type: String,
      default: void 0
    },
    minDate: {
      type: Date,
      default: null
    },
    maxDate: {
      type: Date,
      default: null
    },
    startDateInputAttrs: {
      type: Object,
      default: void 0
    },
    endDateInputAttrs: {
      type: Object,
      default: void 0
    },
    initialStartDate: {
      type: Date,
      default: void 0
    },
    initialEndDate: {
      type: Date,
      default: void 0
    }
  },
  emits: [
    "selected-start-date",
    "selected-end-date"
  ],
  setup(e, { emit: n }) {
    const t = n, a = e, o = D(a.initialStartDate ? Me(a.initialStartDate, ze) : void 0), s = D(a.initialEndDate ? Me(a.initialEndDate, ze) : void 0), i = T(() => `${a.id}_dateRange_inDate`), d = T(() => `${a.id}_dateRange_outDate`), r = T(() => o.value ? new Date(o.value) : void 0), p = T(() => s.value ? new Date(s.value) : void 0);
    we(ua, r), we(ca, p);
    const h = D(!1), b = D(null);
    function y() {
      var f, m;
      (f = document.getElementById(d.value)) == null || f.click(), (m = document.getElementById(d.value)) == null || m.focus();
    }
    function w(f) {
      b.value && clearTimeout(b.value);
      const m = Lt("startDate"), k = Me(f, ze);
      o.value = k, m == null || m.input(k), t("selected-start-date", k), b.value = setTimeout(() => {
        y(), b.value = null;
      }, 0);
    }
    function v(f) {
      const m = Lt(d.value), k = Me(f, ze);
      s.value = k, m == null || m.input(k), t("selected-end-date", k);
    }
    return (f, m) => {
      const k = pe("FormKit");
      return l(), g("div", Cr, [
        L(ht, {
          "initial-value": o.value ? new Date(o.value) : e.initialStartDate,
          "max-date": s.value ? new Date(s.value) : e.maxDate,
          "min-date": e.minDate,
          "prevent-close-on-trigger-click": "",
          onSelected: m[4] || (m[4] = (x) => w(u(Me)(x, ze)))
        }, {
          default: A(() => [
            L(k, {
              id: i.value,
              modelValue: o.value,
              "onUpdate:modelValue": m[0] || (m[0] = (x) => o.value = x),
              "data-testid": i.value,
              label: e.label,
              "v-bind": e.startDateInputAttrs,
              type: "date",
              max: "3000-12-12",
              onClick: m[1] || (m[1] = ie((x) => {
                var $;
                h.value = !0, ($ = x.target) == null || $.focus();
              }, ["prevent"])),
              onFocus: m[2] || (m[2] = (x) => h.value = !0),
              onBlur: m[3] || (m[3] = (x) => h.value = !1)
            }, null, 8, ["id", "modelValue", "data-testid", "label", "v-bind"])
          ]),
          _: 1
        }, 8, ["initial-value", "max-date", "min-date"]),
        c("i", {
          "data-testid": `${e.id}_CalendarRange_arrow`,
          class: I([
            "bi dark:bg-base-1000 bi-arrow-right px-5 py-2 -mx-1 bg-white border-l-0 border-r-0 z-10 inline-block relative fake-input-shadow",
            { active: h.value }
          ])
        }, null, 10, Dr),
        L(ht, {
          "initial-value": s.value ? new Date(s.value) : e.initialEndDate,
          "max-date": e.maxDate,
          "min-date": o.value ? new Date(o.value) : e.minDate,
          "prevent-close-on-trigger-click": "",
          onSelected: m[9] || (m[9] = (x) => v(x))
        }, {
          default: A(() => [
            L(k, {
              id: d.value,
              modelValue: s.value,
              "onUpdate:modelValue": m[5] || (m[5] = (x) => s.value = x),
              "data-testid": d.value,
              "v-bind": e.endDateInputAttrs,
              type: "date",
              max: "3000-12-12",
              onClick: m[6] || (m[6] = ie((x) => {
                var $;
                h.value = !0, ($ = x.target) == null || $.focus();
              }, ["prevent"])),
              onFocus: m[7] || (m[7] = (x) => h.value = !0),
              onBlur: m[8] || (m[8] = (x) => h.value = !1)
            }, null, 8, ["id", "modelValue", "data-testid", "v-bind"])
          ]),
          _: 1
        }, 8, ["initial-value", "max-date", "min-date"])
      ]);
    };
  }
});
const Hm = /* @__PURE__ */ ee(Ar, [["__scopeId", "data-v-2d5d915f"]]), Tr = /* @__PURE__ */ _({
  __name: "CbChartBar",
  props: {
    datasets: {
      type: Object,
      required: !0
    },
    mode: {
      type: String,
      default: "light"
    },
    labels: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ""
    },
    hideLegend: {
      type: Boolean
    }
  },
  setup(e) {
    oe.register(...Qe);
    const n = e, t = {
      responsive: !0,
      maintainAspectRatio: !1,
      plugins: {
        title: {
          display: n.title !== "",
          text: n.title
        },
        legend: {
          display: !n.hideLegend && n.datasets.some((d) => d.label)
        }
      }
    }, a = {
      type: "bar",
      options: $e(t),
      data: {
        datasets: $e(n.datasets),
        labels: Je(n.labels)
      }
    }, o = () => {
      if (n.mode === "dark") {
        const d = "#F7F7F7", r = "rgba(255,255,255,0.4)";
        oe.defaults.borderColor = r, oe.defaults.color = d;
      } else {
        const d = "#666", r = "rgba(0,0,0,0.1)";
        oe.defaults.borderColor = r, oe.defaults.color = d;
      }
    }, s = D();
    let i;
    return ne(() => {
      o(), i = new oe(s.value, a);
    }), Ee(() => {
      i.destroy();
    }), (d, r) => (l(), g("canvas", {
      ref_key: "chartCanvas",
      ref: s,
      "data-testid": "CbChartBar"
    }, null, 512));
  }
}), Mr = /* @__PURE__ */ _({
  __name: "CbChartPie",
  props: {
    datasets: {
      type: Object,
      required: !0
    },
    mode: {
      type: String,
      default: "light"
    },
    labels: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ""
    },
    hideLegend: {
      type: Boolean
    }
  },
  setup(e) {
    oe.register(...Qe);
    const n = e, t = {
      responsive: !0,
      maintainAspectRatio: !1,
      plugins: {
        title: {
          display: n.title !== "",
          text: n.title
        },
        legend: {
          display: !n.hideLegend && n.datasets.some((d) => d.label)
        }
      }
    }, a = {
      type: "pie",
      options: $e(t),
      data: {
        datasets: $e(n.datasets),
        labels: Je(n.labels)
      }
    }, o = () => {
      if (n.mode === "dark") {
        const d = "#F7F7F7";
        oe.defaults.color = d;
      } else {
        const d = "#666";
        oe.defaults.color = d;
      }
    }, s = D();
    let i;
    return ne(() => {
      o(), i = new oe(s.value, a);
    }), Ee(() => {
      i.destroy();
    }), (d, r) => (l(), g("canvas", {
      ref_key: "chartCanvas",
      ref: s,
      "data-testid": "CbChartPie"
    }, null, 512));
  }
}), Ir = /* @__PURE__ */ _({
  __name: "CbChartDoughnut",
  props: {
    datasets: {
      type: Object,
      required: !0
    },
    mode: {
      type: String,
      default: "light"
    },
    labels: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ""
    },
    hideLegend: {
      type: Boolean
    }
  },
  emits: ["selected"],
  setup(e, { emit: n }) {
    oe.register(...Qe);
    const t = e, a = n, o = {
      responsive: !0,
      maintainAspectRatio: !1,
      plugins: {
        title: {
          display: t.title !== "",
          text: t.title
        },
        legend: {
          display: !t.hideLegend && t.datasets.some((h) => h.label)
        }
      }
    }, s = {
      type: "doughnut",
      options: $e(o),
      data: {
        datasets: $e(t.datasets),
        labels: Je(t.labels)
      }
    }, i = () => {
      if (t.mode === "dark") {
        const h = "#F7F7F7";
        oe.defaults.color = h;
      } else {
        const h = "#666";
        oe.defaults.color = h;
      }
    }, d = D();
    let r;
    ne(() => {
      i(), r = new oe(d.value, s);
    }), Ee(() => {
      r.destroy();
    });
    function p(h) {
      const b = r.getElementsAtEventForMode(h, "nearest", { intersect: !0 }, !0);
      b.length > 0 && a("selected", b[0].index);
    }
    return (h, b) => (l(), g("canvas", {
      ref_key: "chartCanvas",
      ref: d,
      "data-testid": "CbChartDoughnut",
      onClick: p,
      onKeypress: () => {
      }
    }, null, 544));
  }
}), Lr = /* @__PURE__ */ _({
  __name: "CbChartLine",
  props: {
    datasets: {
      type: Object,
      required: !0
    },
    mode: {
      type: String,
      default: "light"
    },
    labels: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ""
    },
    hideLegend: {
      type: Boolean
    }
  },
  setup(e) {
    oe.register(...Qe);
    const n = e, t = {
      responsive: !0,
      maintainAspectRatio: !1,
      plugins: {
        title: {
          display: n.title !== "",
          text: n.title
        },
        legend: {
          display: !n.hideLegend && n.datasets.some((d) => d.label)
        }
      }
    }, a = {
      type: "line",
      options: $e(t),
      data: {
        datasets: $e(n.datasets),
        labels: Je(n.labels)
      }
    }, o = () => {
      if (n.mode === "dark") {
        const d = "#F7F7F7", r = "rgba(255,255,255,0.4)";
        oe.defaults.borderColor = r, oe.defaults.color = d;
      } else {
        const d = "#666", r = "rgba(0,0,0,0.1)";
        oe.defaults.borderColor = r, oe.defaults.color = d;
      }
    }, s = D();
    let i;
    return ne(() => {
      o(), i = new oe(s.value, a);
    }), Ee(() => {
      i.destroy();
    }), (d, r) => (l(), g("canvas", {
      ref_key: "chartCanvas",
      ref: s,
      "data-testid": "CbChartLine"
    }, null, 512));
  }
}), Fr = { class: "relative" }, Rm = /* @__PURE__ */ _({
  __name: "CbChart",
  props: {
    type: {
      type: String,
      default: "pie",
      validator: (e) => ["bar", "line", "pie", "doughnut"].includes(e)
    },
    datasets: {
      type: Object,
      required: !0
    },
    labels: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ""
    },
    hideLegend: {
      type: Boolean
    }
  },
  emits: ["selected"],
  setup(e, { emit: n }) {
    const t = {
      bar: Tr,
      pie: Mr,
      doughnut: Ir,
      line: Lr
    }, a = e, o = T(() => a.datasets.every((w) => w.data.every((v) => v === 0))), s = ue(() => import("./vendor/chartjs-7f52c419.js").then((w) => w.e)), i = n, d = document.documentElement, r = D(d.className), p = { attributes: !0 }, h = () => {
      r.value = d.className;
    }, b = new MutationObserver(h);
    ne(() => {
      b.observe(d, p);
    }), Ee(() => {
      b.disconnect();
    });
    const y = D(Se());
    return K([
      () => a.datasets,
      () => a.labels,
      () => a.title,
      () => a.hideLegend,
      () => r.value
    ], (w, v) => {
      za(w, v) || (y.value = Se());
    }), (w, v) => (l(), g("div", Fr, [
      o.value ? (l(), P(de(u(s)), {
        key: 1,
        class: "w-full h-full"
      })) : (l(), P(de(t[e.type]), {
        key: y.value,
        datasets: e.datasets,
        labels: e.labels,
        mode: r.value,
        title: e.title,
        "hide-legend": e.hideLegend,
        onSelected: v[0] || (v[0] = (f) => i("selected", f))
      }, null, 40, ["datasets", "labels", "mode", "title", "hide-legend"]))
    ]));
  }
}), Pr = { "data-testid": "triggerWrapper" }, Or = { class: "inner z-10" }, Er = /* @__PURE__ */ _({
  __name: "CbTooltip",
  props: {
    mode: {
      type: String,
      default: "hover",
      validator: (e) => ["hover", "click", "manual"].includes(e)
    },
    modelValue: {
      type: Boolean
    },
    placement: {
      type: String,
      default: "top",
      validator: (e) => [
        "top",
        "top-left",
        "top-right",
        "right",
        "bottom",
        "bottom-left",
        "bottom-right",
        "left"
      ].includes(e)
    },
    size: {
      type: String,
      default: "medium",
      validator: (e) => ["medium", "small"].includes(e)
    },
    status: {
      type: String,
      default: "default",
      validator: (e) => ["default", "highlight"].includes(e)
    },
    minWidth: {
      type: Number,
      default: 0
    },
    maxWidth: {
      type: Number,
      default: 0
    },
    nowrap: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    }
  },
  emits: [
    "visible"
  ],
  setup(e, { emit: n }) {
    const t = e, a = n, o = D(!1), s = D(), i = D(), d = D(), r = T(() => t.mode === "hover"), p = T(() => t.mode === "click"), h = T(() => t.mode === "manual"), b = T(() => t.placement.includes("-left")), y = T(() => t.placement.includes("-right")), {
      height: w,
      width: v
    } = Ie(d), {
      top: f,
      bottom: m,
      left: k,
      right: x,
      width: $,
      update: F
    } = Ie(i, { updateTiming: "next-frame" }), S = T(() => t.placement.includes("bottom") ? `calc(${u(m)}px + 0.65rem)` : t.placement.includes("top") ? `calc(${u(f) - u(w)}px - 0.65rem)` : `${(u(m) + u(f)) * 0.5 - u(w) * 0.5}px`), R = T(() => t.placement.includes("left") ? `calc(${u(k) - u(v)}px - 0.65rem)` : t.placement.includes("right") ? `calc(${u(x)}px + 0.65rem)` : `calc(${(u(k) + u(x)) * 0.5 - u(v) * 0.5}px)`), B = T(() => {
      const W = u($) / 2, j = 2.75;
      return b.value ? `translateX(calc(${W}px + ${j}rem))` : y.value ? `translateX(calc(-${W}px - ${j}rem))` : "";
    }), U = T(() => ({
      ...t.minWidth > 0 && { minWidth: `${t.minWidth}px` },
      ...t.maxWidth > 0 && { maxWidth: `${t.maxWidth}px` },
      ...t.nowrap && { whiteSpace: "nowrap" },
      left: R.value,
      top: S.value,
      transform: B.value
    }));
    function M() {
      !o.value && !t.disabled && (F(), o.value = !0, a("visible", !0));
    }
    function q() {
      o.value && (o.value = !1, a("visible", !1));
    }
    function G(W) {
      var ae;
      const j = r.value && W.type === "mouseleave", Q = p.value && W.type === "click" && !((ae = s.value) != null && ae.contains(W.target));
      (j || Q) && q();
    }
    function V(W) {
      if (r.value) {
        W.type === "mouseover" && M();
        return;
      }
      p.value && W.type === "click" && (o.value ? q() : M());
    }
    return K(() => t.modelValue, (W) => {
      W && h.value && !t.disabled ? M() : !W && (h.value || p.value) && q();
    }), ne(() => {
      h.value && t.modelValue && M(), document.addEventListener("click", G, !1);
    }), Ce(() => {
      document.removeEventListener("click", G, !1);
    }), (W, j) => (l(), g(Y, null, [
      c("div", {
        ref_key: "tooltipWrapper",
        ref: s,
        "data-testid": "tooltipWrapper",
        class: "relative"
      }, [
        c("div", {
          ref_key: "triggerWrapper",
          ref: i,
          class: I([
            "trigger",
            { "select-none": e.disabled }
          ]),
          "data-testid": "tooltipTrigger",
          onMouseover: V,
          onFocusin: V,
          onMouseleave: G,
          onFocusout: G,
          onClick: V,
          onKeypress: V
        }, [
          c("div", Pr, [
            N(W.$slots, "trigger", {}, void 0, !0)
          ])
        ], 34)
      ], 512),
      (l(), P(Ge, { to: "body" }, [
        Jt(c("div", {
          ref_key: "tooltipElement",
          ref: d,
          "data-testid": "tooltipElement",
          class: I(`cb-tooltip ${e.placement} balloon ${e.size} ${e.status}`),
          style: le(U.value)
        }, [
          c("div", Or, [
            N(W.$slots, "tooltip", {}, void 0, !0)
          ]),
          c("div", {
            class: I(`cb-tooltip-arrow ${e.placement}`)
          }, null, 2)
        ], 6), [
          [Gt, o.value]
        ])
      ]))
    ], 64));
  }
});
const ga = /* @__PURE__ */ ee(Er, [["__scopeId", "data-v-c2fa6eff"]]), _r = { class: "flex items-center" }, Nr = { class: "flex" }, zr = {
  key: 0,
  class: "bi bi-copy mr-2"
}, Br = {
  key: 1,
  class: "bi bi-check-lg mr-2"
}, Vr = /* @__PURE__ */ _({
  __name: "CbCopyToClipboard",
  setup(e) {
    const { t: n } = te(), {
      copy: t,
      copied: a,
      isSupported: o
    } = eo({ legacy: !0 }), s = D(null), { content: i } = Ba(s);
    return (d, r) => (l(), g("div", _r, [
      c("span", {
        ref_key: "copyElementRef",
        ref: s,
        class: "cb__slotSpace"
      }, [
        N(d.$slots, "default", {}, void 0, !0)
      ], 512),
      L(ga, {
        modelValue: u(a),
        "onUpdate:modelValue": r[1] || (r[1] = (p) => Ya(a) ? a.value = p : null),
        mode: "manual",
        status: "highlight",
        disabled: !u(o)
      }, {
        trigger: A(() => [
          L(re, {
            class: "cb__clipboardButton",
            size: "sm",
            mode: "transparent",
            color: "secondary",
            disabled: !u(o),
            onClick: r[0] || (r[0] = (p) => u(t)(u(i)))
          }, {
            default: A(() => [
              c("span", Nr, [
                u(a) ? (l(), g("i", Br)) : (l(), g("i", zr)),
                c("span", null, H(u(n)("Copy")), 1)
              ])
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        tooltip: A(() => [
          X(H(u(n)("Copied!")), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "disabled"])
    ]));
  }
});
const qm = /* @__PURE__ */ ee(Vr, [["__scopeId", "data-v-bc0551a4"]]);
const Hr = /* @__PURE__ */ _({
  __name: "CbCountryFlag",
  props: {
    country: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    return (n, t) => e.country ? (l(), g("span", {
      key: 0,
      "data-testid": "countryFlag",
      class: I(`flag:${e.country} flex items-center`)
    }, null, 2)) : E("", !0);
  }
}), Wm = /* @__PURE__ */ _({
  __name: "CbDraggable",
  props: {
    tag: {},
    itemKey: {},
    modelValue: {},
    config: {}
  },
  emits: [
    "choose",
    "unchoose",
    "start",
    "end",
    "add",
    "update",
    "sort",
    "remove",
    "filter",
    "move",
    "clone",
    "change",
    "update:modelValue"
  ],
  setup(e, { emit: n }) {
    const t = e, a = D(), o = D(), s = n;
    function i(r) {
      const p = [...t.modelValue];
      r(p), s("update:modelValue", p);
    }
    function d(r, p) {
      i((h) => h.splice(p, 0, h.splice(r, 1)[0]));
    }
    return ne(() => {
      a.value && (o.value = Va.create(a.value, {
        animation: 150,
        handle: ".handle",
        ...t.config,
        // Don't move from here (will override defaults but not events)
        forceFallback: !0,
        // This along adding class to hmtl tag avoids issues with grab icon
        onChoose: (r) => {
          document.documentElement.classList.add("cursor-grabbing"), s("choose", r);
        },
        onUnchoose: (r) => {
          document.documentElement.classList.remove("cursor-grabbing"), s("unchoose", r);
        },
        onStart: (r) => {
          s("start", r);
        },
        onEnd: (r) => {
          document.documentElement.classList.remove("cursor-grabbing"), s("end", r);
        },
        onAdd: (r) => {
          s("add", r);
        },
        onUpdate: (r) => {
          s("update", r);
          const { oldIndex: p, newIndex: h } = r;
          typeof p == "number" && typeof h == "number" && d(p, h);
        },
        onSort: (r) => {
          s("sort", r);
        },
        onRemove: (r) => {
          s("remove", r);
        },
        onFilter: (r) => {
          s("filter", r);
        },
        onMove: (r, p) => {
          s("move", { event: r, originalEvent: p });
        },
        onClone: (r) => {
          s("clone", r);
        },
        onChange: (r) => {
          s("change", r);
        }
      }));
    }), (r, p) => (l(), P(de(r.tag), {
      ref_key: "listContainer",
      ref: a
    }, {
      default: A(() => [
        (l(!0), g(Y, null, J(r.modelValue, (h, b) => N(r.$slots, "element", {
          key: h[r.itemKey],
          element: h,
          index: b
        })), 128))
      ]),
      _: 3
    }, 512));
  }
}), Rr = /* @__PURE__ */ c("i", { class: "bi bi-grip-vertical" }, null, -1), qr = [
  Rr
], jm = /* @__PURE__ */ _({
  __name: "CbDraggableCardItem",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    handleClass: {
      type: String,
      default: "handle"
    },
    dragging: {
      type: Boolean
    }
  },
  setup(e) {
    return (n, t) => (l(), P(de(e.tag), {
      class: I([
        "flex items-center mb-2 bg-white dark:bg-base-900 dark:hover:bg-base-800 border border-base-300 hover:bg-base-100 group rounded-sm relative shadow"
      ])
    }, {
      default: A(() => [
        c("button", {
          type: "button",
          class: I([
            "block cursor-grab text-base-400 transition-opacity duration-200 group-hover:opacity-100 py-4 px-2 mr-3 self-stretch",
            e.handleClass,
            { "cursor-grabbing": e.dragging }
          ])
        }, qr, 2),
        N(n.$slots, "default")
      ]),
      _: 3
    }));
  }
}), Wr = /* @__PURE__ */ c("i", { class: "bi bi-grip-vertical" }, null, -1), jr = [
  Wr
], Ym = /* @__PURE__ */ _({
  __name: "CbDraggableListItem",
  props: {
    tag: {
      type: String,
      default: "div"
    },
    handleHiddenUntilHover: {
      type: Boolean
    },
    roundedBorders: {
      type: Boolean
    },
    handleClass: {
      type: String,
      default: "handle"
    },
    dragging: {
      type: Boolean
    },
    customWrapperClass: {
      type: String,
      default: void 0
    }
  },
  setup(e) {
    return (n, t) => (l(), P(de(e.tag), {
      class: I([
        e.customWrapperClass || "flex items-center p-2 space-x-1 bg-white dark:bg-base-900 border-t border-l border-r border-base-300 hover:bg-base-100 dark:hover:bg-base-800 group last:border-b",
        { roundedBorders: "rounded-sm" },
        e.dragging ? "border-b" : "last:border-b"
      ])
    }, {
      default: A(() => [
        c("button", {
          type: "button",
          class: I([
            "block cursor-grab text-base-400 transition-opacity duration-200 group-hover:opacity-100",
            e.handleHiddenUntilHover ? "opacity-0" : "opacity-100",
            e.handleClass,
            { "cursor-grabbing": e.dragging }
          ])
        }, jr, 2),
        N(n.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), Yr = /* @__PURE__ */ _({
  __name: "CbDropdownListItem",
  props: {
    action: {
      type: Function,
      default: void 0
    },
    label: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    const { t: n } = te();
    return (t, a) => (l(), g("li", {
      class: I([
        "p-3",
        { "hover:bg-base-200 dark:hover:bg-base-700 dark:text-white cursor-pointer": e.action }
      ]),
      onClick: a[0] || (a[0] = //@ts-ignore
      (...o) => e.action && e.action(...o)),
      onKeypress: () => {
      }
    }, [
      N(t.$slots, "label", {}, () => [
        X(H(u(n)(e.label)), 1)
      ])
    ], 34));
  }
}), Kr = /* @__PURE__ */ _({
  __name: "CbDropdownList",
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  setup(e) {
    return (n, t) => (l(), P(Te, { class: "p-1" }, {
      default: A(() => [
        c("ul", null, [
          N(n.$slots, "default", {}, () => [
            (l(!0), g(Y, null, J(e.items, (a, o) => {
              var s;
              return l(), P(Yr, {
                key: o,
                label: a.label,
                action: a.action,
                class: I(a.customClasses)
              }, Oe({ _: 2 }, [
                (s = n.$slots) != null && s["item-label"] ? {
                  name: "label",
                  fn: A(() => [
                    N(n.$slots, "item-label", {
                      label: a.label
                    })
                  ]),
                  key: "0"
                } : void 0
              ]), 1032, ["label", "action", "class"]);
            }), 128))
          ])
        ])
      ]),
      _: 3
    }));
  }
}), Ur = { class: "w-full md:w-10/12 lg:w-8/12 md:m-auto text-center" }, Jr = { class: "font-display font-bold text-2xl mb-3" }, Gr = { class: "text-lg" }, Qr = { class: "mt-5 space-x-3" }, Xr = /* @__PURE__ */ _({
  __name: "CbEmptyContent",
  setup(e) {
    const { t: n } = te();
    return (t, a) => (l(), g("article", Ur, [
      N(t.$slots, "image", {}, () => [
        L(u(Pe), {
          src: "https://s3.eu-west-1.amazonaws.com/resources.cluber.es/images/empty_state_island.svg",
          alt: "Empty state illustration",
          class: "w-48 h-48 mx-auto"
        })
      ]),
      c("h2", Jr, [
        N(t.$slots, "title", {}, () => [
          X(H(u(n)("No available data")), 1)
        ])
      ]),
      c("p", Gr, [
        N(t.$slots, "description", {}, () => [
          X(H(u(n)("There is no available data matching your current request. Try refreshing or maybe there's nothing to show")), 1)
        ])
      ]),
      c("section", Qr, [
        N(t.$slots, "actions")
      ])
    ]));
  }
}), Zr = { ref: "wrapper" }, ed = {
  key: 0,
  class: "mb-8 border border-danger-100 rounded-sm p-5"
}, td = { class: "text-lg font-bold font-display text-center" }, ad = { class: "text-center mb-5" }, od = ["data-testid", "innerHTML"], nd = { key: 3 }, sd = ["id", "data-testid"], id = /* @__PURE__ */ _({
  __name: "CbInfiniteScroll",
  props: {
    id: {
      type: String,
      required: !0
    },
    elements: {
      type: Array,
      default: void 0
    },
    totalItems: {
      type: Number,
      required: !0
    },
    currentPage: {
      type: Number,
      required: !0
    },
    initialLimit: {
      type: Number,
      default: void 0
    },
    perPageLimit: {
      type: Number,
      required: !0
    },
    isFetching: {
      type: Boolean
    },
    enableAutomaticLoad: {
      type: Boolean
    },
    requestError: {
      type: Boolean
    },
    kindOfElement: {
      type: String,
      default: void 0
    },
    hideTotalItems: {
      type: Boolean
    }
  },
  emits: ["request-elements"],
  setup(e, { emit: n }) {
    const { t } = te(), a = e, o = n, s = D(null), i = D(!1), d = T(() => {
      var y;
      return (((y = a.elements) == null ? void 0 : y.length) || 0) >= a.totalItems;
    }), r = D(!1);
    function p(y) {
      r.value = !0, (!a.requestError || y) && o("request-elements", { page: a.currentPage + 1 });
    }
    const h = T(() => {
      if (!a.elements)
        return 0;
      const y = 1;
      return a.enableAutomaticLoad ? y : a.initialLimit ? a.initialLimit < a.elements.length ? y : 0 : r.value ? 0 : y;
    }), { stop: b } = to(
      s,
      ([{ isIntersecting: y }]) => {
        !d.value && a.enableAutomaticLoad && (i.value = y, i.value && p());
      },
      {
        threshold: h.value
      }
    );
    return Ee(b), (y, w) => {
      var v, f, m;
      return l(), g("div", Zr, [
        c("ul", null, [
          (l(!0), g(Y, null, J(e.elements, (k, x) => (l(), g("li", {
            key: `CbInfiniteScroll-${x}-${e.id}`
          }, [
            N(y.$slots, "element", {
              element: k,
              index: x
            })
          ]))), 128)),
          !e.isFetching && !e.requestError && e.enableAutomaticLoad ? (l(), g("li", {
            key: 0,
            ref_key: "target",
            ref: s,
            class: "h-1"
          }, null, 512)) : E("", !0)
        ]),
        e.requestError ? (l(), g("div", ed, [
          c("h1", td, H(u(t)("Oops!")), 1),
          c("p", ad, H(u(t)("An error happened and we have not been able to show more results, please use try again button or reload this page")), 1),
          !e.isFetching && !d.value ? (l(), P(re, {
            key: 0,
            mode: "outline",
            color: "primary",
            class: "block! mx-auto mt-5",
            "data-testid": "infiniteScrollTryAgainButton",
            onClick: w[0] || (w[0] = () => p("force"))
          }, {
            default: A(() => [
              X(H(u(t)("Try again")), 1)
            ]),
            _: 1
          })) : E("", !0)
        ])) : E("", !0),
        !e.isFetching && ((v = e.elements) != null && v.length) && !e.hideTotalItems ? (l(), g("p", {
          key: 1,
          "data-testid": `viewSummary_${e.kindOfElement}`,
          class: "text-center flex-inline mt-8",
          innerHTML: u(Be).sanitize(u(t)("You have seen <strong>{seen}</strong> of <strong>{total}</strong> {kindOfElement}", {
            seen: e.elements.length,
            total: e.totalItems,
            kindOfElement: ((f = a.kindOfElement) == null ? void 0 : f.toLowerCase()) || ((m = u(t)("Elements")) == null ? void 0 : m.toLowerCase())
          }))
        }, null, 8, od)) : E("", !0),
        !e.isFetching && !d.value && !e.enableAutomaticLoad && !e.requestError ? (l(), P(re, {
          key: 2,
          mode: "filled",
          color: "primary",
          class: "block! mx-auto mt-5",
          onClick: p
        }, {
          default: A(() => [
            X(H(u(t)("Load more")), 1)
          ]),
          _: 1
        })) : E("", !0),
        y.$slots.loadingElement && e.isFetching ? (l(), g("ul", nd, [
          (l(!0), g(Y, null, J(e.perPageLimit, (k) => (l(), g("li", {
            id: `cb-infinite-scroll-loading-element-${k}`,
            key: k,
            class: "cb-infinite-scroll-loading-element",
            "data-testid": `${k}_loadingElement`
          }, [
            N(y.$slots, "loadingElement")
          ], 8, sd))), 128))
        ])) : e.isFetching && !y.$slots.loadingElement ? (l(), P(qe, {
          key: 4,
          "ring-size": 50,
          class: "mx-auto text-primary-500 my-10"
        })) : E("", !0)
      ], 512);
    };
  }
});
var Ue = /* @__PURE__ */ ((e) => (e.Key = "key", e.Row = "row", e))(Ue || {});
const ld = {
  checkedReturnType: Ue.Key,
  numLoadingItems: 5,
  itemHeight: 80,
  containerHeight: "50vh",
  currentPage: 1,
  perPageLimit: 20,
  totalItems: 0
}, fa = /* @__PURE__ */ _({
  __name: "CbListDefaultItemSkeleton",
  props: {
    hasCheckbox: {
      type: Boolean
    },
    itemHeight: {
      type: Number,
      required: !0
    }
  },
  setup(e) {
    return (n, t) => (l(), g("li", {
      style: le({ height: `${e.itemHeight}px` }),
      class: "flex items-center gap-x-4",
      "data-testid": "cbListItemSkeleton"
    }, [
      e.hasCheckbox ? (l(), P(zt, {
        key: 0,
        "is-loading": "",
        height: "24px",
        width: "24px"
      })) : E("", !0),
      N(n.$slots, "default", {}, () => [
        L(zt, {
          "is-loading": "",
          class: I("my-0!"),
          height: "75%",
          width: "100%"
        })
      ])
    ], 4));
  }
}), rd = {
  class: "cb-list",
  "data-testid": "cbListLoadingSkeleton"
}, dd = /* @__PURE__ */ _({
  __name: "CbListSkeleton",
  props: {
    listId: {
      type: String,
      default: ""
    },
    numLoadingItems: {
      type: Number,
      default: 5
    },
    hasCheckbox: {
      type: Boolean
    },
    itemHeight: {
      type: Number,
      required: !0
    }
  },
  setup(e) {
    return (n, t) => (l(), g("ul", rd, [
      (l(!0), g(Y, null, J(e.numLoadingItems, (a) => (l(), g("li", { key: a }, [
        L(fa, {
          "item-height": e.itemHeight,
          "has-checkbox": e.hasCheckbox
        }, {
          default: A(() => [
            N(n.$slots, "default")
          ]),
          _: 3
        }, 8, ["item-height", "has-checkbox"])
      ]))), 128))
    ]));
  }
});
function Mt({
  props: e,
  offset: n = 0,
  keyField: t,
  emit: a,
  initialState: o = {}
}) {
  const s = D(e.initialSelected || []), i = D(o.isAllChecked || !1), d = D(o.indeterminate || !1);
  function r() {
    a("checked-rows", s.value);
  }
  function p(w) {
    a("all-checked", w);
  }
  function h() {
    if (!e.pageSize)
      return e.rows;
    const w = e.localMode ? u(n) - 1 : 0;
    return e.rows.slice(w, e.pageSize);
  }
  K(i, (w) => {
    if (e.hasCheckbox) {
      if (s.value = [], w) {
        const v = h();
        e.checkedReturnType === Ue.Row ? s.value = v : v.forEach((f) => {
          s.value.push(f[u(t)]);
        });
      }
      d.value = !1, p(w), r();
    }
  }), K(() => e.hasCheckbox, (w) => {
    w || (i.value = !1, d.value = !1);
  });
  function b(w, v) {
    let f = w[u(t)];
    if (e.checkedReturnType === Ue.Row && (f = w), v)
      s.value.push(f);
    else {
      const m = s.value.indexOf(f);
      m >= 0 && s.value.splice(m, 1), s.value.length && (d.value = !0);
    }
    s.value.length === h().length ? (i.value = !0, d.value = !1, p(!0)) : r();
  }
  function y() {
    s.value = [], i.value = !1, d.value = !1, p(!1), r();
  }
  return {
    checkItem: b,
    clearSelection: y,
    checkedItems: s,
    indeterminate: d,
    isAllChecked: i,
    getVisibleItems: h
  };
}
const ud = { key: 1 }, Km = /* @__PURE__ */ _({
  __name: "CbList",
  props: /* @__PURE__ */ St({
    listId: {},
    rows: {},
    itemHeight: {},
    containerHeight: {},
    loading: { type: Boolean },
    trackingKey: {},
    currentPage: {},
    perPageLimit: {},
    totalItems: {},
    numLoadingItems: {},
    allItemsSelected: { type: Boolean },
    hasCheckbox: { type: Boolean },
    pageSize: {},
    localMode: { type: Boolean },
    checkedReturnType: {},
    initialSelected: {}
  }, ld),
  emits: ["checked-rows", "all-checked", "request-elements"],
  setup(e, { emit: n }) {
    const t = e, a = n, o = T(() => (t.localMode || !t.rows || t.rows.length === 0) && t.loading), s = T(() => !t.loading && t.rows.length === 0), i = T(() => t.rows), { list: d, containerProps: r, wrapperProps: p } = Qt(i, {
      itemHeight: t.itemHeight,
      overscan: 4
    }), [h, b] = ao(), {
      checkItem: y,
      checkedItems: w,
      isAllChecked: v
    } = Mt({
      props: t,
      offset: 0,
      keyField: t.trackingKey,
      emit: a
    });
    function f(m) {
      if (!m)
        return !1;
      const k = m[t.trackingKey];
      return k ? w.value.includes(k) : !1;
    }
    return ne(() => {
      v.value = !!t.allItemsSelected;
    }), K(() => t.allItemsSelected, (m) => {
      v.value = m;
    }), (m, k) => (l(), g(Y, null, [
      L(u(h), null, {
        default: A(({ props: { index: x, data: $ } }) => [
          c("li", {
            class: "flex items-center gap-x-3",
            style: le({ height: `${m.itemHeight}px` })
          }, [
            m.hasCheckbox ? (l(), P(ye, {
              key: 0,
              id: `checkbox-${m.listId}-row-${x}`,
              classes: {
                wrapper: "mb-0!"
              },
              "model-value": f($),
              onInput: (F) => u(y)($, !!F),
              onClick: k[0] || (k[0] = (F) => F.stopPropagation())
            }, null, 8, ["id", "model-value", "onInput"])) : E("", !0),
            N(m.$slots, "item", { item: $ })
          ], 4)
        ]),
        _: 3
      }),
      L(xt, {
        name: "fade",
        mode: "out-in",
        duration: 200
      }, {
        default: A(() => [
          s.value ? N(m.$slots, "emptyContent", { key: 0 }, () => [
            L(Xr)
          ]) : o.value ? (l(), P(dd, {
            key: 2,
            "list-id": m.listId,
            "has-checkbox": m.hasCheckbox,
            "item-height": m.itemHeight,
            "num-loading-items": m.numLoadingItems
          }, {
            default: A(() => [
              N(m.$slots, "loadingItem")
            ]),
            _: 3
          }, 8, ["list-id", "has-checkbox", "item-height", "num-loading-items"])) : (l(), g("section", ud, [
            m.localMode ? (l(), g("section", he({ key: 0 }, u(r), {
              style: { height: m.containerHeight, overflow: "auto" }
            }), [
              c("ul", he(u(p), { class: "cb-list" }), [
                (l(!0), g(Y, null, J(u(d), ({ data: x, index: $ }) => (l(), P(u(b), {
                  key: $,
                  props: { index: $, data: x }
                }, null, 8, ["props"]))), 128))
              ], 16)
            ], 16)) : (l(), P(id, {
              key: 1,
              id: m.listId,
              class: "cb-list",
              elements: m.rows,
              style: le({ height: m.containerHeight, overflow: "auto" }),
              "is-fetching": m.loading,
              "current-page": m.currentPage,
              "per-page-limit": m.perPageLimit,
              "total-items": m.totalItems,
              "enable-automatic-load": "",
              "hide-total-items": "",
              onRequestElements: k[1] || (k[1] = (x) => a("request-elements", x))
            }, {
              element: A(({ element: x, index: $ }) => [
                L(u(b), {
                  props: { index: $, data: x }
                }, null, 8, ["props"])
              ]),
              loadingElement: A(() => [
                L(fa, {
                  "item-height": m.itemHeight,
                  "has-checkbox": m.hasCheckbox
                }, {
                  default: A(() => [
                    N(m.$slots, "loadingItem")
                  ]),
                  _: 3
                }, 8, ["item-height", "has-checkbox"])
              ]),
              _: 3
            }, 8, ["id", "elements", "style", "is-fetching", "current-page", "per-page-limit", "total-items"]))
          ]))
        ]),
        _: 3
      })
    ], 64));
  }
});
const Um = /* @__PURE__ */ _({
  __name: "CbLogo",
  setup(e) {
    return (n, t) => (l(), g("div", null, [
      L(u(Pe), {
        class: "h-full dark:hidden",
        src: "https://s3.eu-west-1.amazonaws.com/images.cluber.es/cluber_logo.4d4c091f.png",
        alt: "Cluber logo"
      }),
      L(u(Pe), {
        class: "hidden h-full dark:block",
        src: "https://s3.eu-west-1.amazonaws.com/assets.cluber.es/cluber-next-front/src/assets/images/logo_white.svg",
        alt: "Cluber logo dark mode"
      })
    ]));
  }
}), It = (e) => (De("data-v-77f5074b"), e = e(), Ae(), e), cd = ["data-testid"], md = /* @__PURE__ */ It(() => /* @__PURE__ */ c("i", {
  mode: "outline",
  color: "secondary",
  class: "bi bi-chevron-left"
}, null, -1)), pd = /* @__PURE__ */ It(() => /* @__PURE__ */ c("span", {
  "data-testid": "closeIcon",
  class: "text-2xl bi-x-lg"
}, null, -1)), gd = [
  pd
], fd = {
  key: 2,
  class: "-mb-2",
  "data-testid": "actions"
}, hd = /* @__PURE__ */ It(() => /* @__PURE__ */ c("hr", { class: "mt-8 mb-5 border-base-300" }, null, -1)), bd = { class: "flex justify-end space-x-6" }, vd = /* @__PURE__ */ _({
  __name: "CbModal",
  props: {
    modelValue: {
      type: Boolean,
      default: !0
    },
    contentClasses: {
      type: String,
      default: ""
    },
    clickOutside: {
      type: Boolean,
      default: !0
    },
    showCloseButton: {
      type: Boolean,
      default: !0
    },
    showBackButton: {
      type: Boolean
    },
    dataTestid: {
      type: String,
      default: void 0
    },
    class: {
      type: String,
      default: ""
    }
  },
  emits: [
    "update:modelValue",
    "back"
  ],
  setup(e, { emit: n }) {
    const t = e, a = n;
    function o() {
      a("update:modelValue", !1);
    }
    oo("Escape", (i) => {
      i.preventDefault(), o();
    });
    const s = no(document.querySelector("html"));
    return K(() => t.modelValue, (i) => {
      s.value = !!i;
    }, { immediate: !0 }), Ce(() => {
      s.value = !1;
    }), (i, d) => (l(), P(Ge, { to: "body" }, [
      L(xt, { name: "fade" }, {
        default: A(() => [
          e.modelValue ? (l(), g("div", {
            key: 0,
            class: I([
              "fixed inset-0 flex items-center justify-center bg-black/50 cb-modal overscroll-y-auto md:p-8",
              t.class,
              { "cursor-pointer": e.clickOutside }
            ]),
            tabindex: "0",
            "data-testid": e.dataTestid || "fullWrapper",
            onKeypress: () => {
            },
            onClick: d[2] || (d[2] = ie(() => {
              e.clickOutside && o();
            }, ["self"]))
          }, [
            L(Te, {
              class: I([
                "cb-modal__container p-8 pt-10 shadow w-full relative cursor-auto initial:max-w-3xl",
                e.contentClasses
              ]),
              "data-testid": "modalContainer"
            }, {
              default: A(() => [
                e.showBackButton ? (l(), P(re, {
                  key: 0,
                  class: "absolute! left-4 top-4 rounded-sm text-xs px-2! py-1! font-bold!",
                  mode: "outline",
                  color: "secondary",
                  size: "sm",
                  onClick: d[0] || (d[0] = (r) => i.$emit("back")),
                  onKeydown: d[1] || (d[1] = (r) => i.$emit("back"))
                }, {
                  default: A(() => [
                    md
                  ]),
                  _: 1
                })) : E("", !0),
                e.showCloseButton ? (l(), g("button", {
                  key: 1,
                  type: "button",
                  "data-testid": "closeButton",
                  class: "absolute top-2 right-[.9rem] cursor-pointer",
                  onClick: o
                }, gd)) : E("", !0),
                c("div", {
                  "data-testid": "content",
                  class: I([
                    { "mt-8": e.showBackButton }
                  ])
                }, [
                  N(i.$slots, "content", { close: o }, void 0, !0)
                ], 2),
                i.$slots.actions ? (l(), g("div", fd, [
                  hd,
                  c("div", bd, [
                    N(i.$slots, "actions", { close: o }, void 0, !0)
                  ])
                ])) : E("", !0)
              ]),
              _: 3
            }, 8, ["class"])
          ], 42, cd)) : E("", !0)
        ]),
        _: 3
      })
    ]));
  }
});
const Jm = /* @__PURE__ */ ee(vd, [["__scopeId", "data-v-77f5074b"]]);
var ha = /* @__PURE__ */ ((e) => (e.Success = "success", e.Error = "error", e.Warning = "warning", e))(ha || {});
const yd = { class: "flex flex-col items-center justify-center" }, kd = {
  key: 0,
  "data-testid": "modal-status-success",
  class: "modal-success"
}, wd = /* @__PURE__ */ bt('<svg viewBox="0 0 87 87" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Group-3" transform="translate(2.000000, 2.000000)"><circle id="Oval-2" stroke="rgba(165, 220, 134, 0.2)" stroke-width="4" cx="41.5" cy="41.5" r="41.5"></circle><circle id="Oval-2" class="modal-success-circle" stroke="#A5DC86" stroke-width="4" cx="41.5" cy="41.5" r="41.5"></circle><polyline id="Path-2" class="modal-success-path" stroke="#A5DC86" stroke-width="4" points="19 38.8036813 31.1020744 54.8046875 63.299221 28"></polyline></g></g></svg>', 1), xd = [
  wd
], Sd = {
  key: 1,
  "data-testid": "modal-status-error",
  class: "modal-error"
}, $d = /* @__PURE__ */ bt('<svg viewBox="0 0 87 87" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Group-2" transform="translate(2.000000, 2.000000)"><circle id="Oval-2" stroke="rgba(252, 191, 191, .5)" stroke-width="4" cx="41.5" cy="41.5" r="41.5"></circle><circle class="modal-error-circle" stroke="#F74444" stroke-width="4" cx="41.5" cy="41.5" r="41.5"></circle><path id="Line" class="modal-error-line1" d="M22.244224,22 L60.4279902,60.1837662" stroke="#F74444" stroke-width="3" stroke-linecap="square"></path><path id="Line" class="modal-error-line2" d="M60.755776,21 L23.244224,59.8443492" stroke="#F74444" stroke-width="3" stroke-linecap="square"></path></g></g></svg>', 1), Cd = [
  $d
], Dd = { class: "font-display font-bold text-2xl mb-3" }, Ad = { class: "text-center" }, Gm = /* @__PURE__ */ _({
  __name: "CbModalStatus",
  props: {
    status: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    return (n, t) => (l(), g("div", yd, [
      e.status === u(ha).Success ? (l(), g("div", kd, xd)) : (l(), g("div", Sd, Cd)),
      c("h3", Dd, [
        N(n.$slots, "title", { status: e.status })
      ]),
      c("p", Ad, [
        N(n.$slots, "description", { status: e.status })
      ])
    ]));
  }
});
const Td = { class: "relative right-7 w-0 items-stretch" }, Md = /* @__PURE__ */ _({
  __name: "CbTextInput",
  props: /* @__PURE__ */ Fe({
    id: {
      type: String,
      required: !0
    },
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean
    },
    readonly: {
      type: Boolean
    },
    autofocus: {
      type: Boolean
    },
    loading: {
      type: Boolean
    }
  }, {
    modelValue: {
      type: String,
      default: void 0
    },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Fe(["focus", "blur"], ["update:modelValue"]),
  setup(e, { emit: n }) {
    const t = vt(e, "modelValue"), a = n, o = e, s = yt(), i = T(() => o.loading || o.disabled), d = T(() => o.loading || o.readonly), r = T(() => o.loading ? Object.fromEntries(Object.entries(s).filter(([h]) => h !== "suffix")) : s), p = D(!1);
    return $t(() => o.loading, (h, b) => {
      var y;
      p.value && !h && b && ((y = document.getElementById(o.id)) == null || y.focus());
    }, { debounce: 10 }), (h, b) => {
      const y = pe("FormKit");
      return l(), P(y, he({ id: e.id }, h.$attrs, {
        modelValue: t.value,
        "onUpdate:modelValue": b[0] || (b[0] = (w) => t.value = w),
        type: "text",
        label: e.label,
        placeholder: e.placeholder,
        disabled: i.value,
        readonly: d.value,
        autofocus: e.autofocus,
        style: { opacity: e.loading ? 0.5 : 1 },
        onFocus: b[1] || (b[1] = (w) => {
          a("focus", w), p.value = !0;
        }),
        onBlur: b[2] || (b[2] = (w) => {
          a("blur", w), o.loading || (p.value = !1);
        })
      }), Oe({ _: 2 }, [
        e.loading ? {
          name: "suffix",
          fn: A(() => [
            c("div", Td, [
              L(qe, { class: "text-primary-500" })
            ]),
            N(h.$slots, "suffix")
          ]),
          key: "0"
        } : void 0,
        J(r.value, (w, v) => ({
          name: v,
          fn: A((f) => [
            N(h.$slots, v, kt(wt(f)))
          ])
        }))
      ]), 1040, ["id", "modelValue", "label", "placeholder", "disabled", "readonly", "autofocus", "style"]);
    };
  }
}), Id = ["id"], Re = /* @__PURE__ */ _({
  __name: "CbSelect",
  props: {
    modelValue: {
      type: [String, Number, Array],
      default: () => []
    },
    nativeSelect: {
      type: Boolean
    },
    id: {
      type: String,
      required: !0
    },
    options: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: ""
    },
    searchable: {
      type: Boolean
    },
    searchPlaceholder: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    virtualListElementHeight: {
      type: Number,
      default: void 0
    },
    menuWidth: {
      type: String,
      default: ""
    },
    menuHeight: {
      type: String,
      default: void 0
    },
    menuMaxHeight: {
      type: String,
      default: void 0
    },
    inputMaxHeight: {
      type: String,
      default: void 0
    },
    showDefaultMenuSuffix: {
      type: Boolean
    },
    optionTypeLabel: {
      type: String,
      default: "label"
    },
    errors: {
      type: Array,
      default: () => []
    },
    multiple: {
      type: Boolean
    },
    disabledItems: {
      type: [Array, void 0],
      default: void 0
    },
    validation: {
      type: String,
      default: void 0
    },
    validationVisibility: {
      type: String,
      default: "live"
    },
    showSelectionActions: {
      type: Boolean
    },
    loading: {
      type: Boolean
    }
  },
  emits: [
    "update:modelValue",
    "selected-raw",
    "menu-open"
  ],
  setup(e, { emit: n }) {
    const t = n, a = e, o = D(a.modelValue), s = D(a.menuWidth), i = D(!1);
    K(() => a.modelValue, () => {
      o.value = a.modelValue;
    });
    const d = T(() => {
      const k = o.value;
      return a.multiple && k && k.length > 0;
    });
    function r() {
      var k;
      (k = document.getElementById(a.id)) == null || k.focus();
    }
    const p = T(() => {
      const k = a.options.find((x) => x.value.toString() === o.value.toString());
      return (k == null ? void 0 : k[a.optionTypeLabel]) || void 0;
    });
    function h(k) {
      k.target.id.includes("multiselect-badge") || k.stopPropagation();
    }
    ne(() => {
      if (!Array.isArray(a.modelValue) && a.multiple)
        throw Error(`modelValue for CbSelect with ID ${a.id} needs to be an array because you also set the "multiple" prop, the modelValue received is of type "${typeof a.modelValue}"`);
    });
    function b(k, x) {
      a.multiple && Array.isArray(k) && (o.value = k, t("update:modelValue", k), t("selected-raw", a.options.filter((S) => k.includes(S.value))), a.showSelectionActions && x()), (typeof k == "string" || typeof k == "number") && (o.value = k, t("update:modelValue", k), t("selected-raw", a.options.filter((S) => k === S.value)), x());
    }
    function y(k) {
      const x = o.value.filter(($) => $ !== k);
      o.value = x, t("update:modelValue", x), t("selected-raw", a.options.filter(($) => x == null ? void 0 : x.includes($.value)));
    }
    function w() {
      if (a.menuWidth)
        return;
      const k = document.getElementById(a.id);
      k != null && k.getBoundingClientRect().width && (s.value = Ht(k == null ? void 0 : k.getBoundingClientRect().width));
    }
    ne(() => {
      w(), window.addEventListener("resize", w);
    }), Ce(() => {
      window.removeEventListener("resize", w);
    });
    const v = D(), f = D();
    K(o, () => {
      a.nativeSelect && (t("update:modelValue", o.value), t("selected-raw", a.options.filter((k) => o.value === k.value)));
    });
    const m = T(() => JSON.parse(JSON.stringify(a.options)));
    return ne(() => {
      (!a.modelValue || Array.isArray(a.modelValue) && a.modelValue.length === 0) && [v, f].forEach((k) => {
        if (!k.value)
          return;
        const x = k.value.$el.querySelector("select");
        x && (x.selectedIndex = -1);
      });
    }), (k, x) => {
      const $ = pe("FormKit");
      return e.nativeSelect ? (l(), P($, {
        key: 0,
        ref_key: "nativeInput",
        ref: f,
        modelValue: o.value,
        "onUpdate:modelValue": x[0] || (x[0] = (F) => o.value = F),
        type: "select",
        label: e.label,
        placeholder: e.placeholder,
        options: e.options,
        validation: e.validation,
        "validation-visibility": e.validationVisibility,
        disabled: e.loading
      }, null, 8, ["modelValue", "label", "placeholder", "options", "validation", "validation-visibility", "disabled"])) : (l(), P(We, {
        key: 1,
        "open-direction": "bottom",
        "force-open": i.value && !e.loading,
        disabled: e.loading,
        onClose: x[2] || (x[2] = (F) => i.value = !1),
        onOpen: x[3] || (x[3] = () => {
          k.$emit("menu-open"), w();
        })
      }, {
        button: A(({ isOpen: F }) => [
          L($, {
            ref_key: "validationInput",
            ref: v,
            "model-value": o.value,
            classes: { outer: "inputClip" },
            type: "select",
            options: JSON.parse(JSON.stringify(e.options)),
            validation: e.validation,
            "validation-visibility": e.validationVisibility,
            disabled: e.loading,
            readonly: ""
          }, null, 8, ["model-value", "options", "validation", "validation-visibility", "disabled"]),
          (l(), P(Md, {
            id: e.id,
            key: e.multiple ? void 0 : o.value,
            "data-testid": "customInputButton",
            value: p.value,
            type: "text",
            label: e.label,
            placeholder: e.placeholder,
            errors: e.errors,
            loading: e.loading,
            readonly: "",
            classes: {
              outer: "relative",
              input: "cursor-pointer caret-transparent",
              selectIcon: "bg-white pl-3",
              messages: "absolute whitespace-nowrap"
            },
            onFocus: x[1] || (x[1] = (S) => i.value = !0)
          }, Oe({
            suffix: A(() => [
              e.loading ? E("", !0) : (l(), g("span", {
                key: 0,
                class: "absolute p-2 right-0 bi bi-chevron-down cursor-pointer",
                onClick: r,
                onKeydown: () => {
                }
              }, null, 32))
            ]),
            _: 2
          }, [
            d.value ? {
              name: "input",
              fn: A(() => [
                c("div", {
                  id: e.id,
                  class: I([
                    u(Ua).select.input,
                    "p-[0.375rem]! flex flex-1 flex-row flex-wrap gap-3 min-h-[40px]"
                  ]),
                  style: le(
                    e.inputMaxHeight ? { "max-height": e.inputMaxHeight, overflow: "scroll" } : ""
                  )
                }, [
                  (l(!0), g(Y, null, J(o.value, (S) => (l(), P(At, {
                    id: `multiselect-badge-${S}`,
                    key: S,
                    mode: "primary",
                    "has-close": !F,
                    onClose: (R) => y(S),
                    onClick: h
                  }, {
                    default: A(() => {
                      var R;
                      return [
                        X(H((R = e.options.find((B) => B.value === S)) == null ? void 0 : R.label), 1)
                      ];
                    }),
                    _: 2
                  }, 1032, ["id", "has-close", "onClose"]))), 128))
                ], 14, Id)
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["id", "value", "label", "placeholder", "errors", "loading"]))
        ]),
        menu: A(({ closeMenu: F }) => [
          L(ll, {
            "menu-id": `cbSelect-SelectMenu_${a.id}`,
            "default-selected": JSON.parse(JSON.stringify(o.value)),
            "disabled-items": e.disabledItems,
            items: m.value,
            multiple: e.multiple,
            searchable: e.searchable,
            "search-placeholder": e.searchPlaceholder,
            "menu-width": s.value,
            "menu-height": e.menuHeight,
            "menu-max-height": e.menuMaxHeight,
            "show-default-menu-suffix": e.showDefaultMenuSuffix,
            "virtual-list-element-height": e.virtualListElementHeight,
            "show-selection-actions": e.showSelectionActions,
            onSelected: (S) => b(S, F)
          }, {
            prefix: A(({ item: S }) => [
              N(k.$slots, "optionPrefix", { item: S })
            ]),
            suffix: A(({ item: S }) => [
              N(k.$slots, "optionSuffix", { item: S })
            ]),
            _: 2
          }, 1032, ["menu-id", "default-selected", "disabled-items", "items", "multiple", "searchable", "search-placeholder", "menu-width", "menu-height", "menu-max-height", "show-default-menu-suffix", "virtual-list-element-height", "show-selection-actions", "onSelected"])
        ]),
        _: 3
      }, 8, ["force-open", "disabled"]));
    };
  }
}), Xe = (e) => (De("data-v-aed6738c"), e = e(), Ae(), e), Ld = {
  key: 0,
  class: "cb-pagination flex flex-wrap justify-between items-end",
  "data-testid": "CbPagination"
}, Fd = { class: "col-sm-12 col-md-4 md:mr-4 mb-5 text-center md:text-[initial] w-full md:w-auto" }, Pd = {
  role: "status",
  "aria-live": "polite",
  class: "text-ellipsis"
}, Od = { class: "flex mb-5 space-x-3 w-full md:w-auto md:ml-[10%]" }, Ed = {
  key: 0,
  class: "flex items-center"
}, _d = { class: "flex items-center" }, Nd = { class: "col-sm-12 col-md-4 ml-4 mb-5 hidden md:block" }, zd = { class: "flex justify-end pl-0 mx-0 my-1 list-none rounded-sm whitespace-nowrap" }, Bd = /* @__PURE__ */ Xe(() => /* @__PURE__ */ c("span", { "aria-hidden": "true" }, "«", -1)), Vd = { class: "sr-only" }, Hd = /* @__PURE__ */ Xe(() => /* @__PURE__ */ c("span", { "aria-hidden": "true" }, "<", -1)), Rd = { class: "sr-only" }, qd = ["data-testid"], Wd = ["onClick"], jd = /* @__PURE__ */ Xe(() => /* @__PURE__ */ c("span", { "aria-hidden": "true" }, ">", -1)), Yd = { class: "sr-only" }, Kd = /* @__PURE__ */ Xe(() => /* @__PURE__ */ c("span", { "aria-hidden": "true" }, "»", -1)), Ud = { class: "sr-only" }, Jd = /* @__PURE__ */ _({
  __name: "CbPagination",
  props: {
    id: {
      type: String,
      required: !0
    },
    isHidden: {
      type: Boolean
    },
    // Limit of items that could be shown on any page
    pageSize: {
      type: Number,
      default: 10
    },
    // Limit on items over pagination I.E showing items 10-20 from 6 pages -> limit is 20
    limit: {
      type: Number,
      default: void 0
    },
    // Pagination offset
    offset: {
      type: Number,
      default: void 0
    },
    // Last available page
    lastPage: {
      type: Number,
      default: 0
    },
    totalItems: {
      type: Number,
      default: 0
    },
    // Current page
    page: {
      type: Number,
      default: 1
    },
    hideItemsToShow: {
      type: Boolean
    },
    itemsToShow: {
      type: Array,
      default: () => [10, 25, 50]
    }
  },
  emits: [
    "change-page-size",
    "change-page"
  ],
  setup(e, { emit: n }) {
    const t = n, a = e, { t: o } = te(), s = T(() => {
      if (a.lastPage)
        return a.lastPage;
      if (!a.totalItems || a.totalItems <= 0)
        return 0;
      const v = Math.ceil(a.totalItems / a.pageSize);
      return v === 0 ? 1 : v;
    }), i = T(() => {
      if (a.limit)
        return a.limit;
      const v = a.page * a.pageSize;
      return a.totalItems && a.totalItems >= v ? v : a.totalItems;
    }), d = T(() => {
      let f = a.page - 2 <= 0 ? 1 : a.page - 2;
      s.value - a.page <= 2 && (f = s.value - 4), f = f <= 0 ? 1 : f;
      const m = [];
      for (let k = f; k <= s.value; k += 1)
        m.length < 5 && m.push(k);
      return m;
    }), r = T(() => a.offset || (a.page - 1) * a.pageSize + 1);
    function p() {
      a.page !== 1 && t("change-page", a.page - 1);
    }
    function h(v) {
      t("change-page", v);
    }
    function b() {
      a.page >= s.value || t("change-page", a.page + 1);
    }
    const y = T(() => a.itemsToShow.map((v) => ({
      label: v.toString(),
      value: v.toString()
    }))), w = T(() => Array.from({
      length: s.value
    }, (v, f) => f + 1).map((v) => ({
      label: v.toString(),
      value: v.toString()
    })));
    return (v, f) => a.isHidden ? E("", !0) : (l(), g("div", Ld, [
      c("div", Fd, [
        c("div", Pd, H(u(o)("Showing {0}-{1} of {2}", [
          r.value,
          i.value,
          e.totalItems
        ])), 1)
      ]),
      c("div", Od, [
        e.hideItemsToShow ? E("", !0) : (l(), g("div", Ed, [
          L(Re, {
            id: `to-show-selector-${e.id}`,
            label: u(o)("Show"),
            name: "itemsToShow",
            class: "whitespace-nowrap w-full md:w-auto flex-1 md:flex-none",
            options: y.value,
            "model-value": e.pageSize.toString(),
            "onUpdate:modelValue": f[0] || (f[0] = (m) => t("change-page-size", parseInt(m, 10)))
          }, null, 8, ["id", "label", "options", "model-value"])
        ])),
        c("div", _d, [
          L(Re, {
            id: `page-selector-${e.id}`,
            label: u(o)("Go to page"),
            name: "selectPage",
            class: "whitespace-nowrap w-full md:w-auto flex-1 md:flex-none",
            options: w.value,
            "model-value": e.page.toString(),
            "onUpdate:modelValue": f[1] || (f[1] = (m) => h(parseInt(m, 10)))
          }, null, 8, ["id", "label", "options", "model-value"])
        ])
      ]),
      c("div", Nd, [
        c("div", null, [
          c("ul", zd, [
            c("li", {
              class: I([
                "page-item",
                { disabled: a.page <= 1 }
              ]),
              "data-testid": "firstPage"
            }, [
              c("a", {
                class: "cursor-pointer page-link",
                "aria-label": "First",
                onClick: f[2] || (f[2] = ie((m) => t("change-page", 1), ["prevent"])),
                onKeydown: () => {
                }
              }, [
                Bd,
                c("span", Vd, H(u(o)("First page")), 1)
              ], 32)
            ], 2),
            c("li", {
              class: I([
                "page-item",
                { disabled: a.page <= 1 }
              ]),
              "data-testid": "previousPage"
            }, [
              c("a", {
                class: "cursor-pointer page-link",
                "aria-label": "Previous",
                onClick: ie(p, ["prevent"]),
                onKeydown: () => {
                }
              }, [
                Hd,
                c("span", Rd, H(u(o)("Previous page")), 1)
              ], 32)
            ], 2),
            (l(!0), g(Y, null, J(d.value, (m) => (l(), g("li", {
              key: m,
              "data-testid": `page_${m}`,
              class: I([
                "page-item",
                { "font-bold active": e.page.toString() === m.toString() }
              ])
            }, [
              c("a", {
                class: "cursor-pointer page-link",
                onClick: ie((k) => h(m), ["prevent"]),
                onKeydown: () => {
                }
              }, H(m), 41, Wd)
            ], 10, qd))), 128)),
            c("li", {
              class: I([
                "page-item",
                { disabled: a.page >= s.value }
              ]),
              "data-testid": "nextPage"
            }, [
              c("a", {
                class: "cursor-pointer page-link",
                "aria-label": "Next",
                onClick: ie(b, ["prevent"]),
                onKeydown: () => {
                }
              }, [
                jd,
                c("span", Yd, H(u(o)("Next page")), 1)
              ], 32)
            ], 2),
            c("li", {
              class: I([
                "page-item",
                { disabled: a.page >= s.value }
              ]),
              "data-testid": "lastPage"
            }, [
              c("a", {
                class: "cursor-pointer page-link",
                "aria-label": "Last",
                onClick: f[3] || (f[3] = ie((m) => t("change-page", s.value), ["prevent"])),
                onKeydown: () => {
                }
              }, [
                Kd,
                c("span", Ud, H(u(o)("Last page")), 1)
              ], 32)
            ], 2)
          ])
        ])
      ])
    ]));
  }
});
const Qm = /* @__PURE__ */ ee(Jd, [["__scopeId", "data-v-aed6738c"]]), Gd = /* @__PURE__ */ _({
  __name: "CbProgressBar",
  props: {
    modelValue: {
      type: Number,
      default: 90
    },
    transitionDuration: {
      type: Number,
      default: 3e3
    },
    mode: {
      type: String,
      default: "default"
    },
    errored: {
      type: Boolean
    },
    hidePercentageNumber: {
      type: Boolean
    }
  },
  emits: [
    "animationFinished",
    "animationStarted",
    "progressBarFull"
  ],
  setup(e, { emit: n }) {
    const t = e, a = n, o = D(0), s = D(t.transitionDuration), i = D(!1), d = so(o, {
      duration: s,
      disabled: i,
      transition: io.easeInSine,
      onStarted() {
        a("animationStarted");
      },
      onFinished() {
        a("animationFinished"), t.modelValue < 100 && t.mode === "request" && (s.value = 100);
      }
    });
    function r() {
      o.value = t.modelValue <= 100 ? t.modelValue : 100;
    }
    ne(() => {
      t.modelValue && r();
    }), K(d, () => {
      t.modelValue === 100 ? i.value = !1 : i.value = d.value >= t.modelValue, d.value === 100 && a("progressBarFull");
    }), K(() => t.errored, (b, y) => {
      !y && b && (i.value = !0, o.value = 100), !b && y && (i.value = !1, o.value = t.modelValue);
    }), K(() => t.modelValue, () => {
      i.value = !1, r();
    }), K(() => t.transitionDuration, () => {
      s.value = t.transitionDuration;
    });
    const p = T(() => `${t.modelValue <= 100 ? d.value : t.modelValue}%`), h = T(() => p.value === "100%");
    return (b, y) => (l(), g("div", {
      class: I([
        "cb_progressbar-wrapper",
        { "border-success-500!": h.value && e.mode === "request" && !e.errored },
        { "border-danger-300! bg-danger-100!": e.errored && e.mode === "request" }
      ])
    }, [
      c("div", {
        "data-testid": "CbProgressBar-inner",
        class: I([
          "cb_progressbar-inner",
          { disabled: i.value && e.mode === "request" && !h.value && !e.errored },
          { "bg-success-500!": h.value && e.mode === "request" && !e.errored },
          { "bg-danger-300!": e.errored && e.mode === "request" }
        ]),
        style: le({
          width: p.value,
          "--current-progress-width": p.value
        })
      }, [
        e.errored ? (l(), g(Y, { key: 1 }, [
          X(" Error ")
        ], 64)) : (l(), g(Y, { key: 0 }, [
          X(H(e.hidePercentageNumber ? "" : `${Math.round(parseInt(p.value, 10))}%`), 1)
        ], 64))
      ], 6)
    ], 2));
  }
});
const Qd = /* @__PURE__ */ ee(Gd, [["__scopeId", "data-v-6a8bb27f"]]), Xm = /* @__PURE__ */ _({
  __name: "CbProvider",
  props: {
    i18nConfig: {
      type: Object,
      required: !0
    },
    authToken: {
      type: Function,
      required: !0
    },
    apiUrls: {
      type: Object,
      required: !0
    },
    route: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const n = e;
    return we(Zt, n.i18nConfig), we(ta, n.authToken), we(aa, n.apiUrls), we(ea, n.route), (t, a) => N(t.$slots, "default");
  }
}), Xd = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "logo",
  viewBox: "0 0 512 512"
}, Zd = /* @__PURE__ */ c("g", { id: "imago" }, [
  /* @__PURE__ */ c("path", {
    id: "contorno",
    d: "M229.62.65v50.51c-62.42 9.55-112 39.55-146 93.35-24 37.86-34.11 79.62-30 124.25 9.07 97.54 82.39 169 171.35 181.32 55.63 7.72 106.1-5.65 150.53-40s69.16-80.4 76.8-135.91h48.18c-6.79 110.08-100.78 224.78-242.61 228.67C110.1 506.84-4.98 386.13.17 243.72 5.72 90.1 130.78 5.79 229.62.65",
    class: "cls-1"
  }),
  /* @__PURE__ */ c("path", {
    id: "letra_c",
    d: "M250.29 358.55c27.92-.9 52.05-10.52 72.63-29.36 5-4.61 10.18-9.26 17.32-10.73 14.3-3.16 28.46 5.88 31.61 20.18 1.86 8.43-.5 17.24-6.32 23.61-9.9 10.87-21.69 19.4-34.3 26.77a156.9 156.9 0 0 1-70.32 21.23c-83.44 5.23-155.26-55.09-166.66-136.12-11.64-82.72 41-159.75 122.43-178.29 48.77-11.11 93.35-.36 133 30.27 4.81 3.78 9.42 7.8 13.81 12.05 11.39 10.85 12.08 27.12 1.79 38.14-10.11 10.83-26.23 11.21-37.77.71-16.13-14.68-34.05-25.77-55.72-30.45-57.63-12.45-116.2 26.89-126.33 85.16-10.05 57.82 25.37 111.16 82.51 123.87 7.28 1.66 14.87 2 22.32 2.96",
    class: "cls-1",
    "data-name": "letra c"
  }),
  /* @__PURE__ */ c("path", {
    id: "acento",
    d: "M502.69 231.17H454.1c-5.49-47.6-24.4-88.73-58.12-122.54S321.2 56.15 273.75 50.89V.25c.85-.13 1.7-.21 2.55-.25 62.53 0 125.06.02 187.58.06 18.51 0 33.8 11.64 38.36 29.05.36 1.38.56 2.8.57 4.22v194.82c.02.74-.05 1.51-.12 3.02",
    style: { fill: "#0080ff" }
  })
], -1);
function eu(e, n) {
  return l(), g("svg", Xd, [
    c("defs", null, [
      (l(), P(de("style"), null, {
        default: A(() => [
          X(".cls-1{fill:#002449}")
        ]),
        _: 1
      }))
    ]),
    Zd
  ]);
}
const tu = { render: eu }, au = (e) => (De("data-v-a7759a6c"), e = e(), Ae(), e), ou = { class: "inline-flex flex-col" }, nu = { class: "qrcode__image" }, su = /* @__PURE__ */ au(() => /* @__PURE__ */ c("i", { class: "bi bi-qr-code mr-2" }, null, -1)), iu = /* @__PURE__ */ _({
  __name: "CbQrCode",
  props: {
    id: {
      type: String,
      required: !0
    },
    width: {
      type: Number,
      default: 300
    },
    padding: {
      type: Number,
      default: 0
    },
    url: {
      type: String,
      required: !0
    },
    color: {
      type: String,
      default: "#000000"
    },
    allowDownload: {
      type: Boolean
    },
    showOnlyButton: {
      type: Boolean
    }
  },
  setup(e) {
    const { t: n } = te(), t = e, a = D();
    function o() {
      a.value && co(a.value, { scale: 8 }).then((d) => {
        const r = document.createElement("a");
        r.download = `qrCode-${t.id}.png`, r.href = d.toDataURL("image/png"), r.click();
      });
    }
    function s() {
      return t.allowDownload && !t.showOnlyButton || t.allowDownload && t.showOnlyButton ? !0 : !(!t.allowDownload && !t.showOnlyButton);
    }
    function i() {
      return t.showOnlyButton ? {
        position: "absolute",
        left: "-20000px"
      } : {};
    }
    return (d, r) => (l(), g("div", ou, [
      c("figure", {
        ref_key: "qrRef",
        ref: a,
        class: "qrcode",
        style: le(i())
      }, [
        L(u(Ha), {
          "data-testid": `CbQrCode-${e.id}`,
          value: e.url,
          tag: "svg",
          options: {
            errorCorrectionLevel: "Q",
            width: e.width,
            margin: e.padding,
            color: {
              dark: e.color
            }
          }
        }, null, 8, ["data-testid", "value", "options"]),
        c("div", nu, [
          L(u(tu), {
            width: e.width / 100 * 18,
            height: e.width / 100 * 18
          }, null, 8, ["width", "height"])
        ])
      ], 4),
      N(d.$slots, "button", {
        buttonVisibility: s(),
        downloadQr: o
      }, () => [
        s() ? (l(), P(re, {
          key: 0,
          type: "button",
          class: "mt-5 inline-block justify-center m-auto",
          "data-testid": "CbQrCode-downloadButton",
          onClick: o
        }, {
          default: A(() => [
            su,
            X(H(u(n)("Download QR")), 1)
          ]),
          _: 1
        })) : E("", !0)
      ], !0)
    ]));
  }
});
const Zm = /* @__PURE__ */ ee(iu, [["__scopeId", "data-v-a7759a6c"]]);
function lu({
  image: e,
  imageType: n,
  endpoint: t,
  requestHeaders: a,
  authToken: o,
  route: s
}) {
  return !o || !(s != null && s.params.clubHash) || !t ? Promise.reject() : fetch(`${t}/api/clubs/${s.params.clubHash}/files`, {
    method: "POST",
    headers: {
      "Content-type": "application/json;charset=UTF-8",
      accept: "application/ld+json",
      Authorization: `Bearer ${o}`,
      ...a
    },
    body: JSON.stringify({
      content: e.content,
      type: n || "portal_image",
      mimeType: e.mimeType
    })
  }).then((i) => i.json());
}
function ru({
  fileId: e,
  endpoint: n,
  requestHeaders: t,
  authToken: a,
  route: o
}) {
  return !a || !(o != null && o.params.clubHash) || !n ? Promise.reject() : fetch(`${n}/api/clubs/${o.params.clubHash}/files/${e}`, {
    method: "DELETE",
    headers: {
      "Content-type": "application/json;charset=UTF-8",
      accept: "application/ld+json",
      Authorization: `Bearer ${a}`,
      ...t
    }
  });
}
let Bt = "";
const Ke = "flex items-center p-1 cursor-pointer hover:bg-base-200";
function du(e, n, t, a) {
  const o = t.style.cssText, s = document.createElement("div"), i = document.createElement("i"), d = document.createElement("i"), r = document.createElement("i");
  s.setAttribute(
    "class",
    "absolute top-0 left-1/2 w-32 h-8 z-50 bg-white rounded border border-base-500 cursor-pointer flex justify-between items-center py-1 px-2 -translate-x-1/2 -translate-y-1/2"
  ), i.setAttribute("class", `${Ke} bi bi-text-left`), d.setAttribute("class", `${Ke} bi bi-text-center`), r.setAttribute("class", `${Ke} bi bi-text-right`), i.addEventListener("click", () => {
    n.setAttribute("style", "display: flex; justify-content: flex-start;"), t.setAttribute("style", `${o} justify-content: flex-start;`), a();
  }), d.addEventListener("click", () => {
    n.setAttribute("style", "display: flex; justify-content: center;"), t.setAttribute("style", `${o} justify-content: center;`), a();
  }), r.addEventListener("click", () => {
    n.setAttribute("style", "display: flex; justify-content: flex-end;"), t.setAttribute("style", `${o} justify-content: flex-end;`), a();
  }), s.appendChild(i), s.appendChild(d), s.appendChild(r), e.appendChild(s);
}
function uu(e, n, t, a) {
  var s;
  n.appendChild(e);
  const o = (s = t.style) == null ? void 0 : s.match(/justify-content: (.*?);/);
  n.setAttribute(
    "style",
    `display: flex; ${o ? o[0] : ""}`
  ), o && (a.className = `tiptap-image-${o[1]}`), e.setAttribute("style", `${t.style}`), e.appendChild(a), a.setAttribute("src", t.src), a.setAttribute("alt", t.alt), a.setAttribute("style", t.style), a.setAttribute("draggable", "true"), t["cluber-fileid"] && (Bt = t["cluber-fileid"]), a.setAttribute("cluber-fileid", Bt);
}
const cu = [
  "top: -4px; left: -4px; cursor: nwse-resize;",
  "top: -4px; right: -4px; cursor: nesw-resize;",
  "bottom: -4px; left: -4px; cursor: nesw-resize;",
  "bottom: -4px; right: -4px; cursor: nwse-resize;"
];
function mu(e, n, t, a, o) {
  let s = !1, i, d, r;
  e.addEventListener("click", () => {
    if (e.childElementCount > 3)
      for (let p = 0; p < 5; p += 1)
        e.removeChild(e.lastChild);
    du(e, n, a, o), e.setAttribute(
      "style",
      `position: relative; border: 1px dashed #6C6C6C; ${t} cursor: pointer;`
    ), Array.from({ length: 4 }, (p, h) => {
      const b = document.createElement("div");
      b.setAttribute("class", "absolute w-2 h-2 border border-base-900 rounded-full"), b.setAttribute("style", `${cu[h]}`), b.addEventListener("mousedown", (y) => {
        y.preventDefault(), s = !0, i = y.clientX, d = e.offsetWidth, r = e.offsetHeight;
        const w = (f) => {
          if (!s)
            return;
          const m = h % 2 === 0 ? -(f.clientX - i) : f.clientX - i, k = d / r, x = d + m, $ = x / k;
          e.style.width = `${x}px`, e.style.height = `${$}px`, a.style.width = `${x}px`, a.style.height = `${$ - 4}px`;
        }, v = () => {
          s && (s = !1), o(), document.removeEventListener("mousemove", w), document.removeEventListener("mouseup", v);
        };
        document.addEventListener("mousemove", w), document.addEventListener("mouseup", v);
      }), e.appendChild(b);
    });
  }), document.addEventListener("click", (p) => {
    const h = p.target;
    if (!(e.contains(h) || h.style.cssText === Ke)) {
      const y = e.getAttribute("style"), w = y == null ? void 0 : y.replace("border: 1px dashed #6C6C6C;", "");
      if (e.setAttribute("style", w), e.childElementCount > 3)
        for (let v = 0; v < 5; v += 1)
          e.removeChild(e.lastChild);
    }
  });
}
function pu(e, n, t, a, o) {
  const s = qt(t.attrs.src);
  lu({
    image: s,
    endpoint: n.endpoint,
    requestHeaders: n.requestCustomHeaders,
    authToken: n.authToken,
    route: n.route
  }).then(({ id: i }) => {
    o({ "cluber-fileid": i });
  }).catch(() => {
    e.commands.deleteRange({ from: a, to: a + t.nodeSize });
    const i = Error("Error uploading the image - File may be too large");
    e.emit("contentError", { editor: e, error: i, disableCollaboration: () => {
    } });
  });
}
const mt = mo.extend({
  name: "image-custom",
  addOptions() {
    var e;
    return {
      ...(e = this.parent) == null ? void 0 : e.call(this),
      endpoint: void 0,
      route: void 0,
      authToken: "",
      requestCustomHeaders: void 0
    };
  },
  addAttributes() {
    return {
      src: {
        default: null
      },
      alt: {
        default: ""
      },
      style: {
        default: "height: auto; cursor: pointer;"
      },
      "cluber-fileid": {}
    };
  },
  addNodeView() {
    return ({ node: e, editor: n, getPos: t }) => {
      const {
        view: a,
        options: { editable: o }
      } = n, s = e.attrs.style, i = document.createElement("div"), d = document.createElement("div"), r = document.createElement("img"), p = (h) => {
        if (typeof t == "function") {
          const b = {
            ...e.attrs,
            ...h,
            style: `${r.style.cssText}`
          };
          a.dispatch(a.state.tr.setNodeMarkup(t(), null, b));
        }
      };
      return e.attrs.src.indexOf("data:") === 0 && !e.attrs["cluber-fileid"] && pu(n, this.options, e, t(), p), uu(d, i, e.attrs, r), o ? (mu(d, i, s, r, p), {
        dom: i
      }) : { dom: r };
    };
  }
}), pt = po.extend({
  name: "emoji-search"
}), ba = (e) => (De("data-v-5d3de510"), e = e(), Ae(), e), gu = ["data-testid"], fu = { class: "border-t border-x border-base-300 bg-white dark:bg-base-900 px-2 pb-2 text-xl flex flex-wrap items-center" }, hu = /* @__PURE__ */ ba(() => /* @__PURE__ */ c("div", { class: "flex pr-2 mt-2 space-x-1" }, [
  /* @__PURE__ */ c("button", {
    type: "button",
    class: "active:bg-base-300 px-[.3rem] rounded-sm border border-base-200"
  }, " 😃 ")
], -1)), bu = /* @__PURE__ */ ba(() => /* @__PURE__ */ c("i", { class: "bi bi-send-fill text-white text-sm" }, null, -1)), vu = [
  bu
], yu = {
  key: 0,
  class: "bg-base-100 border border-t-0 border-base-300 text-right p-1 px-2 dark:bg-base-900"
}, ke = "bg-base-200 dark:bg-base-1000", ku = /* @__PURE__ */ _({
  __name: "CbRichtext",
  props: {
    id: {
      type: String,
      required: !0
    },
    charactersLimit: {
      type: Number,
      default: void 0
    },
    modelValue: {
      type: String,
      default: ""
    },
    output: {
      type: String,
      default: "html"
    },
    customEditorClasses: {
      type: String,
      default: ""
    },
    onlyRenderer: {
      type: Boolean
    },
    manualSubmit: {
      type: Boolean
    },
    endpointName: {
      type: String,
      default: "main"
    },
    requestCustomHeaders: {
      type: Object,
      default: void 0
    },
    shouldPreserveAttachments: {
      type: Function,
      default: () => !0
    }
  },
  emits: [
    "update:modelValue",
    "manual-submit",
    "no-token"
  ],
  setup(e, { emit: n }) {
    const t = ue(() => import("./Link-1eea9648.js")), a = ue(() => import("./Alignment-4f8cffc1.js")), o = ue(() => import("./List-9ff36bee.js")), s = ue(() => import("./Fonts-30d76c92.js")), i = ue(() => import("./Color-de7c7934.js")), d = ue(() => import("./History-59beadc5.js")), r = ue(() => import("./Emoji-1509e843.js")), p = ue(() => import("./Image-ad05f28d.js")), h = ue(() => import("./Separator-ed8596be.js")), b = xe(ea), y = xe(ta, () => ""), w = xe(aa), { t: v } = te(), { addAlert: f } = la(), m = e, k = n, x = D("");
    async function $(V) {
      var W;
      return y() ? !w || !((W = b == null ? void 0 : b.params) != null && W.clubHash) ? [] : Promise.all(
        // eslint-disable-next-line consistent-return
        V.map(async (j) => {
          if (j.type.includes("image") && j.attrs["cluber-fileid"] && !j.attrs.src)
            return fetch(`${w[m.endpointName]}/api/clubs/${b.params.clubHash}/files/${j.attrs["cluber-fileid"]}`, {
              method: "GET",
              headers: {
                "Content-type": "application/json;charset=UTF-8",
                accept: "application/ld+json",
                Authorization: `Bearer ${y()}`
              }
            }).then((Q) => Q.json()).then((Q) => ({
              "cluber-fileid": j.attrs["cluber-fileid"],
              ...Q
            }));
        })
      ).then((j) => Promise.all(j.map((Q) => Q))) : (k("no-token"), []);
    }
    function F(V) {
      ru({
        fileId: V,
        authToken: y(),
        endpoint: w == null ? void 0 : w[m.endpointName || "main"],
        requestHeaders: m.requestCustomHeaders,
        route: b
      });
    }
    async function S(V) {
      if (!V)
        return [];
      const W = [], j = V.getJSON();
      return j.content && j.content.forEach((Q) => {
        var ae;
        (ae = Q.type) != null && ae.includes("image") && W.push(Q);
      }), W.length === 0 ? (x.value = "images-loaded", j) : (await $(W).then((Q) => {
        j.content && (j.content.forEach((ae) => {
          var ge;
          if ((ge = ae.type) != null && ge.includes("image")) {
            const be = Q.find((C) => {
              var O;
              return (C == null ? void 0 : C["cluber-fileid"]) === ((O = ae.attrs) == null ? void 0 : O["cluber-fileid"]);
            });
            be && ae.attrs && (ae.attrs.src = be.url);
          }
        }), x.value = "images-loaded");
      }), j);
    }
    const R = T(() => m.onlyRenderer ? "p-0 disable-interaction" : "p-5"), B = D(""), U = D(/* @__PURE__ */ new Set()), M = go({
      content: m.modelValue,
      editable: !m.onlyRenderer,
      async onCreate() {
        var j;
        const V = await S(M.value), W = Et(V, [
          nt,
          st,
          it,
          mt,
          lt,
          rt,
          dt,
          pt
        ]);
        (j = M.value) == null || j.commands.setContent(W);
      },
      async onUpdate() {
        if (!M.value)
          return;
        const V = await S(M.value), W = Et(V, [
          nt,
          st,
          it,
          mt,
          lt,
          rt,
          dt,
          pt
        ]);
        B.value = Be.sanitize(W, { ADD_ATTR: ["cluber-fileid"] }), k("update:modelValue", B.value);
      },
      onContentError({ error: V }) {
        f({
          status: "danger",
          location: "upper-right",
          message: v(V.message),
          closeAfter: 6e3
        });
      },
      onDestroy() {
        if (!m.shouldPreserveAttachments()) {
          Array.from(U.value).forEach((j) => {
            F(j);
          });
          return;
        }
        const V = B.value.match(new RegExp('(?<=cluber-fileid=")(\\d+)(?=")', "g")) || [];
        Array.from(U.value).filter((j) => !V.includes(j)).forEach((j) => {
          F(j);
        });
      },
      extensions: [
        nt.configure({
          bulletList: {
            HTMLAttributes: {
              class: "list-disc px-3"
            }
          },
          orderedList: {
            HTMLAttributes: {
              class: "list-decimal px-3"
            }
          },
          heading: !1
        }),
        st.configure({
          HTMLAttributes: {
            class: "text-primary-300 underline"
          },
          openOnClick: !1
        }),
        fo.configure({ levels: [1, 2, 3] }).extend({
          renderHTML({ node: V, HTMLAttributes: W }) {
            const Q = this.options.levels.includes(V.attrs.level) ? V.attrs.level : this.options.levels[0], ae = {
              1: "text-4xl font-display",
              2: "text-3xl font-display",
              3: "text-2xl font-display"
            };
            return [
              `h${Q}`,
              // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
              ho(this.options.HTMLAttributes, W, {
                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                class: `${ae[Q]}`
              }),
              0
            ];
          }
        }),
        it.configure({
          types: ["heading", "paragraph"]
        }),
        lt.configure({
          limit: m.charactersLimit
        }),
        mt.configure({
          allowBase64: !0,
          route: b,
          authToken: y(),
          requestCustomHeaders: m.requestCustomHeaders,
          endpoint: w == null ? void 0 : w[m.endpointName || "main"]
        }),
        rt,
        dt,
        pt.configure({
          suggestion: {
            char: ":",
            allowSpaces: !1,
            items: () => [],
            render: () => {
              let V, W;
              return {
                onStart({ clientRect: j, range: Q }) {
                  M.value && (V = new bo(r, {
                    props: {
                      editor: M.value,
                      range: Q,
                      offset: 20
                    },
                    editor: M.value
                  }), j && (W = Ra("body", {
                    getReferenceClientRect: j,
                    appendTo: () => document.body,
                    content: V.element,
                    showOnCreate: !0,
                    interactive: !0,
                    trigger: "manual",
                    placement: "bottom-start"
                  })));
                },
                onUpdate({ query: j, range: Q }) {
                  V != null && V.props && (V.props.text = j, V.props.range = Q);
                },
                onExit() {
                  W[0].destroy(), V && V.destroy();
                }
              };
            }
          }
        })
      ],
      editorProps: {
        attributes: {
          class: `${R.value} mx-auto focus:outline-hidden ${m.customEditorClasses}`
        }
      }
    });
    K(() => m.modelValue, (V) => {
      var W;
      V !== B.value && ((W = M.value) == null || W.commands.setContent(V));
    }), Ce(() => {
      var V;
      M.value && ((V = M.value) == null || V.destroy());
    });
    function q(V) {
      var ae;
      const W = V;
      if (!(((ae = W.tagName) == null ? void 0 : ae.toLowerCase()) === "img"))
        return;
      W.removeAttribute("alt");
      const Q = W.getAttribute("cluber-fileid");
      Q && (U.value.add(Q), W.setAttribute("src", ""));
    }
    Ut(() => {
      Be.addHook("afterSanitizeAttributes", q);
    }), Ce(() => {
      Be.removeHook("afterSanitizeAttributes");
    }), K(() => m.onlyRenderer, () => {
      var V;
      (V = M.value) == null || V.setOptions({
        editable: !m.onlyRenderer,
        editorProps: {
          attributes: {
            class: `${R.value} mx-auto focus:outline-hidden ${m.customEditorClasses} select-none`
          }
        }
      });
    });
    function G() {
      M.value && (k("manual-submit", Be.sanitize(M.value.getHTML())), M.value.commands.setContent("", !1));
    }
    return (V, W) => {
      var j;
      return u(M) ? (l(), g("div", {
        key: x.value,
        "data-testid": (j = V.$attrs) == null ? void 0 : j["data-testid"],
        class: I({ "hide-images-until-loaded": !x.value })
      }, [
        e.onlyRenderer ? (l(), P(u(_t), {
          key: 0,
          editor: u(M),
          "is-editable": !1
        }, null, 8, ["editor"])) : (l(), g(Y, { key: 1 }, [
          c("div", fu, [
            L(u(d), {
              id: e.id,
              editor: u(M),
              "active-button-bg": ke
            }, null, 8, ["id", "editor"]),
            L(u(h)),
            L(u(s), {
              id: e.id,
              editor: u(M),
              "active-button-bg": ke
            }, null, 8, ["id", "editor"]),
            L(u(h)),
            L(u(a), {
              id: e.id,
              editor: u(M),
              "active-button-bg": ke
            }, null, 8, ["id", "editor"]),
            L(u(h)),
            L(u(o), {
              id: e.id,
              editor: u(M),
              "active-button-bg": ke
            }, null, 8, ["id", "editor"]),
            L(u(h)),
            L(u(i), {
              id: e.id,
              editor: u(M),
              "active-button-bg": ke
            }, null, 8, ["id", "editor"]),
            L(u(h)),
            L(We, null, {
              button: A(() => [
                hu
              ]),
              menu: A(() => [
                L(u(r), {
                  id: e.id,
                  editor: u(M),
                  "active-button-bg": ke,
                  range: {
                    from: u(M).state.selection.anchor,
                    to: u(M).state.selection.head
                  },
                  text: ""
                }, null, 8, ["id", "editor", "range"])
              ]),
              _: 1
            }),
            L(u(h)),
            L(u(t), {
              id: e.id,
              editor: u(M),
              "active-button-bg": ke
            }, null, 8, ["id", "editor"]),
            L(u(p), {
              id: e.id,
              editor: u(M),
              "active-button-bg": ke,
              "endpoint-name": e.endpointName,
              "request-headers": e.requestCustomHeaders
            }, null, 8, ["id", "editor", "endpoint-name", "request-headers"]),
            e.manualSubmit ? (l(), g("span", {
              key: 0,
              class: "ml-auto rounded-full h-3 w-3 mt-2 bg-primary-500 p-4 flex items-center justify-center hover:shadow-lg hover:bg-primary-300 cursor-pointer rotate-45 mr-[.1rem] active:bg-primary-700",
              onClick: G,
              onKeydown: fe(G, ["enter"])
            }, vu, 32)) : E("", !0)
          ]),
          L(u(_t), {
            editor: u(M),
            class: "border border-base-300 dark:bg-base-800"
          }, null, 8, ["editor"]),
          e.charactersLimit ? (l(), g("div", yu, [
            c("p", {
              class: I([
                "text-base-700 dark:text-base-300 text-sm",
                { "text-danger-500": u(M).storage.characterCount.characters() >= e.charactersLimit }
              ])
            }, H(u(v)("{current}/{limit} characters", { current: u(M).storage.characterCount.characters(), limit: e.charactersLimit })), 3)
          ])) : E("", !0)
        ], 64))
      ], 10, gu)) : E("", !0);
    };
  }
});
const ep = /* @__PURE__ */ ee(ku, [["__scopeId", "data-v-5d3de510"]]), wu = ["id", "data-testid"], xu = ["id", "data-testid"], tp = /* @__PURE__ */ _({
  inheritAttrs: !1,
  __name: "CbScrollShadow",
  props: {
    id: {
      type: String,
      default: "default"
    },
    offsetPx: {
      type: Number,
      default: 10
    }
  },
  setup(e) {
    const n = e, { width: t, height: a } = Xt(), o = D(), s = D(), i = D(), d = D(), r = new AbortController();
    function p() {
      if (!o.value || !s.value)
        return;
      const b = o.value.scrollHeight - s.value.offsetHeight, y = o.value.scrollTop / b;
      i.value.style.opacity = y, d.value.style.opacity = 1 - y;
    }
    function h() {
      o.value && s.value && i.value && d.value && (o.value.scrollHeight - n.offsetPx > o.value.clientHeight || (i.value.style.opacity = 0, d.value.style.opacity = 0));
    }
    return K([t, a], () => {
      h();
    }), ne(() => {
      var b;
      h(), (b = o.value) == null || b.addEventListener("scroll", p, { signal: r.signal });
    }), Ce(() => {
      r.abort();
    }), (b, y) => (l(), g("div", {
      id: `CbScrollShadow--wrapper-${e.id}`,
      ref_key: "wrapper",
      ref: s,
      class: "relative",
      "data-testid": `CbScrollShadow--wrapper-${e.id}`
    }, [
      c("div", {
        ref_key: "shadowTop",
        ref: i,
        class: "cb__scrollshadow cb__scrollshadow--top"
      }, null, 512),
      c("div", {
        ref_key: "shadowBottom",
        ref: d,
        class: "cb__scrollshadow cb__scrollshadow--bottom"
      }, null, 512),
      c("div", he({
        id: `CbScrollShadow--content-${e.id}`,
        ref_key: "content",
        ref: o,
        "data-testid": `CbScrollShadow--content-${e.id}`
      }, b.$attrs, { class: "overflow-y-scroll" }), [
        N(b.$slots, "default")
      ], 16, xu)
    ], 8, wu));
  }
});
const Su = ["name", "checked", "disabled"], $u = { class: "ml-3 text-sm font-medium text-gray-900 dark:text-gray-300" }, ap = /* @__PURE__ */ _({
  __name: "CbSwitch",
  props: {
    modelValue: {
      type: [String, Boolean, Array],
      default: !1
    },
    truthyValue: {
      type: [String, Boolean, Number],
      default: !0
    },
    falsyValue: {
      type: [String, Boolean, Number],
      default: !1
    },
    name: {
      type: String,
      default: "switch"
    },
    disabled: {
      type: Boolean
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = n, a = e, o = T(() => a.modelValue === a.truthyValue);
    function s(i) {
      const { checked: d } = i.target;
      t("update:modelValue", d ? a.truthyValue : a.falsyValue);
    }
    return (i, d) => (l(), g("label", {
      class: I([
        "relative inline-flex items-center",
        { "cursor-pointer": !e.disabled }
      ])
    }, [
      c("input", {
        name: e.name,
        type: "checkbox",
        value: "",
        class: "sr-only",
        checked: o.value,
        disabled: e.disabled,
        onChange: s
      }, null, 40, Su),
      c("div", {
        class: I([
          "w-14 h-7 flex items-center rounded-full px-1",
          o.value ? "bg-primary-500" : "bg-secondary-100"
        ])
      }, [
        c("div", {
          class: I([
            "bg-white w-5 h-5 rounded-full shadow-md transform transition-all",
            { "translate-x-7": o.value }
          ])
        }, null, 2)
      ], 2),
      c("span", $u, [
        N(i.$slots, "default")
      ])
    ], 2));
  }
});
function va(e) {
  const n = D([]);
  function t(r) {
    return n.value ? n.value.indexOf(r) >= 0 : !1;
  }
  function a(r) {
    t(r) || n.value.push(r);
  }
  function o(r) {
    t(r) && n.value.splice(n.value.indexOf(r), 1);
  }
  function s(r) {
    t(r) ? o(r) : a(r);
  }
  function i(r, p, h, b) {
    b.stopPropagation(), e("detail-row-clicked", {
      rowId: r,
      rowIndex: p,
      row: h,
      event: b
    });
  }
  function d(r, p, h) {
    return typeof h == "function" ? h(r, p) : h;
  }
  return {
    isVisibleDetailRow: t,
    toggleDetailRow: s,
    onDetailRowClick: i,
    onDetailRowClass: d
  };
}
var ve = /* @__PURE__ */ ((e) => (e.Asc = "asc", e.Desc = "desc", e.Both = "both", e))(ve || {}), ya = /* @__PURE__ */ ((e) => (e.Key = "key", e.Row = "row", e))(ya || {});
function Cu(e) {
  const n = window.getSelection();
  ((n == null ? void 0 : n.type) !== "Range" || n.toString().length === 0) && e();
}
function ka(e, n, t, a, o, s, i, d, r) {
  function p() {
    const v = new Intl.Collator(void 0, {
      numeric: !0,
      sensitivity: "base"
    }), f = t.value.direction === ve.Desc ? -1 : 1;
    return e.value.sort((m, k) => v.compare(
      m[t.value.field],
      k[t.value.field]
    ) * f);
  }
  const h = T(() => {
    if (!e.value.length)
      return [];
    const v = [], f = r != null && r.value ? e.value : p();
    if (a.value && o.value)
      for (let m = s.value - 1; m < o.value; m += 1)
        v.push(f[m]);
    else
      for (let m = 0; m < f.length; m += 1)
        v.push(f[m]);
    return v;
  });
  function b(v, f, m, k) {
    n.value && Cu(
      () => i(v)
    ), d("row-clicked", {
      rowId: v,
      rowIndex: f,
      row: m,
      event: k
    });
  }
  function y(v, f) {
    const m = v[f.field];
    return f.formatter ? f.formatter(m) : m;
  }
  function w(v, f) {
    if (f)
      return typeof f == "string" ? f : f(v);
  }
  return {
    localRows: h,
    rowClick: b,
    checkFormatter: y,
    setFieldClassName: w
  };
}
function wa(e) {
  const n = T(() => e.pageSize || 10), t = T(() => e.pagination ? e.pagination : {
    page: e.page || 1,
    totalItems: e.rows.length || 0
  }), a = e.itemsToShow && e.itemsToShow.length > 0 ? D(e.itemsToShow[0]) : D(e.pageSize);
  e.itemsToShow && e.itemsToShow.length > 0 && e.itemsToShow.forEach((d) => {
    e.pageSize === d && (a.value = d);
  });
  const o = T(() => {
    const { totalItems: d } = t.value;
    if (!d || d <= 0)
      return 0;
    let r = Math.floor(d / n.value);
    return e.localMode && d % n.value > 0 && (r += 1), r === 0 ? 1 : r;
  }), s = T(() => (t.value.page - 1) * n.value + 1), i = T(() => {
    const d = t.value.page * n.value;
    return t.value.totalItems && t.value.totalItems >= d ? d : t.value.totalItems;
  });
  return {
    offset: s,
    limit: i,
    maxPage: o,
    paginationObject: t
  };
}
const Du = {
  key: 1,
  class: "cb-thead bg-white dark:bg-base-800"
}, Au = { class: "cb-thead-tr" }, Tu = ["data-testid", "onClick"], Mu = { class: "font-light" }, Iu = /* @__PURE__ */ _({
  __name: "CbTableHead",
  props: {
    hasCheckbox: {
      type: Boolean
    },
    hasDragdrop: {
      type: Boolean
    },
    isFixedHeader: {
      type: String,
      default: ""
    },
    tableId: {
      type: String,
      default: ""
    },
    indeterminate: {
      type: Boolean
    },
    columns: {
      type: Array,
      default: () => []
    },
    sortable: {
      type: Object,
      default: () => ({
        order: "id",
        sort: ve.Asc
      })
    },
    isAllChecked: {
      type: Boolean
    },
    isLoading: {
      type: Boolean
    },
    responsive: {
      type: Boolean
    },
    hiddenColumns: {
      type: Array,
      default: () => []
    }
  },
  emits: [
    "sort",
    "all-checked"
  ],
  setup(e) {
    const { t: n } = te(), t = {
      left: "text-left",
      right: "text-right",
      center: "text-center"
    };
    function a(o) {
      return o.alignment ? t[o.alignment] : t.left;
    }
    return (o, s) => e.responsive ? (l(), g(Y, { key: 0 }, [
      e.hasCheckbox ? (l(), g("div", {
        key: 0,
        class: I([
          "flex cursor-pointer items-center cb-thead-responsive cb-checkboxall-responsive ml-3",
          e.isFixedHeader
        ]),
        "data-testid": "checkboxAll"
      }, [
        L(ye, {
          id: `checkbox-checkall-${e.tableId}`,
          type: "checkbox",
          disabled: e.isLoading,
          value: e.isAllChecked,
          "aria-label": "allCheckbox",
          onInput: s[0] || (s[0] = (i) => o.$emit("all-checked", i))
        }, null, 8, ["id", "disabled", "value"]),
        c("p", null, H(u(n)("Select all")), 1)
      ], 2)) : E("", !0)
    ], 64)) : (l(), g("thead", Du, [
      c("tr", Au, [
        e.hasDragdrop ? (l(), g("th", {
          key: 0,
          class: I([
            "cb-thead-th cb-dragdrop-th",
            e.isFixedHeader
          ]),
          "data-testid": "dragdropAll"
        }, null, 2)) : E("", !0),
        e.hasCheckbox ? (l(), g("th", {
          key: 1,
          class: I([
            "cb-thead-th cb-checkbox-th",
            e.isFixedHeader
          ]),
          "data-testid": "checkboxAll"
        }, [
          (l(), P(ye, {
            id: `checkbox-checkall-${e.tableId}`,
            key: `checkbox-checkall-${e.tableId}-${e.isAllChecked}`,
            type: "checkbox",
            disabled: e.isLoading,
            value: e.isAllChecked,
            "aria-label": "allCheckbox",
            onInput: s[1] || (s[1] = (i) => o.$emit("all-checked", i))
          }, null, 8, ["id", "disabled", "value"]))
        ], 2)) : E("", !0),
        (l(!0), g(Y, null, J(e.columns, (i, d) => (l(), g(Y, { key: d }, [
          e.hiddenColumns.includes(i.label) ? E("", !0) : (l(), g("th", {
            key: 0,
            class: I([
              "cb-thead-th",
              i.headerClasses,
              e.isFixedHeader
            ]),
            style: le({
              width: i.width || "auto",
              ...i.headerStyles
            })
          }, [
            c("div", {
              class: I([
                "cb-thead-column font-body text-secondary-300 dark:text-primary-200 select-none",
                { "cursor-pointer": i.sortable && !e.hasDragdrop },
                a(i)
              ]),
              "data-testid": i.sortable ? `sortable-column-${i.field}` : "",
              onClick: ie((r) => i.sortable && !e.hasDragdrop ? o.$emit("sort", i.field) : !1, ["prevent"]),
              onKeydown: () => {
              }
            }, [
              i.tooltip ? (l(), P(ga, {
                key: 0,
                class: "inline-block",
                nowrap: i.tooltip.nowrapText,
                placement: i.tooltip.placement
              }, {
                trigger: A(() => [
                  X(H(i.label), 1)
                ]),
                tooltip: A(() => [
                  c("span", Mu, H(i.tooltip.text), 1)
                ]),
                _: 2
              }, 1032, ["nowrap", "placement"])) : (l(), g(Y, { key: 1 }, [
                X(H(i.label), 1)
              ], 64)),
              c("span", {
                class: I([
                  "bi",
                  { hidden: e.hasDragdrop },
                  // Do not allow SORT if drag and drop
                  {
                    "cb-sortable": i.sortable,
                    "cb-sortable-up": e.sortable.field === i.field && e.sortable.direction === u(ve).Asc,
                    "cb-sortable-down": e.sortable.field === i.field && e.sortable.direction === u(ve).Desc
                  }
                ])
              }, null, 2)
            ], 42, Tu)
          ], 6))
        ], 64))), 128))
      ])
    ]));
  }
});
const xa = /* @__PURE__ */ ee(Iu, [["__scopeId", "data-v-7cea06c1"]]), Lu = ["data-testid"], Fu = { class: "p-5" }, Pu = { class: "font-bold block mr-2 underline" }, Ou = ["name"], Eu = { key: 0 }, Sa = /* @__PURE__ */ _({
  __name: "CbTableLoading",
  props: {
    pageSize: {
      type: Number,
      default: 10
    },
    responsive: {
      type: Boolean
    },
    hasDetailRows: {
      type: Boolean
    },
    hasCheckbox: {
      type: Boolean
    },
    tableId: {
      type: String,
      default: ""
    },
    columns: {
      type: Array,
      default: () => []
    }
  },
  setup(e) {
    return (n, t) => e.responsive ? (l(!0), g(Y, { key: 0 }, J(e.pageSize, (a, o) => (l(), P(Te, {
      key: a,
      class: I([
        "mt-2 relative",
        { "bg-secondary-50! dark:bg-base-800!": u(Ve)(o) },
        { flex: e.hasCheckbox }
      ])
    }, {
      default: A(() => [
        e.hasCheckbox ? (l(), g("div", {
          key: 0,
          class: "mt-5 ml-3",
          "data-testid": `checkbox_${o + 1}`
        }, [
          L(ye, {
            id: `checkbox-loading-${o}-${e.tableId}`,
            type: "checkbox",
            value: !1,
            disabled: !0
          }, null, 8, ["id"])
        ], 8, Lu)) : E("", !0),
        c("div", null, [
          c("div", Fu, [
            (l(!0), g(Y, null, J(e.columns, (s, i) => (l(), g("div", {
              key: s.field,
              class: I([
                { "mt-3": i !== 0 },
                { "last:mb-3": e.hasDetailRows }
              ])
            }, [
              c("span", Pu, H(s.label), 1),
              L(u(Nt), {
                delay: 0,
                "is-loading": !0
              })
            ], 2))), 128))
          ])
        ])
      ]),
      _: 2
    }, 1032, ["class"]))), 128)) : (l(!0), g(Y, { key: 1 }, J(e.pageSize, (a, o) => (l(), g("tr", {
      key: a,
      name: `cb-group-${a}`,
      class: I([
        "cb-tbody-tr",
        { "bg-secondary-50 dark:bg-base-800": !u(Ve)(o) },
        { "cursor-pointer": e.hasDetailRows }
      ])
    }, [
      e.hasCheckbox ? (l(), g("td", Eu, [
        L(ye, {
          id: `checkbox-loading-${o}-${e.tableId}`,
          type: "checkbox",
          value: !1,
          disabled: !0
        }, null, 8, ["id"])
      ])) : E("", !0),
      (l(!0), g(Y, null, J(e.columns, (s, i) => (l(), g("td", {
        key: i,
        class: I([
          "cb-tbody-td",
          s.columnClasses
        ]),
        style: le(s.columnStyles)
      }, [
        L(u(Nt), {
          delay: 0,
          "is-loading": !0
        })
      ], 6))), 128))
    ], 10, Ou))), 128));
  }
});
function _u() {
  function e(n) {
    return typeof n.hideMobileLabel == "function" ? n.hideMobileLabel() : n.hideMobileLabel;
  }
  return {
    isLabelHidden: e
  };
}
const $a = [
  "change-page",
  "change-row-order",
  "set-visible-rows",
  "checked-rows",
  "sort-column",
  "row-clicked",
  "row-toggled",
  "detail-row-clicked",
  "all-checked",
  "drag-change",
  "drag-choose",
  "drag-unchoose",
  "drag-start",
  "drag-end",
  "drag-add",
  "drag-update",
  "drag-sort",
  "drag-remove",
  "drag-filter",
  "drag-move",
  "drag-move-capture",
  "drag-clone"
], Ca = {
  checkedReturnType: ya.Key,
  title: "",
  responsiveBelowSize: "--breakpoint-md",
  columns: () => [],
  rowClasses: () => [],
  pageSize: 10,
  page: 1,
  pagination: void 0,
  sortable: () => ({
    field: "id",
    direction: ve.Asc
  }),
  itemsToShow: () => [10, 25, 50],
  maxHeight: "auto",
  detailRowClass: "cb-table-detail-row",
  trackingKey: "id",
  allowDragDrop: !1,
  allowColumnToggle: !1
}, Nu = ["data-testid"], zu = { class: "w-full" }, Bu = { class: "p-5 pl-2" }, Vu = {
  key: 0,
  class: "block mr-2 font-bold"
}, Hu = ["onClick", "onKeydown"], Ru = { class: "p-3" }, qu = /* @__PURE__ */ _({
  __name: "CbTableMobile",
  props: /* @__PURE__ */ St({
    tableId: {},
    responsiveBelowSize: {},
    isLoading: { type: Boolean },
    hasCheckbox: { type: Boolean },
    checkedReturnType: {},
    title: {},
    isFixedFirstColumn: { type: Boolean },
    columns: {},
    rows: {},
    rowClasses: { type: [Array, Function] },
    pageSize: {},
    page: {},
    pagination: {},
    sortable: {},
    isPaginationHidden: { type: Boolean },
    itemsToShow: {},
    localMode: { type: Boolean },
    maxHeight: {},
    fixedHeader: { type: Boolean },
    hasDetailRows: { type: Boolean },
    detailRowClass: { type: [String, Function] },
    trackingKey: {},
    allowDragDrop: { type: Boolean },
    allowColumnToggle: { type: Boolean },
    offset: {},
    keyColumn: {},
    columnsSelectedToHide: {}
  }, {
    ...Ca,
    keyColumn: "id",
    offset: 1,
    columnsSelectedToHide: () => []
  }),
  emits: $a,
  setup(e, { emit: n }) {
    const t = n, a = e, {
      checkItem: o,
      checkedItems: s,
      indeterminate: i,
      isAllChecked: d
    } = Mt({
      props: a,
      offset: a.offset,
      keyField: a.keyColumn,
      emit: t
    }), {
      offset: r,
      limit: p
    } = wa(a), {
      isVisibleDetailRow: h,
      toggleDetailRow: b,
      onDetailRowClick: y,
      onDetailRowClass: w
    } = va(t), {
      localRows: v,
      setFieldClassName: f,
      checkFormatter: m,
      rowClick: k
    } = ka(
      ce(a, "rows"),
      ce(a, "hasDetailRows"),
      ce(a, "sortable"),
      ce(a, "localMode"),
      p,
      r,
      b,
      t
    ), { isLabelHidden: x } = _u();
    return ($, F) => (l(), g("div", null, [
      L(xa, {
        "is-loading": $.isLoading,
        responsive: "",
        "has-checkbox": $.hasCheckbox,
        "is-fixed-header": "",
        "table-id": $.tableId,
        indeterminate: u(u(i)),
        columns: $.columns,
        sortable: $.sortable,
        "is-all-checked": u(u(d)),
        onSort: F[0] || (F[0] = (S) => $.$emit("sort", S)),
        onAllChecked: F[1] || (F[1] = (S) => $.$emit("all-checked", S))
      }, null, 8, ["is-loading", "has-checkbox", "table-id", "indeterminate", "columns", "sortable", "is-all-checked"]),
      $.isLoading ? (l(), P(Sa, {
        key: 0,
        "page-size": $.pageSize,
        responsive: "",
        "has-detail-rows": $.hasDetailRows,
        "has-checkbox": $.hasCheckbox,
        "table-id": $.tableId,
        columns: $.columns
      }, null, 8, ["page-size", "has-detail-rows", "has-checkbox", "table-id", "columns"])) : u(v).length ? (l(!0), g(Y, { key: 1 }, J(u(v), (S, R) => (l(), P(Te, {
        key: S[$.keyColumn] ? S[$.keyColumn] : R,
        class: I([
          "mt-2 relative",
          { "bg-secondary-50! dark:bg-base-900!": u(Ve)(R) },
          $.hasDetailRows ? u(h)(S[a.keyColumn]) ? "pb-8" : "pb-3" : "",
          { "flex flex-wrap": $.hasCheckbox }
        ]),
        onClick: (B) => u(k)(S[a.keyColumn], R, S, B)
      }, {
        default: A(() => [
          $.hasCheckbox ? (l(), g("div", {
            key: 0,
            class: "mt-5 ml-3",
            "data-testid": `checkbox_${R + 1}`,
            onClick: F[3] || (F[3] = (B) => B.stopPropagation()),
            onKeydown: () => {
            }
          }, [
            (l(), P(ye, {
              id: `checkbox-check-${R}-${$.tableId}`,
              key: `checkbox-${R}-${u(d)}`,
              type: "checkbox",
              disabled: $.isLoading,
              value: S && S[a.keyColumn] ? u(s).includes(S[a.keyColumn]) : !1,
              "aria-label": `checkbox-${R}`,
              onInput: (B) => u(o)(S, !!B),
              onClick: F[2] || (F[2] = (B) => B.stopPropagation())
            }, null, 8, ["id", "disabled", "value", "aria-label", "onInput"]))
          ], 40, Nu)) : E("", !0),
          c("div", zu, [
            c("div", Bu, [
              (l(!0), g(Y, null, J($.columns, (B, U) => (l(), g(Y, {
                key: B.field
              }, [
                a.columnsSelectedToHide.includes(B.label) ? E("", !0) : (l(), g("div", {
                  key: 0,
                  class: I([
                    "border-b last:border-b-0 pb-2",
                    u(Ve)(R) ? "border-base-500" : "border-base-200",
                    { "mt-3": U !== 0 },
                    { "last:mb-3": $.hasDetailRows }
                  ])
                }, [
                  u(x)(B) ? E("", !0) : (l(), g("span", Vu, H(B.label), 1)),
                  N($.$slots, "slotColumn", {
                    column: B,
                    row: S,
                    rowIndex: R
                  }),
                  !B.isSlot && !$.$slots[B.field] ? (l(), g("span", {
                    key: 1,
                    class: I(u(f)(S, B.columnClasses))
                  }, H(S && S[B.field] ? u(m)(S, B) : ""), 3)) : E("", !0)
                ], 2))
              ], 64))), 128))
            ])
          ]),
          u(h)(S[a.keyColumn]) ? (l(), g("div", {
            key: 1,
            class: I(u(w)(S, R, a.detailRowClass)),
            onClick: (B) => u(y)(S[a.keyColumn], R, S, B),
            onKeydown: fe((B) => u(y)(S[a.keyColumn], R, S, B), ["enter"])
          }, [
            c("div", Ru, [
              N($.$slots, "detailRow", {
                row: S,
                rowIndex: R
              })
            ])
          ], 42, Hu)) : E("", !0),
          $.hasDetailRows ? (l(), g("span", {
            key: 2,
            class: I([
              "bi text-center absolute bottom-[.2rem] border-t w-full cursor-pointer",
              u(h)(S[a.keyColumn]) ? "bi-arrow-up-short" : "bi-arrow-down-short",
              u(Ve)(R) ? "border-base-300" : "border-base-200"
            ])
          }, null, 2)) : E("", !0)
        ]),
        _: 2
      }, 1032, ["class", "onClick"]))), 128)) : E("", !0)
    ]));
  }
}), Ze = (e) => (De("data-v-5b9e86a5"), e = e(), Ae(), e), Wu = {
  key: 0,
  class: "cb-table-pagination flex flex-wrap justify-between items-end",
  "data-testid": "CbTable-pagination"
}, ju = { class: "col-sm-12 col-md-4 mr-4 mb-5" }, Yu = {
  role: "status",
  "aria-live": "polite",
  class: "text-ellipsis"
}, Ku = { class: "flex mb-5 space-x-3 ml-[10%]" }, Uu = { class: "flex items-center" }, Ju = { class: "flex items-center" }, Gu = { class: "col-sm-12 col-md-4 ml-4 mb-5" }, Qu = { class: "flex justify-end pl-0 mx-0 my-1 list-none rounded-sm whitespace-nowrap" }, Xu = /* @__PURE__ */ Ze(() => /* @__PURE__ */ c("span", { "aria-hidden": "true" }, "«", -1)), Zu = { class: "sr-only" }, ec = /* @__PURE__ */ Ze(() => /* @__PURE__ */ c("span", { "aria-hidden": "true" }, "<", -1)), tc = { class: "sr-only" }, ac = ["data-testid"], oc = ["onClick"], nc = /* @__PURE__ */ Ze(() => /* @__PURE__ */ c("span", { "aria-hidden": "true" }, ">", -1)), sc = { class: "sr-only" }, ic = /* @__PURE__ */ Ze(() => /* @__PURE__ */ c("span", { "aria-hidden": "true" }, "»", -1)), lc = { class: "sr-only" }, rc = /* @__PURE__ */ _({
  __name: "CbTablePagination",
  props: {
    id: {
      type: String,
      required: !0
    },
    isHidden: {
      type: Boolean
    },
    // Limit of items that could be shown on any page
    pageSize: {
      type: Number,
      default: 10
    },
    // Limit on items over pagination I.E showing items 10-20 from 6 pages -> limit is 20
    limit: {
      type: Number,
      default: 10
    },
    // Pagination offset
    offset: {
      type: Number,
      default: 1
    },
    // Last available page
    lastPage: {
      type: Number,
      default: 0
    },
    // Current page
    page: {
      type: Number,
      default: 1
    },
    itemsToShow: {
      type: Array,
      default: () => [10, 25, 50]
    }
  },
  emits: [
    "set-visible-rows",
    "change-page"
  ],
  setup(e, { emit: n }) {
    const t = n, a = e, { t: o } = te(), s = T(() => {
      let b = a.page - 2 <= 0 ? 1 : a.page - 2;
      a.lastPage - a.page <= 2 && (b = a.lastPage - 4), b = b <= 0 ? 1 : b;
      const y = [];
      for (let w = b; w <= a.lastPage; w += 1)
        y.length < 5 && y.push(w);
      return y;
    });
    function i() {
      a.page !== 1 && t("change-page", a.page - 1);
    }
    function d(b) {
      t("change-page", b);
    }
    function r() {
      a.page >= a.lastPage || t("change-page", a.page + 1);
    }
    const p = T(() => a.itemsToShow.map((b) => ({
      label: b.toString(),
      value: b.toString()
    }))), h = T(() => Array.from({ length: a.lastPage }, (b, y) => y + 1).map((b) => ({
      label: b.toString(),
      value: b.toString()
    })));
    return (b, y) => a.isHidden ? E("", !0) : (l(), g("div", Wu, [
      c("div", ju, [
        c("div", Yu, H(u(o)("Showing {0}-{1} of {2}", [
          e.offset,
          e.limit,
          e.lastPage
        ])), 1)
      ]),
      c("div", Ku, [
        c("div", Uu, [
          L(Re, {
            id: `table-to-show-selector-${e.id}`,
            label: u(o)("Show"),
            name: "itemsToShow",
            class: "whitespace-nowrap",
            options: p.value,
            "model-value": e.pageSize.toString(),
            "onUpdate:modelValue": y[0] || (y[0] = (w) => t("set-visible-rows", parseInt(w, 10)))
          }, null, 8, ["id", "label", "options", "model-value"])
        ]),
        c("div", Ju, [
          L(Re, {
            id: `table-page-selector-${e.id}`,
            label: u(o)("Go to page"),
            name: "selectPage",
            class: "whitespace-nowrap",
            options: h.value,
            "model-value": e.page.toString(),
            "onUpdate:modelValue": y[1] || (y[1] = (w) => d(parseInt(w, 10)))
          }, null, 8, ["id", "label", "options", "model-value"])
        ])
      ]),
      c("div", Gu, [
        c("div", null, [
          c("ul", Qu, [
            c("li", {
              class: I([
                "page-item",
                { disabled: a.page <= 1 }
              ]),
              "data-testid": "firstPage"
            }, [
              c("a", {
                class: "cursor-pointer page-link",
                "aria-label": "First",
                onClick: y[2] || (y[2] = ie((w) => t("change-page", 1), ["prevent"])),
                onKeydown: () => {
                }
              }, [
                Xu,
                c("span", Zu, H(u(o)("First page")), 1)
              ], 32)
            ], 2),
            c("li", {
              class: I([
                "page-item",
                { disabled: a.page <= 1 }
              ]),
              "data-testid": "previousPage"
            }, [
              c("a", {
                class: "cursor-pointer page-link",
                "aria-label": "Previous",
                onClick: ie(i, ["prevent"]),
                onKeydown: () => {
                }
              }, [
                ec,
                c("span", tc, H(u(o)("Previous page")), 1)
              ], 32)
            ], 2),
            (l(!0), g(Y, null, J(s.value, (w) => (l(), g("li", {
              key: w,
              "data-testid": `page_${w}`,
              class: I([
                "page-item",
                { "font-bold active": e.page.toString() === w.toString() }
              ])
            }, [
              c("a", {
                class: "cursor-pointer page-link",
                onClick: ie((v) => d(w), ["prevent"]),
                onKeydown: () => {
                }
              }, H(w), 41, oc)
            ], 10, ac))), 128)),
            c("li", {
              class: I([
                "page-item",
                { disabled: a.page >= a.lastPage }
              ]),
              "data-testid": "nextPage"
            }, [
              c("a", {
                class: "cursor-pointer page-link",
                "aria-label": "Next",
                onClick: ie(r, ["prevent"]),
                onKeydown: () => {
                }
              }, [
                nc,
                c("span", sc, H(u(o)("Next page")), 1)
              ], 32)
            ], 2),
            c("li", {
              class: I([
                "page-item",
                { disabled: a.page >= a.lastPage }
              ]),
              "data-testid": "lastPage"
            }, [
              c("a", {
                class: "cursor-pointer page-link",
                "aria-label": "Last",
                onClick: y[3] || (y[3] = ie((w) => t("change-page", a.lastPage), ["prevent"])),
                onKeydown: () => {
                }
              }, [
                ic,
                c("span", lc, H(u(o)("Last page")), 1)
              ], 32)
            ], 2)
          ])
        ])
      ])
    ]));
  }
});
const dc = /* @__PURE__ */ ee(rc, [["__scopeId", "data-v-5b9e86a5"]]), uc = { key: 0 }, cc = {
  key: 0,
  id: "newIndexCard",
  class: "flex items-center flex-wrap"
}, mc = { class: "flex items-center w-full" }, pc = { class: "flex items-center" }, gc = { class: "ml-2 flex items-center whitespace-nowrap" }, fc = { key: 0 }, hc = { class: "ml-auto space-x-2" }, bc = /* @__PURE__ */ _({
  __name: "CbTableDragNDrop",
  props: {
    tableId: {
      type: String,
      required: !0
    },
    trackingKey: {
      type: String,
      required: !0
    },
    showCard: {
      type: Boolean
    },
    rows: {
      type: Array,
      default: () => []
    },
    currentTablePage: {
      type: Number,
      default: 1
    },
    totalItems: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 10
    },
    limit: {
      type: Number,
      default: 10
    }
  },
  emits: [
    "change-row-order"
  ],
  setup(e) {
    const { t: n } = te(), t = e, a = D(!1), o = D(), s = D(!1), i = D(!1), d = D(!1), r = D();
    K(() => t.showCard, (v) => {
      d.value || (i.value = v), !v && d.value && (i.value = !0);
    });
    function p() {
      i.value = !1, d.value = !1, r.value = void 0, a.value = !1;
    }
    const h = D(null);
    gt(h, p);
    const b = T(() => {
      if (!o.value)
        return !1;
      if (typeof o.value == "string") {
        const v = parseInt(o.value, 10);
        if (v > t.limit || v < t.limit - t.pageSize)
          return !0;
      }
      return !1;
    }), y = T(() => {
      let v = 0;
      !r.value || r.value === 0 ? v = 0 : v = r.value;
      const f = t.currentTablePage - 1, m = v + 1;
      return f * 10 + m;
    }), w = D();
    return gt(w, () => {
      s.value = !1;
    }), (v, f) => {
      const m = pe("i18n-t"), k = pe("FormKit");
      return l(), P(k, {
        id: "moveRowIndexCard",
        ref: "moveRowIndexCard",
        type: "form",
        actions: !1,
        onSubmit: () => {
        }
      }, {
        default: A(({ state: { valid: x } }) => [
          i.value ? (l(), P(Te, {
            key: 0,
            ref_key: "cardWrapper",
            ref: h,
            class: I([
              "absolute bottom-0 left-[50%] translate-x-[-50%] w-4/5 transition-transform",
              "border-2 border-dashed border-primary-300 rounded-2xl",
              { "scale-105": a.value }
            ]),
            onDragover: f[7] || (f[7] = ($) => {
              a.value = !0;
            }),
            onDragleave: f[8] || (f[8] = () => {
              a.value = !1, s.value = !1;
            })
          }, {
            default: A(() => [
              d.value ? E("", !0) : (l(), g("i", {
                key: 0,
                class: "bi bi-x absolute top-0 right-1 text-2xl cursor-pointer",
                onClick: p,
                onKeydown: fe(p, ["enter"])
              }, null, 32)),
              L(u(Wt), {
                class: "sortable-hide-td p-8",
                list: e.rows,
                "item-key": e.trackingKey,
                tag: "div",
                options: {
                  group: {
                    name: `table_${e.tableId}`,
                    sort: !1
                  },
                  filter: "#newIndexCard",
                  disabled: s.value
                },
                onAdd: f[6] || (f[6] = ($) => {
                  d.value = !0, a.value = !1, s.value = !0, r.value = $.oldIndex;
                })
              }, {
                header: A(() => [
                  d.value ? E("", !0) : (l(), g("p", uc, H(u(n)("Drop rows here to move them to a row not shown on this page")), 1))
                ]),
                item: A(({ index: $ }) => {
                  var F;
                  return [
                    $ === r.value ? (l(), g("div", cc, [
                      c("div", mc, [
                        L(m, { keypath: "Move element from row {originalPosition} to:" }, {
                          originalPosition: A(() => [
                            L(At, {
                              class: "mx-2",
                              mode: "info"
                            }, {
                              default: A(() => [
                                X(H(y.value), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        c("div", pc, [
                          L(k, {
                            id: "newIndexInput",
                            ref_key: "refNewIndexInput",
                            ref: w,
                            modelValue: o.value,
                            "onUpdate:modelValue": f[0] || (f[0] = (S) => o.value = S),
                            type: "text",
                            validation: `max:${e.totalItems}|min:1`,
                            classes: {
                              outer: "ml-2 max-w-12",
                              input: "dark:bg-base-800!"
                            },
                            "validation-messages": {
                              max: u(n)("Last available row is {n}", { n: e.totalItems }),
                              min: u(n)("You cannot use zero or negative values")
                            },
                            onFocus: f[1] || (f[1] = (S) => s.value = !0),
                            onMouseover: f[2] || (f[2] = (S) => s.value = !0),
                            onMouseleave: f[3] || (f[3] = (S) => s.value = !1),
                            onBlur: f[4] || (f[4] = (S) => s.value = !1)
                          }, null, 8, ["modelValue", "validation", "validation-messages"]),
                          c("p", gc, [
                            x ? (l(), g("span", fc, H(u(n)("Max: {totalItems}", { totalItems: e.totalItems })), 1)) : E("", !0),
                            L(u(Ja), {
                              class: "basis-full ml-2 mt-0!",
                              node: (F = w.value) == null ? void 0 : F.node
                            }, null, 8, ["node"])
                          ])
                        ]),
                        c("div", hc, [
                          L(re, {
                            mode: "filled",
                            color: "primary",
                            disabled: !x,
                            onClick: f[5] || (f[5] = () => {
                              v.$emit("change-row-order", {
                                oldIndex: r.value,
                                newIndex: parseInt(o.value, 10) - 1,
                                // -1 to match 0 index
                                isMovedOutsideCurrentPage: b.value
                              }), p();
                            })
                          }, {
                            default: A(() => [
                              X(H(u(n)("Move")), 1)
                            ]),
                            _: 2
                          }, 1032, ["disabled"]),
                          L(re, {
                            mode: "outline",
                            color: "secondary",
                            onClick: p
                          }, {
                            default: A(() => [
                              X(H(u(n)("Cancel")), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ])) : E("", !0)
                  ];
                }),
                _: 2
              }, 1032, ["list", "item-key", "options"])
            ]),
            _: 2
          }, 1032, ["class"])) : E("", !0)
        ]),
        _: 1
      }, 512);
    };
  }
});
const vc = { class: "items-center flex" }, yc = /* @__PURE__ */ c("i", { class: "bi bi-gear-fill mr-2" }, null, -1), kc = { class: "mb-[.1rem]" }, wc = { class: "flex items-center" }, xc = { class: "mb-1 cursor-pointer" }, Sc = /* @__PURE__ */ _({
  __name: "CbTableColumnVisibility",
  props: {
    columns: {
      type: Array,
      required: !0
    }
  },
  emits: [
    "unselected-columns"
  ],
  setup(e, { emit: n }) {
    const t = n, { t: a } = te(), o = D([]);
    function s(d) {
      return o.value.includes(d);
    }
    function i(d, r) {
      s(r) ? o.value = o.value.filter((p) => p !== r) : o.value.push(r);
    }
    return K(o, () => {
      t("unselected-columns", o.value);
    }, { immediate: !0 }), (d, r) => (l(), P(We, { class: "ml-auto" }, {
      button: A(() => [
        L(re, {
          size: "sm",
          mode: "outline",
          color: "secondary",
          class: "mb-3",
          "data-testid": "ToggleColumnMenuButton"
        }, {
          default: A(() => [
            c("span", vc, [
              yc,
              c("span", kc, H(u(a)("Edit columns")), 1)
            ])
          ]),
          _: 1
        })
      ]),
      menu: A(() => [
        L(Kr, {
          items: e.columns.map((p) => ({ label: u(a)(p.label) }))
        }, {
          "item-label": A(({ label: p }) => [
            c("span", wc, [
              L(ye, {
                id: `checkbox_${p.toLowerCase()}`,
                "data-testid": `checkbox_${p.toLowerCase()}`,
                type: "checkbox",
                value: !s(p),
                disabled: o.value.length === e.columns.length - 1 && !s(p),
                onInput: (h) => i(!!h, p)
              }, {
                label: A(() => [
                  c("span", xc, H(p), 1)
                ]),
                _: 2
              }, 1032, ["id", "data-testid", "value", "disabled", "onInput"])
            ])
          ]),
          _: 1
        }, 8, ["items"])
      ]),
      _: 1
    }));
  }
}), $c = (e) => (De("data-v-efd3ee04"), e = e(), Ae(), e), Cc = { class: "relative flex flex-col min-w-0 break-words bg-clip-border" }, Dc = { class: "flex flex-wrap items-center" }, Ac = {
  key: 0,
  class: "mb-2 text-2xl md:text-xl font-bold text-secondary-500 dark:text-white font-display"
}, Tc = {
  key: 0,
  class: "cb-table-row"
}, Mc = {
  key: 0,
  class: "cb-tbody"
}, Ic = ["name", "onClick"], Lc = ["data-testid"], Fc = /* @__PURE__ */ $c(() => /* @__PURE__ */ c("i", { class: "bi bi-grip-vertical" }, null, -1)), Pc = [
  Fc
], Oc = ["data-testid"], Ec = { key: 0 }, _c = { key: 1 }, Nc = ["data-testid", "onClick"], zc = ["colspan"], Bc = { key: 1 }, Vc = {
  key: 3,
  class: "cb-table-row"
}, Hc = { class: "text-center cb-empty-msg col-sm-12" }, Rc = /* @__PURE__ */ _({
  __name: "CbTable",
  props: /* @__PURE__ */ St({
    tableId: {},
    responsiveBelowSize: {},
    isLoading: { type: Boolean },
    hasCheckbox: { type: Boolean },
    checkedReturnType: {},
    title: {},
    isFixedFirstColumn: { type: Boolean },
    columns: {},
    rows: {},
    rowClasses: { type: [Array, Function] },
    pageSize: {},
    page: {},
    pagination: {},
    sortable: {},
    isPaginationHidden: { type: Boolean },
    itemsToShow: {},
    localMode: { type: Boolean },
    maxHeight: {},
    fixedHeader: { type: Boolean },
    hasDetailRows: { type: Boolean },
    detailRowClass: { type: [String, Function] },
    trackingKey: {},
    allowDragDrop: { type: Boolean },
    allowColumnToggle: { type: Boolean }
  }, Ca),
  emits: $a,
  setup(e, { emit: n }) {
    const t = n, a = e, { t: o } = te(), s = D(), i = T(() => a.fixedHeader ? "sticky bg-white dark:bg-base-800" : "bg-transparent"), d = T(() => {
      if (a.trackingKey)
        return a.trackingKey;
      let C = "";
      if (a.columns.forEach((O) => {
        O.isKey && (C = O.field);
      }), !C && !a.trackingKey)
        throw Error(`Tracking key is not set for table ${a.tableId}: set a column field as isKey or use trackingKey prop`);
      return C;
    }), {
      offset: r,
      limit: p,
      maxPage: h,
      paginationObject: b
    } = wa(a), y = D(!0), { width: w } = Xt(), { isSmaller: v } = Rt();
    function f() {
      y.value = !v(a.responsiveBelowSize).value;
    }
    K(w, f), ne(f);
    const {
      checkItem: m,
      clearSelection: k,
      checkedItems: x,
      indeterminate: $,
      isAllChecked: F
    } = Mt({
      props: a,
      offset: r,
      keyField: d,
      emit: t
    });
    function S(C) {
      let O = ve.Asc;
      C === a.sortable.field && a.sortable.direction === ve.Asc && (O = ve.Desc), t("sort-column", { field: C, direction: O }), F.value ? F.value = !1 : a.hasCheckbox && k();
    }
    K(() => a.rows, () => {
      a.localMode && t("change-page", 1);
    });
    const {
      isVisibleDetailRow: R,
      toggleDetailRow: B,
      onDetailRowClick: U,
      onDetailRowClass: M
    } = va(t), {
      localRows: q,
      setFieldClassName: G,
      checkFormatter: V,
      rowClick: W
    } = ka(
      ce(a, "rows"),
      ce(a, "hasDetailRows"),
      ce(a, "sortable"),
      ce(a, "localMode"),
      p,
      r,
      B,
      t,
      ce(a, "allowDragDrop")
    ), j = D(), Q = D(Se());
    function ae(C) {
      j.value = C;
    }
    function ge(C, O) {
      const z = [...a.rows], se = z[C], Z = z.filter((et, Ta) => Ta !== C);
      return Z.splice(O, 0, se), Z;
    }
    const be = D([]);
    return (C, O) => (l(), g("div", Cc, [
      c("div", Dc, [
        C.title ? (l(), g("h3", Ac, H(C.title), 1)) : E("", !0),
        N(C.$slots, "tableActions", {}, void 0, !0),
        C.allowColumnToggle ? (l(), P(Sc, {
          key: 1,
          columns: C.columns,
          onUnselectedColumns: O[0] || (O[0] = (z) => be.value = z)
        }, null, 8, ["columns"])) : E("", !0)
      ]),
      c("div", null, [
        y.value ? (l(), g("div", Tc, [
          c("div", {
            class: I([
              "col-sm-12",
              {
                "fixed-first-column": C.isFixedFirstColumn,
                "fixed-first-second-column": C.isFixedFirstColumn && C.hasCheckbox
              }
            ])
          }, [
            c("table", {
              ref_key: "tableRef",
              ref: s,
              class: "cb-table cb-table-hover",
              style: le(`max-height: ${C.maxHeight}px;`)
            }, [
              L(xa, {
                "has-checkbox": C.hasCheckbox,
                "has-dragdrop": C.allowDragDrop,
                "is-fixed-header": i.value,
                "table-id": C.tableId,
                indeterminate: u($),
                columns: C.columns,
                sortable: C.sortable,
                "is-loading": C.isLoading,
                "is-all-checked": u(F),
                "hidden-columns": be.value,
                onSort: O[1] || (O[1] = (z) => S(z)),
                onAllChecked: O[2] || (O[2] = (z) => F.value = z)
              }, null, 8, ["has-checkbox", "has-dragdrop", "is-fixed-header", "table-id", "indeterminate", "columns", "sortable", "is-loading", "is-all-checked", "hidden-columns"]),
              C.isLoading ? (l(), g("tbody", Mc, [
                L(Sa, {
                  "page-size": C.pageSize,
                  "has-detail-rows": C.hasDetailRows,
                  "has-checkbox": C.hasCheckbox,
                  "table-id": C.tableId,
                  columns: C.columns
                }, null, 8, ["page-size", "has-detail-rows", "has-checkbox", "table-id", "columns"])
              ])) : u(q).length ? (l(), P(u(Wt), {
                key: Q.value,
                class: "cb-tbody",
                list: u(q),
                "item-key": C.trackingKey,
                tag: "tbody",
                options: {
                  sort: C.allowDragDrop,
                  handle: `.sortGrip_${C.tableId}_handle`,
                  animation: 150,
                  easing: "cubic-bezier(1, 0, 0, 1)",
                  group: {
                    name: `table_${C.tableId}`,
                    pull: "clone",
                    revertClone: !0
                  }
                },
                onChange: O[6] || (O[6] = (z) => t("drag-change")),
                onChoose: O[7] || (O[7] = (z) => t("drag-choose")),
                onUnchoose: O[8] || (O[8] = (z) => t("drag-unchoose")),
                onStart: O[9] || (O[9] = (z) => {
                  t("drag-start"), ae(!0);
                }),
                onEnd: O[10] || (O[10] = () => {
                  t("drag-end"), ae(!1);
                }),
                onAdd: O[11] || (O[11] = (z) => t("drag-add")),
                onUpdate: O[12] || (O[12] = (z) => t("drag-update")),
                onSort: O[13] || (O[13] = (z) => t("drag-sort")),
                onRemove: O[14] || (O[14] = (z) => t("drag-remove")),
                onFilter: O[15] || (O[15] = (z) => t("drag-filter")),
                onMove: O[16] || (O[16] = (z) => t("drag-move")),
                onMoveCapture: O[17] || (O[17] = (z) => t("drag-move-capture")),
                onClone: O[18] || (O[18] = (z) => t("drag-clone"))
              }, {
                item: A(({ element: z, index: se }) => [
                  c("tr", {
                    name: `cb-group-${se}`,
                    class: I([
                      "cb-tbody-tr bg-white dark:bg-base-900",
                      typeof C.rowClasses == "function" ? C.rowClasses(z) : C.rowClasses,
                      { "cursor-pointer": a.hasDetailRows }
                    ]),
                    onClick: (Z) => u(W)(z[d.value], se, z, Z)
                  }, [
                    C.allowDragDrop ? (l(), g("td", {
                      key: 0,
                      class: I(`cb-tbody-td sortGripHandle sortGrip_${C.tableId}_handle`),
                      width: "22",
                      "data-testid": `sortGrip_${se + 1}`,
                      onClick: O[3] || (O[3] = (Z) => Z.stopPropagation()),
                      onKeydown: () => {
                      }
                    }, Pc, 42, Lc)) : E("", !0),
                    C.hasCheckbox ? (l(), g("td", {
                      key: 1,
                      class: "cb-tbody-td",
                      "data-testid": `checkbox_${se + 1}`,
                      onClick: O[5] || (O[5] = (Z) => Z.stopPropagation()),
                      onKeydown: () => {
                      }
                    }, [
                      (l(), P(ye, {
                        id: `checkbox-check-${se}-${C.tableId}`,
                        key: `checkbox-${se}-${u(F)}`,
                        type: "checkbox",
                        disabled: C.isLoading,
                        value: z && z[d.value] ? u(x).includes(z[d.value]) : !1,
                        "aria-label": `checkbox-${se}`,
                        onInput: (Z) => u(m)(z, !!Z),
                        onClick: O[4] || (O[4] = (Z) => Z.stopPropagation())
                      }, null, 8, ["id", "disabled", "value", "aria-label", "onInput"]))
                    ], 40, Oc)) : E("", !0),
                    (l(!0), g(Y, null, J(C.columns, (Z, et) => (l(), g(Y, { key: et }, [
                      be.value.includes(Z.label) ? E("", !0) : (l(), g("td", {
                        key: 0,
                        class: I([
                          "cb-tbody-td",
                          u(G)(z, Z.columnClasses)
                        ]),
                        style: le(Z.columnStyles)
                      }, [
                        c("div", null, [
                          Z.isSlot && C.$slots[Z.field] ? (l(), g("div", Ec, [
                            N(C.$slots, Z.field, {
                              row: z,
                              rowIndex: se
                            }, void 0, !0)
                          ])) : (l(), g("span", _c, H(z && z[Z.field] ? u(V)(z, Z) : ""), 1))
                        ])
                      ], 6))
                    ], 64))), 128))
                  ], 10, Ic),
                  C.hasDetailRows ? (l(), g(Y, { key: 0 }, [
                    u(R)(z[d.value]) ? (l(), g("tr", {
                      key: 0,
                      "data-testid": `detail-row-${z[d.value]}`,
                      class: I(u(M)(z, se, a.detailRowClass)),
                      onClick: (Z) => u(U)(z[d.value], se, z, Z)
                    }, [
                      c("td", {
                        colspan: C.columns.length + (C.hasCheckbox ? 1 : 0) + (C.allowDragDrop ? 1 : 0)
                      }, [
                        N(C.$slots, "detailRow", {
                          row: z,
                          rowIndex: se
                        }, void 0, !0)
                      ], 8, zc)
                    ], 10, Nc)) : E("", !0)
                  ], 64)) : E("", !0)
                ]),
                _: 3
              }, 8, ["list", "item-key", "options"])) : E("", !0)
            ], 4)
          ], 2)
        ])) : (l(), g("div", Bc, [
          L(qu, {
            "table-id": C.tableId,
            "responsive-below-size": C.responsiveBelowSize,
            "is-loading": C.isLoading,
            "has-checkbox": C.hasCheckbox,
            "checked-return-type": C.checkedReturnType,
            title: C.title,
            "key-column": d.value,
            "has-detail-rows": C.hasDetailRows,
            rows: C.rows,
            offset: u(r),
            columns: C.columns,
            "row-classes": C.rowClasses,
            "page-size": C.pageSize,
            page: C.page,
            sortable: C.sortable,
            "items-to-show": C.itemsToShow,
            "max-height": C.maxHeight,
            "detail-row-class": C.detailRowClass,
            "tracking-key": C.trackingKey,
            "columns-selected-to-hide": be.value,
            onAllChecked: O[19] || (O[19] = (z) => F.value = z),
            onDetailRowClicked: O[20] || (O[20] = (z) => t("detail-row-clicked", z)),
            onCheckedRows: O[21] || (O[21] = (z) => t("checked-rows", z)),
            onChangePage: O[22] || (O[22] = (z) => t("change-page", z)),
            onSetVisibleRows: O[23] || (O[23] = (z) => t("set-visible-rows", z)),
            onSortColumn: O[24] || (O[24] = (z) => t("sort-column", z)),
            onRowClicked: O[25] || (O[25] = (z) => t("row-clicked", z)),
            onRowToggled: O[26] || (O[26] = (z) => t("row-toggled", z))
          }, {
            detailRow: A(({ row: z, rowIndex: se }) => [
              N(C.$slots, "detailRow", {
                row: z,
                rowIndex: se
              }, void 0, !0)
            ]),
            slotColumn: A(({ row: z, rowIndex: se, column: Z }) => [
              N(C.$slots, Z.field, {
                row: z,
                rowIndex: se
              }, void 0, !0)
            ]),
            _: 3
          }, 8, ["table-id", "responsive-below-size", "is-loading", "has-checkbox", "checked-return-type", "title", "key-column", "has-detail-rows", "rows", "offset", "columns", "row-classes", "page-size", "page", "sortable", "items-to-show", "max-height", "detail-row-class", "tracking-key", "columns-selected-to-hide"])
        ])),
        C.rows.length > 0 && !C.isLoading ? (l(), P(dc, {
          key: 2,
          id: C.tableId,
          class: I({ "mt-5": !y.value }),
          "page-size": C.pageSize,
          limit: u(p),
          offset: u(r),
          "last-page": u(h),
          page: u(b).page,
          "is-hidden": C.isPaginationHidden,
          "items-to-show": C.itemsToShow,
          onChangePage: O[27] || (O[27] = (z) => t("change-page", z)),
          onSetVisibleRows: O[28] || (O[28] = (z) => {
            t("set-visible-rows", z), t("change-page", 1);
          })
        }, null, 8, ["id", "class", "page-size", "limit", "offset", "last-page", "page", "is-hidden", "items-to-show"])) : C.isLoading ? E("", !0) : (l(), g("div", Vc, [
          N(C.$slots, "emptyContent", {}, () => [
            c("div", Hc, H(u(o)("No data")), 1)
          ], !0)
        ]))
      ]),
      L(bc, {
        "show-card": j.value,
        "table-id": C.tableId,
        "tracking-key": C.trackingKey,
        rows: u(q),
        limit: u(p),
        "page-size": C.pageSize,
        "current-table-page": u(b).page,
        "total-items": u(b).totalItems,
        onChangeRowOrder: O[29] || (O[29] = (z) => {
          Q.value = u(Se)(), C.$emit("change-row-order", {
            oldIndex: z.oldIndex,
            newIndex: z.newIndex,
            data: ge(z.oldIndex, z.newIndex),
            isMovedOutsideCurrentPage: z.isMovedOutsideCurrentPage
          });
        })
      }, null, 8, ["show-card", "table-id", "tracking-key", "rows", "limit", "page-size", "current-table-page", "total-items"])
    ]));
  }
});
const op = /* @__PURE__ */ ee(Rc, [["__scopeId", "data-v-efd3ee04"]]), Da = Symbol("tab-group-active-tab"), Aa = Symbol("tab-group-register"), qc = { class: "p-4" }, np = /* @__PURE__ */ _({
  __name: "CbTab",
  props: {
    value: {
      type: String,
      required: !0
    },
    title: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    const n = e, t = xe(Aa), a = xe(Da), o = T(() => (a == null ? void 0 : a.value) === n.value);
    return t == null || t.registerChild({
      value: n.value,
      title: n.title
    }), Ce(() => {
      t == null || t.unregisterChild(n.value);
    }), (s, i) => Jt((l(), g("div", qc, [
      N(s.$slots, "default")
    ], 512)), [
      [Gt, o.value]
    ]);
  }
}), Wc = /* @__PURE__ */ _({
  __name: "CbTabHeader",
  props: {
    value: {
      type: [String, Number],
      required: !0
    },
    modelValue: {
      type: String,
      required: !0
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, a = n, o = T(() => t.value === t.modelValue);
    function s() {
      a("update:modelValue", t.value);
    }
    return (i, d) => (l(), g("li", null, [
      c("button", {
        class: I([
          "font-semibold inline-block relative p-4 uppercase h-full",
          o.value ? "text-primary-500 dark:text-primary-200 after:w-full after:h-1 after:bg-primary-500 dark:after:bg-primary-200 after:absolute after:left-0 after:bottom-0" : "text-base-700 dark:text-base-500 hover:bg-secondary-100/50"
        ]),
        role: "tab",
        type: "button",
        onClick: s
      }, [
        N(i.$slots, "default")
      ], 2)
    ]));
  }
}), jc = { class: "border-b border-secondary-100" }, Yc = { "data-testid": "tabContainer" }, sp = /* @__PURE__ */ _({
  __name: "CbTabGroup",
  props: {
    defaultTab: {
      type: String,
      default: ""
    },
    classes: {
      type: Object,
      default: () => ({})
    }
  },
  emits: [
    "selected-tab"
  ],
  setup(e, { emit: n }) {
    const t = e, a = n, o = D(t.defaultTab), i = D([]);
    function d(p) {
      i.value.push(p), o.value === "" && (o.value = p.value);
    }
    function r(p) {
      i.value = i.value.filter(
        (h) => h.value !== p
      );
    }
    return we(Aa, { registerChild: d, unregisterChild: r }), we(Da, o), K(o, (p, h) => {
      h && a("selected-tab", o.value);
    }), (p, h) => (l(), g(Y, null, [
      c("div", jc, [
        c("ul", {
          class: I([
            "flex items-stretch -mb-px text-sm font-medium text-center",
            e.classes.listContainer
          ]),
          role: "tablist"
        }, [
          (l(!0), g(Y, null, J(i.value, (b) => (l(), P(Wc, {
            key: b.value,
            modelValue: o.value,
            "onUpdate:modelValue": h[0] || (h[0] = (y) => o.value = y),
            value: b.value
          }, {
            default: A(() => [
              X(H(b.title), 1)
            ]),
            _: 2
          }, 1032, ["modelValue", "value"]))), 128))
        ], 2)
      ]),
      c("div", Yc, [
        N(p.$slots, "default")
      ])
    ], 64));
  }
}), ip = /* @__PURE__ */ _({
  __name: "CbTimeAgo",
  props: {
    time: {
      type: [Date, String, Number],
      required: !0
    }
  },
  setup(e) {
    const n = e, { t } = te(), a = T(() => n.time), o = {
      justNow: t("Just Now"),
      past: (i) => i.match(/\d/) ? t("Time Ago Past", [i]) : i,
      future: (i) => i.match(/\d/) ? t("Time Ago Future", [i]) : i,
      month: (i, d) => i === 1 ? t(d ? "Last Month" : "Next Month") : `${i} ${t("Time Ago Month", i)}`,
      year: (i, d) => i === 1 ? t(d ? "Last Year" : "Next Year") : `${i} ${t("Time Ago Year", i)}`,
      day: (i, d) => i === 1 ? t(d ? "Yesterday" : "Tomorrow") : `${i} ${t("Time Ago Day", i)}`,
      week: (i, d) => i === 1 ? t(d ? "Last Week" : "Next Week") : `${i} ${t("Time Ago Week", i)}`,
      hour: (i) => `${i} ${t("Time Ago Hour", i)}`,
      minute: (i) => `${i} ${t("Time Ago Minute", i)}`,
      second: (i) => `${i} ${t("Time Ago Second", i)}`,
      invalid: ""
    }, s = lo(a, {
      messages: o,
      fullDateFormatter: (i) => i.toLocaleDateString()
    });
    return (i, d) => (l(), g("span", null, H(u(s)), 1));
  }
}), Kc = { class: "flex flex-col items-center justify-center space-y-1 p-3" }, Uc = {
  class: /* @__PURE__ */ I([
    "w-full"
    // { hidden: isDragOver },
  ])
}, Jc = { class: "flex flex-col items-center justify-center" }, Gc = ["innerHTML"], Qc = { class: "flex" }, Xc = ["innerHTML"], Zc = { class: "flex text-sm space-x-1 text-base-700 justify-center mt-1" }, em = { class: "uppercase" }, tm = /* @__PURE__ */ _({
  __name: "CbUploadEmptyContent",
  props: {
    fileMode: {
      type: String,
      default: "image",
      validator: (e) => ["image", "file"].includes(e)
    },
    fileTypes: {
      type: Array,
      default: () => []
    },
    maxFileSize: {
      type: Number,
      default: 1024
    },
    isDragOver: {
      type: Boolean
    }
  },
  emits: [
    "selectFile"
  ],
  setup(e, { emit: n }) {
    const t = e, a = n, { t: o } = te(), s = ue(() => import("./add_files-3ce51482.js")), i = T(() => `${o("Max file size")}: ${jt(t.maxFileSize)}.`), d = T(() => qa(t.fileTypes));
    function r() {
      a("selectFile");
    }
    const p = T(() => t.fileMode === "image" ? o("Drag and drop <span class='text-primary-300'>your image</span> here") : o("Drag and drop <span class='text-primary-300'>your file</span> here")), h = T(() => t.fileMode === "image" ? o("Or <span class='text-primary-300 underline cursor-pointer'>browse</span> images in your device") : o("Or <span class='text-primary-300 underline cursor-pointer'>browse</span> files in your device"));
    return (b, y) => (l(), g("div", Kc, [
      (l(), P(de(u(s)), {
        class: I([
          "w-[3.75rem] h-[25%] m-auto",
          { "scale-up-center": e.isDragOver }
        ]),
        alt: u(o)("Add file")
      }, null, 8, ["class", "alt"])),
      c("div", Uc, [
        c("div", Jc, [
          c("h3", {
            class: "text-base text-center font-display font-bold w-full",
            innerHTML: p.value
          }, null, 8, Gc),
          c("div", Qc, [
            c("p", {
              class: "font-bold text-base",
              "data-testid": "CbUploadEmptyContent-browseButton",
              onClick: r,
              onKeydown: fe(r, ["enter"]),
              innerHTML: h.value
            }, null, 40, Xc)
          ])
        ]),
        c("div", Zc, [
          c("span", em, H(d.value) + ".", 1),
          c("span", null, H(i.value), 1)
        ])
      ])
    ]));
  }
}), am = { class: "flex flex-col items-center justify-center w-full h-full" }, om = { class: "text-lg font-light capitalize mt-3.5 text-base-900 dark:text-white" }, nm = /* @__PURE__ */ _({
  __name: "CbUploadFilled",
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    fileMode: {
      type: String,
      default: "image",
      validator: (e) => ["image", "file"].includes(e)
    },
    fileName: {
      type: String,
      default: ""
    }
  },
  emits: [
    "deleteFile"
  ],
  setup(e) {
    const n = e, { t } = te(), a = T(() => n.modelValue.includes("://") ? `${n.modelValue}?t=${Date.now()}` : n.modelValue);
    return (o, s) => (l(), g("div", am, [
      e.fileMode === "image" ? (l(), P(u(Pe), {
        key: 0,
        src: a.value,
        alt: u(t)("Image preview"),
        "data-testid": "CbUploadFilledImage-image",
        class: "object-cover w-full h-full"
      }, null, 8, ["src", "alt"])) : (l(), g(Y, { key: 1 }, [
        L(u(Pe), {
          src: "../../assets/images/documents.svg",
          alt: "Document icon",
          class: "h-48"
        }),
        c("div", om, H(e.fileName), 1)
      ], 64))
    ]));
  }
}), sm = { class: "absolute top-0 right-0 mt-4 mr-4 flex space-x-2.5" }, im = /* @__PURE__ */ c("i", { class: "bi bi-trash3-fill px-1" }, null, -1), lm = {
  key: 4,
  class: "text-xs text-danger-500 mt-2.5 text-center",
  "data-testid": "CbUploadErrorMessages"
}, rm = ["for"], dm = ["name", "accept"], Vt = 75, um = 98, lp = /* @__PURE__ */ _({
  __name: "CbUpload",
  props: {
    name: {
      type: String,
      required: !0
    },
    modelValue: {
      type: String,
      default: ""
    },
    fileMode: {
      type: String,
      default: "image",
      validator: (e) => ["image", "file"].includes(e)
    },
    fileTypes: {
      type: Array,
      default: () => ["image/jpeg", "image/png"]
    },
    maxFileSize: {
      type: Number,
      default: 1024
    },
    validation: {
      type: String,
      default: void 0
    },
    requestStatus: {
      type: String,
      default: void 0
    }
  },
  emits: [
    "update:modelValue",
    "file-dropped",
    "file-deleted",
    "no-format-support",
    "file-size-exceeded",
    "base64-info"
  ],
  setup(e, { emit: n }) {
    var M;
    const t = e, a = n, { t: o } = te(), s = D((M = t.modelValue) != null && M.includes("://") ? `${t.modelValue}?t=${Date.now()}` : t.modelValue), i = D(!1), d = D(2e3), r = () => Math.floor(Math.random() * (um - Vt + 1)) + Vt, p = D(r());
    function h() {
      p.value = r(), d.value = 2e3, s.value = "";
    }
    function b() {
      p.value = 100, s.value = t.modelValue, d.value = 0, setTimeout(() => {
        i.value = !1, p.value = 0;
      }, 1500);
    }
    K(() => t.requestStatus, (q) => {
      q === "request" && (i.value = !0, h()), q === "success" && b(), q === "error" && setTimeout(() => {
        i.value = !1, p.value = 0;
      }, 800);
    });
    const y = D(""), w = T(() => {
      const q = {
        unsupported: o("Please, add a file with a supported format."),
        sizeLimit: `${o("File exceeds size limit")} (${jt(t.maxFileSize)}).`,
        filesLimit: o("Please upload only one file at a time."),
        unknownErr: o("Unknown error")
      };
      return q[y.value] || q.unknownErr;
    }), v = D(), f = D();
    function m() {
      f.value.click();
    }
    function k() {
      v.value = null, s.value = null, a("update:modelValue", null);
    }
    async function x(q) {
      if (y.value = "", !q) {
        k();
        return;
      }
      if (!t.fileTypes.includes(q.type)) {
        k(), a("no-format-support"), y.value = "unsupported";
        return;
      }
      if (q.size > t.maxFileSize * 1024) {
        k(), a("file-size-exceeded"), y.value = "sizeLimit";
        return;
      }
      const G = await Wa(q);
      s.value = G, v.value = q.name, a("base64-info", qt(s.value)), a("update:modelValue", G);
    }
    function $(q) {
      q != null && q.length ? x(q[0]) : k();
    }
    function F(q) {
      var V;
      if (q.preventDefault(), q.dataTransfer && q.dataTransfer.items.length > 1) {
        k(), y.value = "filesLimit";
        return;
      }
      const G = (V = q.dataTransfer) == null ? void 0 : V.items[0].getAsFile();
      x(G), a("file-dropped");
    }
    function S() {
      a("file-deleted"), k();
    }
    const R = D(), { isOverDropZone: B } = ro(R), U = T(() => {
      const q = s.value ? "border-solid" : "border-dashed";
      return B.value ? `${q} bg-secondary-50 border-secondary-700` : y.value ? `${q} bg-base-100 border-danger-300` : `${q} dark:bg-base-900 bg-white border-base-400`;
    });
    return K(() => t.modelValue, () => {
      t.modelValue && (s.value = t.modelValue);
    }), (q, G) => {
      const V = pe("FormKit");
      return l(), g("div", {
        ref_key: "dropZone",
        ref: R,
        "data-testid": "CbUpload",
        class: I([
          "flex flex-col items-center justify-center rounded-lg border relative overflow-hidden w-full",
          U.value
        ]),
        onDrop: F
      }, [
        i.value ? (l(), P(Qd, {
          key: 0,
          modelValue: p.value,
          "onUpdate:modelValue": G[0] || (G[0] = (W) => p.value = W),
          errored: e.requestStatus === "error",
          "transition-duration": d.value,
          mode: "request"
        }, null, 8, ["modelValue", "errored", "transition-duration"])) : E("", !0),
        s.value ? E("", !0) : N(q.$slots, "empty", {
          key: 1,
          fileMode: e.fileMode,
          fileTypes: e.fileTypes,
          maxFileSize: e.maxFileSize,
          handleSelectFile: m
        }, () => [
          L(tm, {
            "data-testid": "CbUploadEmptyContent",
            "file-mode": e.fileMode,
            "file-types": e.fileTypes,
            "max-file-size": e.maxFileSize,
            "is-drag-over": u(B),
            onSelectFile: m
          }, null, 8, ["file-mode", "file-types", "max-file-size", "is-drag-over"])
        ]),
        s.value ? N(q.$slots, "filled", {
          key: 2,
          fileName: v.value,
          fileMode: e.fileMode,
          selectedFile: s.value,
          handleDeleteFile: S
        }, () => [
          L(nm, {
            "data-testid": "CbUploadFilled",
            "file-name": v.value,
            "file-mode": e.fileMode,
            "model-value": s.value
          }, null, 8, ["file-name", "file-mode", "model-value"])
        ]) : E("", !0),
        s.value ? N(q.$slots, "actions", {
          key: 3,
          selectedFile: s.value,
          handleDeleteFile: S
        }, () => [
          c("div", sm, [
            N(q.$slots, "buttons", { selectedFile: s.value }),
            L(re, {
              "data-testid": "deleteButton",
              mode: "filled",
              color: "danger",
              size: "sm",
              square: "",
              onClick: ie(S, ["stop", "prevent"])
            }, {
              default: A(() => [
                im
              ]),
              _: 1
            })
          ])
        ]) : E("", !0),
        y.value ? (l(), g("div", lm, H(w.value), 1)) : E("", !0),
        L(V, {
          "model-value": e.modelValue,
          type: "text",
          classes: {
            outer: "hidden"
          },
          name: e.name,
          validation: e.validation
        }, null, 8, ["model-value", "name", "validation"]),
        c("label", {
          for: e.name,
          class: "hidden"
        }, null, 8, rm),
        c("input", {
          ref_key: "inputFile",
          ref: f,
          type: "file",
          name: e.name,
          accept: e.fileTypes.join(","),
          class: "hidden",
          "data-testid": "CbUploadInput",
          onChange: G[1] || (G[1] = (W) => $(W.target.files))
        }, null, 40, dm)
      ], 34);
    };
  }
}), cm = /* @__PURE__ */ c("span", {
  "data-testid": "toggleCalendar",
  class: "absolute top-[1.5rem] left-0 z-10 p-2 shadow-secondary-100 border-0 boder-l-0 cursor-pointer"
}, [
  /* @__PURE__ */ c("i", { class: "bi mr-2 ml-1 bi-calendar" })
], -1), mm = /* @__PURE__ */ c("i", { class: "bi bi-x-circle-fill px-2" }, null, -1), pm = [
  mm
], gm = /* @__PURE__ */ _({
  __name: "CbDateTextbox",
  props: {
    modelValue: {
      type: Date,
      default: null
    },
    minDate: {
      type: Date,
      default: null
    },
    maxDate: {
      type: Date,
      default: null
    },
    dateFormat: {
      type: String,
      default: "dd/MM/yyyy"
    },
    label: {
      type: String,
      default: ""
    }
  },
  emits: [
    "update:modelValue",
    "clear-selection"
  ],
  setup(e, { emit: n }) {
    const t = e, { t: a } = te(), o = T(() => t.label || a("Date")), s = D(t.modelValue ? Me(t.modelValue, t.dateFormat) : ""), i = n;
    K(() => t.modelValue, () => {
      s.value = t.modelValue ? Me(t.modelValue, t.dateFormat) : "";
    });
    const d = {
      y: a("Date Abbreviation Short Year"),
      M: a("Date Abbreviation Short Month"),
      d: a("Date Abbreviation Short Day")
    }, r = T(() => {
      let f = t.dateFormat;
      return Object.entries(d).forEach(([m, k]) => {
        f = f.replaceAll(m, k);
      }), f;
    });
    function p(f) {
      let m = "";
      const x = t.dateFormat.includes("-") ? "-" : "/";
      f.on("created", () => {
        f.context && (f.context.handlers.setValue = ($) => {
          const F = $.target, S = String($.target.value), R = S.replaceAll(x, "");
          if (!/^\d*$/.test(R)) {
            F.value = m;
            return;
          }
          if (S.length > t.dateFormat.length) {
            F.value = m;
            return;
          }
          m = S, f.input(m);
        });
      });
    }
    const h = Ga(
      {
        $el: "input",
        attrs: {
          type: "text",
          placeholder: r.value,
          onInput: "$handlers.setValue",
          value: "$_value"
        }
      },
      {
        features: [p],
        family: "text"
      }
    );
    function b(f) {
      let m = !0;
      return t.minDate && (m = m && (He(f, t.minDate) || me(f, t.minDate))), t.maxDate && (m = m && (Dt(f, t.maxDate) || me(f, t.maxDate))), m;
    }
    function y(f) {
      if (!t.minDate && !t.maxDate)
        return !0;
      const m = f.value;
      if (m.length === t.dateFormat.length) {
        const k = ot(m, t.dateFormat, /* @__PURE__ */ new Date());
        return b(k);
      }
      return !0;
    }
    function w(f) {
      const m = f.value;
      if (m.length === t.dateFormat.length) {
        const k = ot(m, t.dateFormat, /* @__PURE__ */ new Date());
        return Ot(k);
      }
      return !0;
    }
    function v(f) {
      if (f.length === 0 && i("clear-selection"), f.length !== t.dateFormat.length)
        return;
      const m = ot(f, t.dateFormat, /* @__PURE__ */ new Date());
      i("update:modelValue", Ot(m) && b(m) ? m : null);
    }
    return (f, m) => {
      const k = pe("FormKit");
      return l(), P(k, {
        type: u(h),
        label: o.value,
        "data-testid": "dateInput",
        "validation-visibility": "live",
        "validation-rules": { dateValidation: w, rangeValidation: y },
        validation: "dateValidation|rangeValidation",
        "validation-messages": {
          dateValidation: u(a)("The specified date is not valid"),
          rangeValidation: u(a)("The specified date is outside the allowed range")
        },
        classes: {
          outer: "relative",
          input: "pl-10"
        },
        "model-value": s.value,
        onInput: m[1] || (m[1] = (x) => v(x))
      }, {
        prefix: A(() => [
          cm
        ]),
        suffix: A(() => [
          s.value ? (l(), g("button", {
            key: 0,
            class: "absolute right-1",
            type: "button",
            "data-testid": "clearInput",
            onClick: m[0] || (m[0] = (x) => i("clear-selection"))
          }, pm)) : E("", !0)
        ]),
        _: 1
      }, 8, ["type", "label", "validation-rules", "validation-messages", "model-value"]);
    };
  }
}), rp = /* @__PURE__ */ _({
  __name: "CbDateInput",
  props: {
    modelValue: {
      type: Date,
      default: null
    },
    minDate: {
      type: Date,
      default: null
    },
    maxDate: {
      type: Date,
      default: null
    },
    dateFormat: {
      type: String,
      default: "dd/MM/yyyy"
    },
    label: {
      type: String,
      default: ""
    }
  },
  emits: [
    "update:modelValue"
  ],
  setup(e, { emit: n }) {
    const t = n;
    function a(o) {
      t("update:modelValue", o);
    }
    return (o, s) => (l(), P(ht, {
      "initial-value": e.modelValue,
      "min-date": e.minDate,
      "max-date": e.maxDate,
      onSelected: a
    }, {
      default: A(() => [
        L(gm, {
          "model-value": e.modelValue,
          "min-date": e.minDate,
          "max-date": e.maxDate,
          "date-format": e.dateFormat,
          label: e.label,
          "onUpdate:modelValue": a,
          onClearSelection: s[0] || (s[0] = (i) => t("update:modelValue", null))
        }, null, 8, ["model-value", "min-date", "max-date", "date-format", "label"])
      ]),
      _: 1
    }, 8, ["initial-value", "min-date", "max-date"]));
  }
}), dp = /* @__PURE__ */ _({
  __name: "CbPassword",
  setup(e) {
    const n = D(!1);
    function t(a) {
      n.value = a.props.type === "password";
    }
    return (a, o) => {
      const s = pe("FormKit");
      return l(), P(s, he(a.$attrs, {
        type: n.value ? "text" : "password",
        onSuffixIconClick: t
      }), {
        suffixIcon: A(() => [
          c("span", {
            "data-testid": "togglePasswordIcon",
            class: "relative left-[1px] p-2 transition-all duration-200 shadow-px shadow-secondary-100 border-0 cursor-pointer",
            onClick: o[0] || (o[0] = (i) => n.value = !n.value),
            onKeyup: () => {
            }
          }, [
            c("span", {
              class: I([
                "bi px-1",
                n.value ? "bi-eye-slash" : "bi-eye"
              ])
            }, null, 2)
          ], 32)
        ]),
        _: 1
      }, 16, ["type"]);
    };
  }
}), fm = { class: "flex w-full" }, up = /* @__PURE__ */ _({
  __name: "CbPhone",
  props: {
    defaultCountry: {
      type: String,
      default: "ES"
    },
    modelValue: {
      type: Object,
      default: void 0
    },
    hidePrefixUntilBackendSupport: {
      type: Boolean
    },
    validation: {
      type: String,
      default: ""
    },
    validationVisibility: {
      type: String,
      default: "blur"
    }
  },
  emits: [
    "update:modelValue"
  ],
  setup(e, { emit: n }) {
    var B, U;
    const t = n, a = e, { t: o } = te(), s = D([]), i = D(), d = () => import("./libs/config-countries-df62edb9.js").then((M) => M.i).then((M) => {
      i.value = M.default;
    });
    ne(() => {
      a.hidePrefixUntilBackendSupport || d();
    });
    function r(M) {
      var G, V;
      if (!i.value)
        return "";
      const q = (V = (G = i.value) == null ? void 0 : G.find((W) => W["alpha-2"] === M)) == null ? void 0 : V.name;
      return q ? o(q) : "";
    }
    function p(M) {
      var q, G;
      return (G = (q = i.value) == null ? void 0 : q.find((V) => V.name === M)) == null ? void 0 : G["alpha-2"];
    }
    const h = D(((B = a.modelValue) == null ? void 0 : B.code) || ""), b = D(a.defaultCountry), y = D(((U = a.modelValue) == null ? void 0 : U.number) || "");
    function w(M) {
      return new wo(b.value).input(M);
    }
    function v(M) {
      return M.value && b.value ? xo(M.value, b.value) : !0;
    }
    function f() {
      t("update:modelValue", {
        code: h.value,
        number: y.value
      });
    }
    $t(
      y,
      () => {
        y.value = w(y.value), f();
      },
      { debounce: 50, maxWait: 1e3 }
    );
    const m = Se(), k = T(() => vo().map((M) => ({
      value: `+${yo(M)}`,
      label: r(M)
    })).filter((M) => M.label));
    function x(M) {
      b.value = p(M.label), s.value = [], y.value && (y.value = w(y.value));
    }
    const $ = D();
    import("./vendor/libphonenumberjs-dba064a0.js").then((M) => M.e).then((M) => {
      $.value = M.default;
    });
    const F = T(() => {
      if ($.value) {
        const M = ko(b.value, $.value);
        if (M)
          return {
            prefix: `+${M.countryCallingCode}`,
            number: w(M.nationalNumber)
          };
      }
      return {
        prefix: "",
        number: ""
      };
    }), S = T(() => {
      const M = ["checkSetPhoneNumber"];
      return a.validation ? [a.validation, ...M].join("|") : M.join("|");
    });
    function R(M) {
      if (h.value)
        s.value = [];
      else {
        const q = document.getElementById(m);
        q && (M.preventDefault(), setTimeout(() => {
          s.value = [o("Select country phone code")], q.focus();
        }, 150));
      }
    }
    return (M, q) => {
      const G = pe("FormKit");
      return l(), P(G, {
        type: "group",
        config: { validationVisibility: "blur" }
      }, {
        default: A(() => [
          c("div", fm, [
            !e.hidePrefixUntilBackendSupport && i.value ? (l(), P(Re, {
              key: 0,
              id: u(m),
              modelValue: h.value,
              "onUpdate:modelValue": q[0] || (q[0] = (V) => h.value = V),
              options: k.value,
              placeholder: F.value.prefix,
              label: u(o)("Phone"),
              "menu-width": "22rem",
              "menu-max-height": "14rem",
              "show-default-menu-suffix": "",
              "option-type-label": "value",
              searchable: "",
              "search-placeholder": u(o)("Search country name or code"),
              errors: s.value,
              class: "max-w-[6rem]",
              role: "presentation",
              "data-testid": "phoneInputPrefix",
              autocomplete: "off",
              readonly: "",
              onSelectedRaw: q[1] || (q[1] = (V) => x(V[0]))
            }, {
              optionPrefix: A(({ item: V }) => [
                p(V.label) ? (l(), P(Hr, {
                  key: 0,
                  country: p(V.label),
                  class: "mr-1 w-[2rem]!"
                }, null, 8, ["country"])) : E("", !0)
              ]),
              _: 1
            }, 8, ["id", "modelValue", "options", "placeholder", "label", "search-placeholder", "errors"])) : E("", !0),
            L(G, {
              modelValue: y.value,
              "onUpdate:modelValue": q[2] || (q[2] = (V) => y.value = V),
              value: `${w(y.value)}`,
              "data-testid": "phoneNumber",
              type: "search",
              placeholder: F.value.number,
              label: e.hidePrefixUntilBackendSupport ? u(o)("Phone") : " ",
              classes: {
                outer: "w-full"
              },
              "validation-rules": { checkSetPhoneNumber: v },
              validation: S.value,
              "validation-visibility": e.validationVisibility,
              "validation-messages": {
                checkSetPhoneNumber: u(o)("The phone number you entered is invalid")
              },
              onMousedown: R
            }, null, 8, ["modelValue", "value", "placeholder", "label", "validation-rules", "validation", "validation-visibility", "validation-messages"])
          ])
        ]),
        _: 1
      });
    };
  }
}), cp = /* @__PURE__ */ _({
  __name: "CbRadioInput",
  props: /* @__PURE__ */ Fe({
    id: {
      type: String,
      required: !0
    },
    label: {
      type: String,
      default: ""
    },
    options: {
      type: [Array, Object],
      required: !0
    },
    disabled: {
      type: Boolean
    },
    loading: {
      type: Boolean
    },
    help: {
      type: String,
      default: ""
    }
  }, {
    modelValue: {
      type: [String, Number],
      default: void 0
    },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Fe(["change"], ["update:modelValue"]),
  setup(e, { emit: n }) {
    const t = vt(e, "modelValue"), a = n, o = e;
    K(t, (r) => {
      a("change", r);
    });
    const s = yt(), i = T(() => o.loading || o.disabled), d = T(() => o.loading ? Object.fromEntries(Object.entries(s).filter(([r]) => r !== "decorator")) : s);
    return (r, p) => {
      const h = pe("FormKit");
      return l(), P(h, he({ id: e.id }, r.$attrs, {
        modelValue: t.value,
        "onUpdate:modelValue": p[0] || (p[0] = (b) => t.value = b),
        type: "radio",
        label: e.label,
        options: e.options,
        help: e.help,
        disabled: i.value,
        classes: {
          option: "mt-4 gap-y-2 flex flex-col",
          inner: "flex"
        }
      }), Oe({ _: 2 }, [
        e.loading ? {
          name: "decorator",
          fn: A(() => [
            L(qe, { class: "text-primary-500 mr-2" })
          ]),
          key: "0"
        } : void 0,
        J(d.value, (b, y) => ({
          name: y,
          fn: A((w) => [
            N(r.$slots, y, kt(wt(w)))
          ])
        }))
      ]), 1040, ["id", "modelValue", "label", "options", "help", "disabled"]);
    };
  }
});
var hm = /* @__PURE__ */ ((e) => (e.BarChart = "bar", e.LineChart = "line", e.PieChart = "pie", e.DoughnutChart = "doughnut", e))(hm || {}), bm = /* @__PURE__ */ ((e) => (e.Spinner = "spinner", e.Logo = "logo", e))(bm || {});
function mp(e, n) {
  const t = D("");
  return K(
    [
      () => e.pagination.page,
      () => e.filters.limit,
      () => e.filters.sortable
    ],
    ([
      a,
      o,
      s
    ], [
      i,
      d,
      r
    ]) => {
      const p = {
        page: a !== i,
        limit: o !== d,
        sortable: e.filters.sortable ? JSON.stringify(s) !== JSON.stringify(r) : !1
      };
      n ? t.value = p[n] ? n : "" : (p.page && (t.value = `page_${a}`), p.limit && (t.value = `limit_${o}`), p.limit && (t.value = `sortable_${Math.random()}`));
    }
  ), {
    changed: t
  };
}
var vm = /* @__PURE__ */ ((e) => (e.Hover = "hover", e.Click = "click", e.Manual = "manual", e))(vm || {}), ym = /* @__PURE__ */ ((e) => (e.Top = "top", e.Left = "left", e.Right = "right", e.Bottom = "bottom", e.TopLeft = "top-left", e.TopRight = "top-right", e.BottomLeft = "bottom-left", e.BottomRight = "bottom-right", e))(ym || {}), km = /* @__PURE__ */ ((e) => (e.Small = "small", e.Medium = "medium", e))(km || {}), wm = /* @__PURE__ */ ((e) => (e.Default = "default", e.Highlight = "highlight", e))(wm || {});
export {
  Xm as $,
  Rm as A,
  Tr as B,
  re as C,
  Ir as D,
  Lr as E,
  Mr as F,
  qm as G,
  Hr as H,
  tl as I,
  Wm as J,
  jm as K,
  Ym as L,
  Kr as M,
  Yr as N,
  Xr as O,
  id as P,
  Km as Q,
  fa as R,
  dd as S,
  qe as T,
  Yi as U,
  Um as V,
  Jm as W,
  Gm as X,
  Qm as Y,
  Qd as Z,
  We as _,
  Te as a,
  $a as a$,
  Zm as a0,
  ep as a1,
  tp as a2,
  $l as a3,
  zt as a4,
  Nt as a5,
  ap as a6,
  op as a7,
  Sc as a8,
  bc as a9,
  sa as aA,
  da as aB,
  Tt as aC,
  Bl as aD,
  ua as aE,
  ca as aF,
  Fl as aG,
  Pl as aH,
  Ol as aI,
  El as aJ,
  _l as aK,
  Le as aL,
  Nl as aM,
  zl as aN,
  ct as aO,
  hm as aP,
  ld as aQ,
  bm as aR,
  ha as aS,
  Zt as aT,
  _u as aU,
  va as aV,
  wa as aW,
  ka as aX,
  mp as aY,
  ve as aZ,
  ya as a_,
  xa as aa,
  Sa as ab,
  qu as ac,
  dc as ad,
  np as ae,
  sp as af,
  Wc as ag,
  ip as ah,
  ga as ai,
  tm as aj,
  nm as ak,
  ye as al,
  rp as am,
  gm as an,
  dp as ao,
  up as ap,
  cp as aq,
  Re as ar,
  Md as as,
  ia as at,
  la as au,
  ra as av,
  ft as aw,
  Ji as ax,
  oa as ay,
  na as az,
  ta as b,
  Ca as b0,
  Cu as b1,
  Da as b2,
  Aa as b3,
  vm as b4,
  ym as b5,
  km as b6,
  wm as b7,
  Ue as b8,
  Mt as b9,
  ea as c,
  aa as d,
  lp as e,
  ru as f,
  lu as g,
  Em as h,
  ll as i,
  Ui as j,
  _m as k,
  Nm as l,
  hl as m,
  zm as n,
  Bm as o,
  At as p,
  Vm as q,
  ut as r,
  Hl as s,
  Xl as t,
  te as u,
  dr as v,
  kr as w,
  $r as x,
  ht as y,
  Hm as z
};
//# sourceMappingURL=main-faa4dca4.js.map
